<script>
import {
  SearchIcon,
  // InfoIcon,
  // MoreVerticalIcon
} from "@zhuowenli/vue-feather-icons";

import { ref, watch, inject } from "vue";

import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import calendar from "dayjs/plugin/calendar";
import 'dayjs/locale/id'

import Layout from "../../layouts/main.vue";
import appConfig from "../../../app.config";
// import SocketMixin from '../../mixins/SocketMixins';
// import DebounceMixin from '../../mixins/DebounceMixins';
import axios from "axios";
import Swal from "sweetalert2";

import DropZone from "@/components/widgets/dropZone";
// import { file } from '@babel/types';

import EmojiPicker from "vue3-emoji-picker";
import "vue3-emoji-picker/dist/style.css";

import FsLightbox from 'fslightbox-vue/v3';

// dayjs.locale('id')
// dayjs().locale('de').format()
dayjs.extend(relativeTime);
dayjs.extend(calendar);

export default {
  // mixins: [SocketMixin],
  setup() {
    let files = ref([]);
    let dropzoneFile = ref("");
    let imagesPreview = ref("");
    let debounceTimeout;
    let listUser = ref([]);
    const syncContact = inject("sync_contact")

    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    });

    const drop = async (e) => {
      dropzoneFile.value = e.dataTransfer.files[0];
      files.value[0] = dropzoneFile.value;
      const f = files.value[files.value.length - 1];
      if (f && f.type && f.type.startsWith('video/')) {
        try {
          imagesPreview.value = await generateVideoThumbnailFromFile(f);
        } catch (err) {
          console.warn('video thumbnail generation failed', err);
          imagesPreview.value = await toBase64(f);
        }
      } else {
        imagesPreview.value = await toBase64(f);
      }
    };
    const selectedFile = async () => {
      dropzoneFile.value = document.querySelector(".dropzoneFile").files[0];
      files.value[0] = dropzoneFile.value;
      const f = files.value[files.value.length - 1];
      if (f && f.type && f.type.startsWith('video/')) {
        try {
          imagesPreview.value = await generateVideoThumbnailFromFile(f);
        } catch (err) {
          console.warn('video thumbnail generation failed', err);
          imagesPreview.value = await toBase64(f);
        }
      } else {
        imagesPreview.value = await toBase64(f);
      }
    };
    const toBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (err) => reject(err);
      });
    
    const generateVideoThumbnailFromFile = (file, seekTo = 0.5) => {
      return new Promise((resolve, reject) => {
        try {
          const url = URL.createObjectURL(file);
          const video = document.createElement('video');
          video.preload = 'metadata';
          video.src = url;
          video.muted = true;

          const cleanup = () => {
            try { URL.revokeObjectURL(url); } catch (err) { void err; }
            try { video.src = ''; video.load(); } catch (err) { void err; }
          };

          video.addEventListener('loadedmetadata', () => {
            if (video.duration < seekTo) seekTo = 0;
            try { video.currentTime = seekTo; } catch (err) { console.debug && console.debug('video seek not allowed', err); }
          });

          video.addEventListener('seeked', () => {
            try {
              const canvas = document.createElement('canvas');
              const ratio = video.videoWidth && video.videoHeight ? (video.videoWidth / video.videoHeight) : 16/9;
              const maxWidth = 480;
              canvas.width = Math.min(video.videoWidth || maxWidth, maxWidth);
              canvas.height = Math.round(canvas.width / ratio);
              const ctx = canvas.getContext('2d');
              ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
              const dataUrl = canvas.toDataURL('image/jpeg', 0.75);
              cleanup();
              resolve(dataUrl);
            } catch (err) {
              cleanup();
              reject(err);
            }
          });

          video.addEventListener('error', () => {
            cleanup();
            reject(new Error('Video load error'));
          });
        } catch (err) {
          reject(err);
        }
      });
    };
    const checkStringOfLink = (text) => {
      var pattern = new RegExp(
        "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
        "i"
      ); // fragment locator
      return !!pattern.test(text);
    };
    watch(
      () => [...files.value],
      (currentValue) => {
        return currentValue;
      }
    );

    return {
      dropzoneFile,
      files,
      drop,
      selectedFile,
      imagesPreview,
      Toast,
      v$: useVuelidate(),
      checkStringOfLink,
      debounceTimeout,
      listUser,
      syncContact
    };
  },
  page: {
    title: "Chat",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      toggler: false,
      sourcesImages: "",
      whatsappStatus: false,
      chatData: [],
      chatMessagesData: [],
      agentData: [],
      searchAgentInput: "",
      title: "Chat",
      valueSearch: "",
      items: [
        {
          text: "Velzon",
          href: "/",
        },
        {
          text: "Chat",
          active: true,
        },
      ],
      submitted: false,
      form: {
        message: "",
      },
      username: "Steven Franklin",
      profile: require("@/assets/images/users/user-dummy-img.jpg"),
      userNotFound: require("@/assets/images/error500.png"),
      phoneNumber: null, // 🔥 FIX: Use null instead of 0 to prevent false comparison
      userid: null, // 🔥 FIX: Use null instead of 0
      user: null,
      userStatus: null,
      imageModal: "",
      captionModal: "",
      showFormUpload: false,
      isSending: false,
      // Video modal state
      showVideoModal: false,
      videoModalUrl: '',
      videoFileName: 'video.mp4',
      videoBlobUrl: null,
      currentImages: undefined,
      previewImages: undefined,
      messagesReply: false,
      isMediaReply: false,
      isSticker: false,
      nameReply: "",
      pesanReply: "",
      pesanId: "",
      tagvalue: null,
      tagoption: [],
      lastEdit: null,
      create: null,
      agentHandle: [],
      assignedAgent: null,
      socket: null,
      newMessage: false,
      note: null,
      tagValue: [],
      agentChatName: null,
      agentChatRole: null,
      searchChatInput: "",
      shimmerOn: false,
      fetchChatRoom: true,
      // For loadmore
      finished: false,
      page: 1,
      pageSize: 25,
      itemsInPages: 10,
      pages: [],
      styleObject: [],
      downloadImage: [],
      openModal: false,
      resultSearchMessage: [],
      db: inject("db"),
      selectedMessage: null,
      canDeleteForEveryone: true,
      deleteTimeLimit: 48 * 60 * 60 * 1000,
      loadingConversation: false,
      showSearch: false,
      searchQuery: '',
      routeLookupLoading: false,
      // Global search
      globalSearchResults: [],
      globalSearchLoading: false,
      globalSearchPage: 1,
      globalSearchMeta: null,
      // Categorized search results
      searchChats: [],
      searchContacts: [],
      searchMessages: [],
      // Backup chatData saat search
      chatDataBackup: [],
      isSearchMode: false,
      // Load more control
      isLoadingMore: false,
      loadMoreRetryCount: 0,
      // Load more for contacts
      isLoadingContacts: false,
      finishedContacts: false,
      // Phone filter for chat rooms
      phonesFilter: [], // Array of phone numbers to filter chat rooms
      // ✅ [ADDED] Debugging tools
      debugMode: false,
      socketLogs: [],
      showDebugPanel: false,
    };
  },
  components: {
    Layout,
    SearchIcon,
    DropZone,
    Multiselect,
    EmojiPicker,
    FsLightbox
    // InfoIcon,
    // MoreVerticalIcon
  },
  validations: {
    form: {
      message: {
        required: helpers.withMessage("Message is required", required),
      },
    },
  },
  // mounted() {
  //   console.log('🏗️ [LIFECYCLE] chat.vue mounted | ID:', this.userid);
  // },
  beforeUnmount() {
    console.log('🏚️ [LIFECYCLE] chat.vue unmounting | ID:', this.userid);
  },
  methods: {
    /**
     * Sinkronisasi data customer dari SS API ke chatData Vue reactive.
     * Dipanggil oleh SocketMixins.js refreshContact() setelah fetch SS getCustomerByPhone.
     * Ini adalah bridge antara SocketMixins IndexedDB dan chatData UI.
     */
    syncContactToChatData(customerData) {
      if (!customerData || (!customerData.Phone && !customerData.phone)) return;

      const phone = String(customerData.Phone || customerData.phone || '').replace(/\D/g, '');
      if (!phone) return;

      const idx = this.chatData.findIndex(el =>
        String(el.telp || '').replace(/\D/g, '') === phone
      );

      if (idx !== -1) {
        // Update status dari SS API
        if (customerData.Status) {
          this.chatData[idx].status = customerData.Status;
        }
        // Update name dari SS jika lebih baik
        if (customerData.Name && customerData.Name !== phone) {
          this.chatData[idx].name = customerData.Name;
        }
        // Update avatar dari SS jika tersedia
        if (customerData.Avatar?.Original) {
          this.chatData[idx].image = customerData.Avatar.Original;
        }
        console.log(`[✅ syncContactToChatData] Synced ${phone}: status=${customerData.Status}, name=${customerData.Name}`);
      } else {
        // 🔥 ADD NEW CONTACT TO LIST
        const currentStatus = (this.currentStatusFilter || 'all').toLowerCase();
        const customerStatus = (customerData.Status || 'unassigned').toLowerCase();
        
        // Hanya tambahkan jika filter 'all' atau status cocok
        if (currentStatus === 'all' || currentStatus === customerStatus) {
          console.log(`[🆕 syncContactToChatData] Menambahkan kontak baru ${phone} ke sidebar`);
          
          this.chatData.unshift({
            id: customerData.ID || customerData.id || 0,
            image: customerData.Avatar?.Original || customerData.image || this.profile,
            name: customerData.Name || customerData.name || phone,
            telp: parseInt(phone),
            message: customerData.message || "New Customer Arrival",
            hasMedia: customerData.hasMedia || false,
            ack: customerData.ack || 0,
            Tags: Array.isArray(customerData.Tags) ? customerData.Tags.map(t => t.Title).join(",") : (customerData.Tags || ""),
            timestamp: customerData.timestamp || customerData.TimestampLastChat || Math.floor(Date.now() / 1000),
            unread_count: customerData.unread_count || 0,
            fromMe: customerData.fromMe || false,
            status: customerStatus,
            firstTimeChat: customerData.CreatedTime || Math.floor(Date.now() / 1000),
            shimmer: false,
            type: customerData.type || "chat"
          });
          
          this.sortChatRooms();
        } else {
          console.log(`[ℹ️ syncContactToChatData] Kontak ${phone} (status: ${customerStatus}) tidak ditambahkan karena filter saat ini: ${currentStatus}`);
        }
      }
    },

    getInitials(name) {
      if (!name) return '?';
      
      const words = name.trim().split(' ');
      if (words.length === 1) {
        return words[0].substring(0, 2).toUpperCase();
      }
      
      return (words[0][0] + words[words.length - 1][0]).toUpperCase();
    },
    
    // Handle error saat load gambar
    handleImageError(event, data) {
      // Ganti dengan avatar inisial
      event.target.style.display = 'none';
      data.image = null; // Force re-render dengan inisial
    },
    
    // Get ACK icon class
    getAckIconClass(ack, fromMe) {
      if (!fromMe) return '';
      
      const iconMap = {
        0: 'ri-time-line text-muted',
        1: 'ri-check-line',
        2: 'ri-check-double-line',
        3: 'ri-check-double-line text-info',
        4: 'ri-check-double-line text-info'
      };
      
      return iconMap[ack] || '';
    },
    
    // Get media icon
    getMediaIcon(type) {
      const iconMap = {
        'image': 'ri-image-line',
        'video': 'ri-live-line',
        'sticker': 'ri-sticky-note-fill',
        'audio': 'ri-volume-up-line',
        'document': 'ri-file-text-line'
      };
      
      return iconMap[type] || 'ri-file-line';
    },
    
    // Get status badge class
    getStatusBadgeClass(status) {
      const classMap = {
        'assigned': 'badge-soft-primary',
        'unassigned': 'badge-soft-warning',
        'resolved': 'badge-soft-success',
        'served by bot': 'badge-soft-info',
        'search-result': 'badge-soft-secondary'
      };
      
      return classMap[status] || 'badge-soft-secondary';
    },
    selectEmoji(emoji) {
      this.form.message += emoji.i;
    },
    highlightKeyword(text, keyword) {
      if (!text || !keyword) return text;
      
      // Escape special regex characters
      const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(`(${escapedKeyword})`, 'gi');
      
      return text.replace(regex, '<mark class="search-highlight">$1</mark>');
    },
    debugSocketData(label, rawData) {
      try {
        // If it's a long string, print truncated preview to avoid console flooding
        if (typeof rawData === 'string') {
          if (rawData.length > 2000) {
            console.log(`[SOCKET DEBUG] ${label} (string, len=${rawData.length}) =>`, rawData.slice(0,2000) + '... (truncated)');
          } else {
            console.log(`[SOCKET DEBUG] ${label} (string) =>`, rawData);
          }
          return;
        }

        // For objects, create a JSON-safe summary replacing large binary fields
        const replacer = (key, val) => {
          if (!val) return val;
          // Typed arrays / buffers
          if (val instanceof ArrayBuffer) return { type: 'ArrayBuffer', byteLength: val.byteLength };
          if (val && val.buffer && val.buffer instanceof ArrayBuffer) return { type: 'TypedArray', constructor: val.constructor.name, length: val.length };
          // Large arrays (e.g. binary chunks)
          if (Array.isArray(val) && val.length > 50) return `[Array length=${val.length}]`;
          // If object contains a large 'data' field, summarize it
          if (val && typeof val === 'object' && ('data' in val) && (typeof val.data === 'string' || Array.isArray(val.data))) {
            const size = typeof val.data === 'string' ? val.data.length : val.data.length;
            return { ...val, data: `[${typeof val.data} length=${size}]` };
          }
          return val;
        };

        try {
          console.log(`[SOCKET DEBUG] ${label} (object) =>`, JSON.parse(JSON.stringify(rawData, replacer)));
        } catch (e) {
          console.log(`[SOCKET DEBUG] ${label} (object, stringify failed) =>`, rawData);
        }
      } catch (e) {
        console.log('[SOCKET DEBUG] inspect failed', e, rawData);
      }
    },
    avatarUrl(agent) {
      if (!agent) return this.profile;
      if (agent.avatar) return agent.avatar;
      if (agent.Avatar && agent.Avatar.Original) return agent.Avatar.Original;
      if (agent.Avatar && typeof agent.Avatar === 'string') return agent.Avatar;
      return this.profile;
    },
    async getUserDetil() {
      this.agentHandle = [];
      var secure =
        "ClientID=" +
        process.env.VUE_APP_CLIENT_ID +
        "&AccessToken=" +
        localStorage.getItem("jwt");
      var param = "?ID=" + this.userid + "&" + secure;
      const userDetil = await axios.get(
        process.env.VUE_APP_URL_API + "customer-api/getCustomerByID" + param
      );

      this.note = userDetil.data.Data.Note;

      this.create = userDetil.data.Data.Created;
      this.lastEdit = userDetil.data.Data.LastEdited;

      if (userDetil.data.Data.AgentAssigned !== null) {
        userDetil.data.Data.AgentAssigned.forEach((agents) => {
          this.agentHandle.push({
            ID: agents.ID,
            Name: agents.Name,
            avatar: agents.Avatar ? agents.Avatar.Original : require("@/assets/images/users/avatar-2.jpg"),
            Avatar: agents.Avatar ? agents.Avatar : null,
          });
        });
        // set currently assigned agent from server data
        if (this.agentHandle.length > 0) this.assignedAgent = this.agentHandle[0];
      }

      this.tagoption = [];
      this.tagValue = [];
      const tags = await axios.get(
        process.env.VUE_APP_URL_API + "customer-api/getAllTags?" + secure
      );
      tags.data.Data.forEach((items) => {
        this.tagoption.push({
          value: items.ID,
          label: items.Title,
        });
      });

      if (userDetil.data.Data.Tags != null) {
        userDetil.data.Data.Tags.forEach((t) => {
          this.tagValue.push(t.ID);
        });
      }
    },
    replyMessages(pesan, nama, messageId, isMedia, data) {
      console.log('🔄 ===== REPLY MESSAGE CLICKED =====');
      console.log('📌 Pesan:', pesan);
      console.log('📌 Nama:', nama);
      console.log('📌 Message ID (param):', messageId);
      console.log('📌 Data Object:', data);
      console.log('📌 Data.chatID:', data.chatID);
      console.log('📌 Data.id:', data.id);
      console.log('📌 Data.message_id:', data.message_id);
      
      // ✅ CRITICAL FIX: chatID ternyata berisi full WA message ID!
      let extractedId = null;
      
      // Priority 1: messageId parameter (passed from template)
      if (messageId && typeof messageId === 'string' && !(/^\d+$/.test(messageId))) {
        extractedId = messageId;
        console.log('✅ Using messageId parameter:', extractedId);
      }
      
      // Priority 2: data.chatID (ternyata ini WA message ID format lengkap!)
      if (!extractedId && data.chatID && typeof data.chatID === 'string') {
        // Check if it's NOT a pure number (database ID)
        if (!(/^\d+$/.test(data.chatID))) {
          extractedId = data.chatID;
          console.log('✅ Using data.chatID as message ID:', extractedId);
        }
      }
      
      // Priority 3: data.message_id
      if (!extractedId && data.message_id) {
        extractedId = data.message_id;
        console.log('✅ Using data.message_id:', extractedId);
      }
      
      // Priority 4: data.id (various formats)
      if (!extractedId && data.id) {
        if (typeof data.id === 'string') {
          extractedId = data.id;
          console.log('✅ Using data.id (string):', extractedId);
        } else if (typeof data.id === 'object') {
          extractedId = data.id._serialized || data.id.id;
          console.log('✅ Using data.id (object):', extractedId);
        }
      }
      
      // Priority 5: data._data.key.id (WAHA format)
      if (!extractedId && data._data?.key?.id) {
        extractedId = data._data.key.id;
        console.log('✅ Using data._data.key.id:', extractedId);
      }
      
      console.log('📌 Extracted ID:', extractedId);
      console.log('📌 Is pure number?:', /^\d+$/.test(extractedId));
      
      // ❌ Validation: DO NOT use database ID (pure number)
      if (!extractedId || /^\d+$/.test(extractedId)) {
        console.error('❌ ERROR: Invalid WhatsApp message ID!');
        console.error('   Received:', extractedId);
        console.error('   Type:', typeof extractedId);
        console.error('   Data structure:', {
          has_id: !!data.id,
          has_message_id: !!data.message_id,
          has_chatID: !!data.chatID,
          chatID_value: data.chatID,
          id_type: typeof data.id
        });
        
        this.Toast.fire({
          icon: 'error',
          title: 'Cannot Reply',
          text: 'Message ID not found. Please refresh the chat.',
          timer: 3000
        });
        return;
      }
      
      console.log('✅ Valid WA Message ID:', extractedId);
      
      // ✅ Validation: Check if from current conversation
      const currentPhone = String(this.phoneNumber).replace(/\D/g, '');
      
      // Extract phone from message ID
      let messagePhone = '';
      if (extractedId.includes('@')) {
        const cleanId = extractedId.replace(/^(true_|false_)/, '');
        const match = cleanId.match(/^(\d+)@/);
        if (match) {
          messagePhone = match[1];
        }
      }
      
      // Use data.phone as fallback
      const dataPhone = data.phone ? String(data.phone).replace(/\D/g, '') : '';
      
      // Check if it's our own message
      const isOwnMessage = data.fromMe || data.align === 'right';
      
      console.log('🔍 Validation:');
      console.log('   Current Phone:', currentPhone);
      console.log('   Message Phone:', messagePhone);
      console.log('   Data Phone:', dataPhone);
      console.log('   Is Own Message:', isOwnMessage);
      
      // ✅ Allow reply if:
      // 1. It's our own message, OR
      // 2. Phone numbers match
      const isValid = 
        isOwnMessage ||
        messagePhone === currentPhone || 
        dataPhone === currentPhone;
      
      if (!isValid) {
        console.warn('⚠️ WARNING: Message from different conversation!');
        this.Toast.fire({
          icon: 'warning',
          title: 'Cannot Reply',
          text: 'This message is from a different chat',
          timer: 3000
        });
        return;
      }
      
      // ✅ Set reply state
      this.nameReply = nama;
      this.pesanReply = pesan;
      this.pesanId = extractedId; // ✅ Full WA message ID format
      this.messagesReply = true;
      this.isMediaReply = isMedia;
      this.isSticker = data.type === "sticker";
      this.previewImages = data.media;
      
      console.log('✅ Reply State Saved:', {
        nameReply: this.nameReply,
        pesanId: this.pesanId,
        messagesReply: this.messagesReply,
        format: extractedId.includes('_') ? 'FULL_FORMAT' : 'ID_ONLY'
      });
      console.log('====================================');
      
      // Focus input
      this.$nextTick(() => {
        const input = document.getElementById("chatInput");
        if (input) {
          input.focus();
          input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    },
    closeReply() {
      console.log('❌ Closing reply...');
      
      this.messagesReply = false;
      this.nameReply = '';
      this.pesanReply = '';
      this.pesanId = '';
      this.isMediaReply = false;
      this.isSticker = false;
      this.previewImages = null;
      
      console.log('✅ Reply state cleared');
    },
    setDataModal(data, index) {
      if (data.type === 'image') {
        if (("downloadImage" in data) && !data.downloadImage) {
          // Image already downloaded — open modal directly
          this.openModal = true;
          this.imageModal = data.media;
          this.captionModal = data.message;

          this.sourcesImages = data.media
          this.toggler = this.toggler = !this.toggler;

          let anchorPreviewImage = document.querySelector(".popup-img");
          anchorPreviewImage.setAttribute("data-bs-toggle", "modal")
          anchorPreviewImage.setAttribute("data-bs-target", "#zoomInModal")
          // anchorPreviewImage.click();
        } else if (data.downloadImage) {
          // Image still blurred — resolve index reliably
          let idx = (index !== undefined && index !== null) ? index : -1;

          if (idx !== -1 && this.chatMessagesData[idx] !== undefined) {
            const atIdx = this.chatMessagesData[idx];
            if (data.chatID && atIdx.chatID && data.chatID !== atIdx.chatID) {
              console.warn('[setDataModal] Index mismatch! v-for index points to wrong message. Falling back to chatID search.', {
                expected_chatID: data.chatID,
                found_chatID: atIdx.chatID,
                index: idx
              });
              idx = -1;
            }
          } else {
            idx = -1;
          }

          if (idx === -1 && data.chatID) {
            idx = this.chatMessagesData.findIndex(m => m.chatID === data.chatID);
            console.log('[setDataModal] Fell back to chatID search, result idx:', idx);
          }

          console.log('[setDataModal] resolved idx:', idx, '| chatID:', data.chatID, '| sentMediaUrl:', !!data.sentMediaUrl, '| array length:', this.chatMessagesData.length);

          if (data.sentMediaUrl) {
            if (idx !== -1) {
              const unblurred = { ...this.chatMessagesData[idx], style: { filter: 'blur(0px)' }, downloadImage: false };
              this.chatMessagesData.splice(idx, 1, unblurred);
            }
            this.openModal = true;
            this.imageModal = data.sentMediaUrl;
            this.captionModal = data.message;
            this.sourcesImages = data.sentMediaUrl;
            this.toggler = !this.toggler;
          } else if (idx !== -1) {
            this.downloadMedia(idx);
          } else {
            console.error('[setDataModal] All lookups failed. data:', JSON.stringify({ chatID: data.chatID, type: data.type, downloadImage: data.downloadImage, sentMediaUrl: data.sentMediaUrl }));
            console.log('[setDataModal] chatMessagesData chatIDs:', this.chatMessagesData.map((m, i) => ({ i, chatID: m.chatID, type: m.type, downloadImage: m.downloadImage })));
            this.Toast.fire({ title: 'Pesan tidak ditemukan, coba refresh chat', icon: 'warning' });
          }
        }
      } else if (data.type === 'video') {
        // Resolve the best index for this message
        let vIdx = (index !== undefined && index !== null) ? index : -1;
        if (vIdx !== -1 && this.chatMessagesData[vIdx] && data.chatID && this.chatMessagesData[vIdx].chatID !== data.chatID) {
          vIdx = -1; // index shifted; fall back to chatID search
        }
        if (vIdx === -1 && data.chatID) {
          vIdx = this.chatMessagesData.findIndex(m => m.chatID === data.chatID);
        }

        const liveData = vIdx !== -1 ? this.chatMessagesData[vIdx] : data;

        // If not yet downloaded (downloadImage still true), trigger download first.
        // downloadMedia will open the video modal automatically once the download succeeds.
        if (liveData.downloadImage) {
          if (vIdx !== -1) {
            this.downloadMedia(vIdx);
          } else {
            this.Toast.fire({ icon: 'warning', title: 'Video belum siap, coba refresh chat', timer: 2500 });
          }
          return;
        }

        // Already downloaded — use the per-message blob URL (separate from thumbnail in 'media')
        const readyUrl = liveData.videoBlobUrl || data.sentMediaUrl;
        if (readyUrl && (readyUrl.startsWith('data:video') || readyUrl.startsWith('blob:') || readyUrl.startsWith('http'))) {
          this.videoFileName = (liveData.fileName || data.fileName || 'video') + '.mp4';
          this.videoModalUrl = readyUrl;
          this.showVideoModal = true;
          this.$nextTick(() => this.$nextTick(() => this.tryPlayVideo()));
        } else {
          this.Toast.fire({ icon: 'error', title: 'Video tidak tersedia untuk diputar', timer: 2500 });
        }
      } else if (data.type === 'document') {
        // Resolve index reliably
        let dIdx = (index !== undefined && index !== null) ? index : -1;
        if (dIdx !== -1 && this.chatMessagesData[dIdx] && data.chatID && this.chatMessagesData[dIdx].chatID !== data.chatID) {
          dIdx = -1;
        }
        if (dIdx === -1 && data.chatID) {
          dIdx = this.chatMessagesData.findIndex(m => m.chatID === data.chatID);
        }

        const liveDDoc = dIdx !== -1 ? this.chatMessagesData[dIdx] : data;

        if (liveDDoc.documentBlobUrl) {
          // Already downloaded — trigger browser download
          this.downloadDocument(liveDDoc.documentBlobUrl, liveDDoc.fileName || 'document');
        } else if (liveDDoc.downloadImage) {
          if (dIdx !== -1) {
            this.downloadMedia(dIdx);
          } else {
            this.Toast.fire({ icon: 'warning', title: 'Dokumen belum siap, coba refresh chat', timer: 2500 });
          }
        } else {
          this.Toast.fire({ icon: 'warning', title: 'Dokumen tidak tersedia', timer: 2500 });
        }
      }
    },

    closeVideoModal() {
      const vid = this.$refs.videoPlayer;
      try {
        if (vid && typeof vid.pause === 'function') vid.pause();
      } catch (e) {
        console.warn('closeVideoModal: failed to pause video', e);
      }
      // Blob URLs are stored per-message in chatMessagesData[n].videoBlobUrl for re-play;
      // do NOT revoke them here — that would break the thumbnail display after close.
      this.showVideoModal = false;
      this.videoModalUrl = '';
      this.$nextTick(() => {
        try { this.scrollToBottom('users-chat'); } catch (err) { console.warn('scrollToBottom failed after closeVideoModal', err); }
      });
    },

    downloadVideo() {
      if (!this.videoModalUrl) return;
      const a = document.createElement('a');
      a.href = this.videoModalUrl;
      a.download = this.videoFileName || 'video.mp4';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    downloadDocument(blobUrl, fileName) {
      if (!blobUrl) return;
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = fileName || 'document';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    tryPlayVideo() {
      const vid = this.$refs.videoPlayer;
      if (!vid) return;
      try {
        vid.load();
        const playPromise = vid.play();
        if (playPromise !== undefined) {
          // Autoplay may be blocked by browser policy — that is fine, controls allow manual play
          playPromise.catch((error) => {
            if (error && error.name !== 'AbortError') {
              console.warn('[tryPlayVideo] play() failed (user can press play manually):', error.name);
            }
          });
        }
      } catch (e) {
        console.warn('[tryPlayVideo] error', e);
      }
    },

    // Convert base64 string to Blob (avoids large data: URIs on <video> elements)
    base64ToBlob(base64, mimeType) {
      const byteChars = atob(base64);
      const byteNums = new Array(byteChars.length);
      for (let i = 0; i < byteChars.length; i++) {
        byteNums[i] = byteChars.charCodeAt(i);
      }
      return new Blob([new Uint8Array(byteNums)], { type: mimeType });
    },
    generateVideoThumbnail(videoUrl, seekTo = 1.0) {
      return new Promise((resolve, reject) => {
        try {
          const video = document.createElement('video');
          video.crossOrigin = 'anonymous';
          video.preload = 'metadata';
          video.src = videoUrl;

          // Cleanup helper
          const cleanup = () => {
            video.pause();
            video.src = '';
            video.load();
          };

          video.addEventListener('loadedmetadata', function () {
            // clamp seekTo
            if (video.duration < seekTo) seekTo = 0;
            video.currentTime = seekTo;
          });

          video.addEventListener('seeked', function () {
            try {
              const canvas = document.createElement('canvas');
              const ratio = video.videoWidth && video.videoHeight ? (video.videoWidth / video.videoHeight) : 16/9;
              const maxWidth = 480;
              canvas.width = Math.min(video.videoWidth || maxWidth, maxWidth);
              canvas.height = Math.round(canvas.width / ratio);
              const ctx = canvas.getContext('2d');
              ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
              const dataUrl = canvas.toDataURL('image/jpeg', 0.75);
              cleanup();
              resolve(dataUrl);
            } catch (err) {
              cleanup();
              reject(err);
            }
          });

          // Error handling
          video.addEventListener('error', function () {
            try { cleanup(); } catch (cleanupErr) { console.warn('[generateVideoThumbnail] cleanup failed', cleanupErr); }
            reject(new Error('Video load error'));
          });
        } catch (err) {
          reject(err);
        }
      });
    },
    scrollToBottom(id) {
      var self = this;
      setTimeout(function () {
        // ✅ Safe querySelector with null check
        const chatContainer = document.getElementById(id);
        if (!chatContainer) {
          console.warn("❌ Chat container not found:", id);
          return;
        }

        const simpleBar = chatContainer.querySelector(
          "#chat-conversation .simplebar-content-wrapper"
        );
        
        if (!simpleBar) {
          console.warn("❌ SimpleBar wrapper not found");
          return;
        }

        const chatConvList = chatContainer.getElementsByClassName(
          "chat-conversation-list"
        )[0];
        
        if (!chatConvList) {
          console.warn("❌ Chat conversation list not found");
          return;
        }

        var offsetHeight = chatConvList.scrollHeight - window.innerHeight + 600;

        if (offsetHeight) {
          simpleBar.scrollTo({
            top: offsetHeight,
            behavior: "smooth",
          });
        }

        self.onLoad(simpleBar);
      }, 100); // ✅ Increased delay
    },
    onLoad(el) {
      var self = this;
      el.addEventListener("scroll", async function () {
        var top = el.scrollTop;
        if (top === 0 && self.whatsappStatus && !self.isLoadingMore) {
          self.isLoadingMore = true; // ✅ Prevent multiple load more
          var indexEl = self.chatMessagesData.length - 1;
          var posTop = document.getElementById("buble-" + indexEl);

          var contact = await self.getAllContact();
          var usersContact = contact.find((el) => parseInt(el.Phone) === parseInt(self.phoneNumber))
          self.userStatus = usersContact.Status;

          console.log('🔄 Loading more messages...', {
            phone: self.phoneNumber,
            fetched: self.chatMessagesData.length,
            limit: 25
          });

          const convertation = await axios.post(
            process.env.VUE_APP_WA_BASE_URL +
            "api/waha/whatsapp/conversation?clientid=abcd1234",
            {
              phone: self.phoneNumber,
              limit: 25,
              fetched: self.chatMessagesData.length,
              kodemb: JSON.parse(localStorage.getItem("user")).Company
                .CompanyCode,
              download_media: false,
              created_date: parseInt(usersContact.CreatedTime),
              ClientID: process.env.VUE_APP_CLIENT_ID,
              AccessToken: localStorage.getItem("jwt")
            }
          );

          // console.log('📦 API Response:', {
          //   status: convertation.data.status,
          //   total: convertation.data.data.length,
          //   meta: convertation.data.meta
          // });

          let convertationData = convertation.data.data.reverse();

          let tempArray = [];
          convertationData.forEach((item, index) => {
            const regexItalic = /(_)([^_]+?)(_)/gs;
            const regexBold = /(\*)([^*]+?)(\*)/gs;
            const regexStrike = /(~)([^~]+?)(~)/gs;

            var body = item.body;
            body = body.replace(regexItalic, `<i>$2</i>`);
            body = body.replace(regexBold, `<b>$2</b>`);
            body = body.replace(regexStrike, `<s>$2</s>`);
            body = body.replace(/\n/g, "<br/>");

            // 🔥 CRITICAL FIX: Extract agent from API response
            let safeAgent = null;
            
            // ✅ Get agent from response (support both lowercase & PascalCase)
            if (item.agent) {
              const agentName = item.agent.name || item.agent.Name;
              const agentRole = item.agent.role || item.agent.Role?.Title || item.agent.Role;
              
              if (agentName) {
                safeAgent = {
                  ID: item.agent.id || item.agent.ID || 0,
                  Name: agentName,
                  Role: {
                    Title: agentRole || 'Agent',
                    Code: item.agent.Role?.Code || 'agent'
                  }
                };
                
                // console.log(`✅ Agent extracted for message ${index}:`, safeAgent);
              }
            }
            
            // ✅ Fallback: Try from _data.agent if exists
            if (!safeAgent && item._data?.agent) {
              const agentName = item._data.agent.name || item._data.agent.Name;
              const agentRole = item._data.agent.role || item._data.agent.Role?.Title;
              
              if (agentName) {
                safeAgent = {
                  ID: item._data.agent.id || item._data.agent.ID || 0,
                  Name: agentName,
                  Role: {
                    Title: agentRole || 'Agent',
                    Code: 'agent'
                  }
                };
                
                // console.log(`✅ Agent extracted from _data for message ${index}:`, safeAgent);
              }
            }
            
            if (!safeAgent && item.fromMe && index < 3) {
              console.warn(`⚠️ No agent data for outgoing message ${index}`);
            }
            
            // ✅ Handle revoked messages
            let displayMessage = body;
            let messageType = item.type;
            const wahaMediaMsg = item._data?.message ? (item._data.message.imageMessage || item._data.message.videoMessage || item._data.message.documentMessage || item._data.message.audioMessage || item._data.message.stickerMessage) : null;
            let hasMediaDisplay = ("deprecatedMms3Url" in item._data) || (item.hasMedia && !!wahaMediaMsg) ? true : false;
            
            if (item.isRevoked === true || item.type === "revoked") {
              messageType = 'revoked';
              hasMediaDisplay = false; // No media for revoked messages
              
              // Show different text based on who sent it
              if (item.fromMe) {
                displayMessage = '<i class="revoked-inline">Anda menghapus pesan ini</i>';
              } else {
                displayMessage = '<i class="text-muted">Pesan ini dihapus</i>';
              }
            }

            tempArray.push({
              align: item.fromMe === true ? "right" : "",
              name: self.username,
              chatID: item.id.id,
              message: displayMessage,
              time: item.timestamp,
              hasMedia: hasMediaDisplay,
              ack: item.ack ?? 0,
              fromMe: item.fromMe,
              phone: self.phoneNumber,
              type: messageType,
              agent: safeAgent,
              isRevoked: item.isRevoked || false,
              revokedTimestamp: item.revokedTimestamp || null,
              originalBody: item.isRevoked ? item.body : null
            });

            // ✅ Handle media (skip if message is revoked)
            if (!item.isRevoked && "deprecatedMms3Url" in item._data) {
              if ("downloadedMedia" in item) {
                tempArray[index]["media"] = item.downloadedMedia
                  ? "data:" +
                  item.downloadedMedia.mimetype +
                  ";base64," +
                  item.downloadedMedia.data
                  : "data:" +
                  item.downloadedMedia.mimetype +
                  ";base64," +
                  item._data.body;
                tempArray[index]['style'] = { 'filter': 'blur(0px)' }
                tempArray[index]['downloadImage'] = false
              } else {
                tempArray[index]['style'] = { 'filter': 'blur(3px)' }
                tempArray[index]['downloadImage'] = true
                var mimeType = "";
                if ("mimetype" in item._data) {
                  mimeType = item._data.mimetype;
                } else {
                  mimeType = "image/png";
                }
                tempArray[index]["media"] =
                  "data:" + mimeType + ";base64," + item._data.body;
              }
              tempArray[index]["message"] = item._data.caption
                ? item._data.caption
                : "";
              tempArray[index]["type"] =
                item.type === "sticker" ? "sticker" : "image";
            }
            // ✅ Handle WAHA media format (_data.message.imageMessage etc.)
            else if (!item.isRevoked && wahaMediaMsg) {
              const thumbData = wahaMediaMsg.jpegThumbnail;
              if (thumbData) {
                const thumbBase64 = typeof thumbData === 'string'
                  ? thumbData
                  : (thumbData.data
                    ? (typeof thumbData.data === 'string' ? thumbData.data : btoa(new Uint8Array(thumbData.data).reduce(function(s, b) { return s + String.fromCharCode(b); }, '')))
                    : null);
                if (thumbBase64) {
                  // Use thumbnail for preview
                  tempArray[index]['media'] = 'data:image/jpeg;base64,' + thumbBase64;
                }
              } else if (wahaMediaMsg.url) {
                // If the WAHA media provides a direct URL use it
                tempArray[index]['media'] = wahaMediaMsg.url;
              }

              tempArray[index]['hasMedia'] = true;
              // Default to blurred preview for images/documents unless it's a video with direct URL
              tempArray[index]['style'] = { filter: 'blur(3px)' };
              tempArray[index]['downloadImage'] = true;
              tempArray[index]['message'] = wahaMediaMsg.caption || item._data.caption || '';

              if (item._data.message.imageMessage) {
                tempArray[index]['type'] = 'image';
              } else if (item._data.message.videoMessage) {
                tempArray[index]['type'] = 'video';
                // If a direct playable URL exists for video, show it unblurred and mark as ready
                if (wahaMediaMsg.url) {
                  tempArray[index]['media'] = wahaMediaMsg.url;
                  tempArray[index]['style'] = { filter: 'blur(0px)' };
                  tempArray[index]['downloadImage'] = false;
                }
              } else if (item._data.message.stickerMessage) {
                tempArray[index]['type'] = 'sticker';
              } else {
                tempArray[index]['type'] = 'document';
                const docMsg = item._data.message.documentMessage;
                if (docMsg) {
                  tempArray[index]['fileName'] = docMsg.fileName || 'document';
                  tempArray[index]['documentMimeType'] = docMsg.mimetype || 'application/octet-stream';
                }
              }
            }

            // ✅ Handle quoted messages (support both wwebjs and WAHA format)
            let hasQuoted = false;
            let quotedData = null;
            let quotedParticipant = null;
            
            // Method 1: Check wwebjs format (hasQuotedMsg + _data.quotedMsg)
            if (item?.hasQuotedMsg && "quotedMsg" in item._data) {
              hasQuoted = true;
              quotedData = item._data.quotedMsg;
              quotedParticipant = item._data.quotedParticipant;
              
              if ("deprecatedMms3Url" in quotedData) {
                quotedData.body =
                  "data:" +
                  quotedData.mimetype +
                  ";base64," +
                  quotedData.body;
              }
            }
            // Method 2: Check WAHA format (extendedTextMessage.contextInfo.quotedMessage)
            else if (item?._data?.message?.extendedTextMessage?.contextInfo?.quotedMessage) {
              hasQuoted = true;
              const quotedMessage = item._data.message.extendedTextMessage.contextInfo.quotedMessage;
              
              quotedData = {
                body: quotedMessage.conversation || '',
                type: 'chat',
                id: item._data.message.extendedTextMessage.contextInfo.stanzaId || ''
              };
              
              // Extract participant info from contextInfo
              const participant = item._data.message.extendedTextMessage.contextInfo.participant || '';
              const participantPhone = participant.replace(/[^\d]/g, '');

              // Resolusi LID: jika participant berupa LID digits (tidak match phone langsung),
              // cek chatData apakah ada entry customer dengan original_lid yang sesuai
              let isParticipantCurrentUser = participantPhone === self.phoneNumber;
              if (!isParticipantCurrentUser && participantPhone.length >= 9) {
                const lidEntry = Array.isArray(self.chatData) && self.chatData.find(c =>
                  c.original_lid &&
                  c.original_lid.replace(/[^\d]/g, '') === participantPhone
                );
                if (lidEntry && String(lidEntry.phone) === String(self.phoneNumber)) {
                  isParticipantCurrentUser = true;
                }
              }

              quotedParticipant = {
                user: participantPhone,
                name: (isParticipantCurrentUser ? self.username : 'Anda') || participantPhone || 'Unknown'
              };
            }
            
            if (hasQuoted) {
              tempArray[index]["quotedMsg"] = quotedData;
              tempArray[index]["quotedParticipant"] = quotedParticipant;
            }
          });
          
          tempArray.reverse();
          let fixList = tempArray.concat(self.chatMessagesData);
          self.chatMessagesData = fixList;
          
          // ✅ Debug: Final stats
          const withAgent = tempArray.filter(m => m.agent && m.agent.Name).length;
          const outgoing = tempArray.filter(m => m.fromMe).length;
          console.log('📊 Load more complete:', {
            total: tempArray.length,
            outgoing: outgoing,
            withAgent: withAgent,
            percentage: outgoing > 0 ? ((withAgent / outgoing) * 100).toFixed(1) + '%' : '0%'
          });

          if (posTop) {
            el.scrollTop = posTop.offsetHeight - (posTop.offsetHeight / 2 + 5);
          }
        }
        
        // ✅ Reset loading flag after operation
        self.isLoadingMore = false;
      });
    },
    async chatUsername(name, image, telp, id, loadLimit = 25) {
      console.log('🔵 chatUsername called:', { name, telp, id, loadLimit });
      
      if(window.event) window.event.preventDefault();
      
      // ✅ Validate WhatsApp status
      if(!this.whatsappStatus){
        this.Toast.fire({
          title: "Whatsapp Not Ready",
          icon: "error"
        })
        return;
      }

      // 🔥 CRITICAL FIX: Prevent duplicate calls untuk conversation yang sama
      if (this.loadingConversation && String(this.phoneNumber) === String(telp)) {
        console.log('⚠️ Already loading this conversation, skipping...');
        return;
      }

      this.loadingConversation = true;

      // ✅ CRITICAL: Set phone and username FIRST
      this.phoneNumber = String(telp);
      this.username = name;
      this.userid = id;
      
      // 🔥 FIX: Pastikan profile selalu di-set, gunakan dummy jika tidak ada
      const defaultImage = require("@/assets/images/users/user-dummy-img.jpg");
      this.profile = image || defaultImage;
      
      console.log('✅ Set conversation context:', {
        phoneNumber: this.phoneNumber,
        username: this.username,
        userid: this.userid
      });

      // ✅ Set active class
      let element = this.$el.querySelector(`#row-${id}`)
      if(element) {
        this.$el.querySelectorAll('.chat-user-list li').forEach(el => {
          el.classList.remove('active');
        });
        element.classList.add("active");
        console.log('✅ Set active class on row:', id);
      }

      // ✅ Reset conversation state - CRITICAL: Clear sebelum fetch
      this.usermessage = "Hello";
      this.chatMessagesData = []; // 🔥 CLEAR ARRAY
      this.resultSearchMessage = [];
      this.searchChatInput = "";
      this.closeFormUpload();
      this.closeReply(); // 🔥 Also close any open reply
      
      // ✅ Reset load more flags
      this.isLoadingMore = false;
      this.loadMoreRetryCount = 0;
      
      console.log('✅ Cleared conversation state, chatMessagesData length:', this.chatMessagesData.length);

      // ✅ Clear notification
      if (localStorage.getItem("notif") !== null) {
        const notif = JSON.parse(localStorage.getItem("notif"));
        var idxLocalStore = notif.findIndex(
          (el) => parseInt(el.from.split("@")[0]) === parseInt(telp)
        );
        if (idxLocalStore !== -1) {
          notif.splice(idxLocalStore, 1);
          localStorage.setItem("notif", JSON.stringify(notif));
        }
      }

      // ✅ Get contact from IndexedDB
      var contact = await this.getAllContact();
      var usersContact = contact.find((el) => parseInt(el.Phone) === parseInt(telp))
      
      if (!usersContact) {
        console.log('⚠️ Contact not found in IndexedDB');
        usersContact = {
          ID: id || 0,
          Name: name || ("+" + telp),
          Phone: telp,
          Status: "new",
          CreatedTime: Math.floor(Date.now() / 1000),
          TimestampLastChat: Math.floor(Date.now() / 1000),
        };
      } else {
        console.log('✅ Contact found in IndexedDB:', usersContact.Name);
      }
      
      this.userStatus = usersContact.Status;

      // ✅ Fetch conversation
      var kodemb = JSON.parse(localStorage.getItem("user")).Company.CompanyCode;
      var clientID = process.env.VUE_APP_CLIENT_ID;
      var accessToken = localStorage.getItem("jwt");
      
      console.log('🔄 Fetching conversation from API...');
      
      try {
        const convertation = await axios.post(
          process.env.VUE_APP_WA_BASE_URL +
          "api/waha/whatsapp/conversation?clientid=abcd1234",
          {
            phone: telp,
            limit: loadLimit,
            fetched: 0,
            kodemb: kodemb,
            download_media: false,
            ClientID: clientID,
            AccessToken: accessToken
          },
          {
            timeout: 15000
          }
        );

        // ✅ Validate response
        if (!convertation?.data?.data || !Array.isArray(convertation.data.data)) {
          console.error("❌ Invalid conversation response:", convertation?.data);
          this.Toast.fire({
            icon: 'warning',
            title: 'Failed to load conversation'
          });
          return;
        }
        
        console.log('✅ Conversation fetched:', convertation.data.data.length, 'messages');

        // ✅ Mark as read
        if (this.whatsappStatus) {
          try {
            const unreadcount = await axios.post(
              process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/mark-as-read",
              {
                phone: telp,
                kodemb: kodemb,
              },
              {
                headers: {
                  clientid: "abcd1234",
                },
                timeout: 5000
              }
            );

            if (unreadcount.status == 200) {
              var index = this.chatData.findIndex((el) => el.telp === telp);
              if (index !== -1) {
                this.chatData[index].unread_count = 0;
                this.cachingChatData();
              }
            }
          } catch (markReadError) {
            console.error('⚠️ Mark as read failed:', markReadError.message);
          }
        }

        let convertationData = convertation.data.data;
        
        console.log('🔄 Processing', convertationData.length, 'messages...');
        console.log('📊 chatMessagesData BEFORE processing:', this.chatMessagesData.length);
        
        // 🔥 CRITICAL: Create temporary array untuk avoid multiple push
        const tempMessages = [];
        
        // 🔥 PERBAIKAN: Process messages dengan SAFE quoted message handling
        convertationData.forEach((item, index) => {
          try {
            if (!item || typeof item !== 'object') {
              console.warn('⚠️ Skipping invalid message at index', index);
              return;
            }
            
            const regexItalic = /(_)([^_]+?)(_)/gs;
            const regexBold = /(\*)([^*]+?)(\*)/gs;
            const regexStrike = /(~)([^~]+?)(~)/gs;

            var body = item?.body || ' ';
            body = body.replace(regexItalic, `<i>$2</i>`);
            body = body.replace(regexBold, `<b>$2</b>`);
            body = body.replace(regexStrike, `<strike>$2</strike>`);
            body = body.replace(/\n/g, "<br/>");

            if (item?.links?.length) {
              const isValidLink = this.checkStringOfLink(body);
              if (isValidLink) {
                body = "<a href='" + body + "' target='_blank'>" + body + "</a>";
              }
            }

            // 🔥 Safe message ID extraction (support multiple formats)
            let messageId = null;
            if (item?.id) {
              if (typeof item.id === 'string') {
                messageId = item.id;
              } else if (item.id?.id) {
                messageId = item.id.id;
              } else if (item.id?._serialized) {
                messageId = item.id._serialized;
              }
            }
            
            if (!messageId && item?._data?.key?.id) {
              messageId = item._data.key.id;
            }
            
            if (!messageId) {
              messageId = `msg_${item?.timestamp || Date.now()}_${index}`;
            }

            // 🔥 Check duplicate dalam temp array
            const existingIdx = tempMessages.findIndex(
              msg => msg.chatID === messageId
            );
            
            if (existingIdx !== -1) {
              console.warn('⚠️ Duplicate message dalam batch, skipping:', messageId);
              return;
            }

            let safeAgent = null;
            if (item.agent) {
              const agentName = item.agent.Name || item.agent.name;
              const agentRole = item.agent.Role?.Title || item.agent.role;
              
              if (agentName) {
                safeAgent = {
                  ID: item.agent.ID || item.agent.id || 0,
                  Name: agentName,
                  Role: {
                    Title: agentRole || 'Agent',
                    Code: item.agent.Role?.Code || 'agent'
                  }
                };
              } else {
                safeAgent = null;
                console.warn('⚠️ Invalid agent structure at index', index);
              }
            }

            // 🔥 CRITICAL FIX: Extract quoted message properly
            let quotedMsg = null;
            let quotedParticipant = null;
            let hasQuoted = false;

            // Method 1: Check root level (from backend normalization)
            if (item.hasQuotedMsg && item.quotedMsg) {
              hasQuoted = true;
              quotedMsg = item.quotedMsg;
              quotedParticipant = item.quotedParticipant;
              
              // console.log('✅ Found quoted message at root level:', {
              //   messageId,
              //   quotedBody: quotedMsg.body,
              //   quotedParticipant
              // });
            }
            // Method 2: Check _data level
            else if (item._data?.quotedMsg) {
              hasQuoted = true;
              quotedMsg = item._data.quotedMsg;
              quotedParticipant = item._data.quotedParticipant;
              
              console.log('✅ Found quoted message in _data:', {
                messageId,
                quotedBody: quotedMsg.body
              });
            }
            // Method 3: Extract from contextInfo (fallback for raw WAHA)
            else if (item._data?.message?.extendedTextMessage?.contextInfo?.quotedMessage) {
              hasQuoted = true;
              const contextInfo = item._data.message.extendedTextMessage.contextInfo;
              const quotedMessage = contextInfo.quotedMessage;
              
              // Extract body from various formats
              let quotedBody = '';
              if (quotedMessage.conversation) {
                quotedBody = quotedMessage.conversation;
              } else if (quotedMessage.extendedTextMessage?.text) {
                quotedBody = quotedMessage.extendedTextMessage.text;
              } else if (quotedMessage.imageMessage?.caption) {
                quotedBody = quotedMessage.imageMessage.caption || '[Image]';
              }
              
              quotedMsg = {
                body: quotedBody,
                type: quotedMessage.conversation ? 'chat' : 
                      quotedMessage.imageMessage ? 'image' : 'chat',
                id: contextInfo.stanzaId || ''
              };
              
              // Extract participant
              const participantJid = contextInfo.participant || '';
              quotedParticipant = participantJid.replace(/(@s\.whatsapp\.net|@c\.us|@lid)/g, '').replace(/[^\d]/g, '');
              
              console.log('✅ Extracted quoted message from contextInfo:', {
                messageId,
                quotedBody: quotedMsg.body,
                participantJid,
                quotedParticipant
              });
            }

            // 🔥 Format quotedParticipant for display
            let quotedParticipantDisplay = null;
            if (hasQuoted && quotedParticipant) {
              // Normalisasi JID ke digits saja sebelum perbandingan (WAHA mengembalikan format raw JID e.g. 628xxx@s.whatsapp.net)
              const rawParticipant = quotedParticipant;
              const normalizedParticipant = typeof rawParticipant === 'string'
                ? rawParticipant.replace(/(@s\.whatsapp\.net|@c\.us|@lid)/g, '').replace(/[^\d]/g, '')
                : typeof rawParticipant === 'object'
                  ? String(rawParticipant?.user || '')
                  : String(rawParticipant || '');

              // Pesan dikutip dari customer (phone match) → tampilkan nama customer
              // Pesan dikutip dari agent (tidak match) → tampilkan 'Anda'
              let isQuotedFromCurrentUser = normalizedParticipant !== '' &&
                normalizedParticipant === String(this.phoneNumber);

              // Resolusi LID: jika participant berupa LID digits (tidak match phone langsung),
              // cek chatData apakah ada entry customer dengan original_lid yang sesuai
              if (!isQuotedFromCurrentUser && normalizedParticipant.length >= 9) {
                const lidEntry = Array.isArray(this.chatData) && this.chatData.find(c =>
                  c.original_lid &&
                  c.original_lid.replace(/[^\d]/g, '') === normalizedParticipant
                );
                if (lidEntry && String(lidEntry.phone) === String(this.phoneNumber)) {
                  isQuotedFromCurrentUser = true;
                }
              }

              quotedParticipantDisplay = {
                user: normalizedParticipant || String(rawParticipant || ''),
                name: (isQuotedFromCurrentUser ? this.username : 'Anda') || normalizedParticipant || 'Unknown'
              };
            }

            // Build message object (handle revoked flag from backend)
            const isRevokedFlag = item.isRevoked === true || item.type === 'revoked';
            const messageObj = {
              id: item.id,
              message_id: item._data?.key?.id || item.id,
              align: item.fromMe === true ? "right" : "",
              name: this.username,
              chatID: messageId,
              message: isRevokedFlag
                ? (item.fromMe ? '<i class="revoked-inline">Anda menghapus pesan ini</i>' : '<i class="text-muted">Pesan ini dihapus</i>')
                : body,
              time: item?.timestamp || Math.floor(Date.now() / 1000),
              hasMedia: !isRevokedFlag && (item?._data?.deprecatedMms3Url || (item?.hasMedia && item?._data?.message && (item._data.message.imageMessage || item._data.message.videoMessage || item._data.message.documentMessage || item._data.message.audioMessage || item._data.message.stickerMessage))) ? true : false,
              ack: item?.ack || 0,
              fromMe: item?.fromMe || false,
              phone: this.phoneNumber,
              type: isRevokedFlag ? 'revoked' : (item?.type || "chat"),
              quotedMsg: quotedMsg, // ✅ Add quoted message
              quotedParticipant: quotedParticipantDisplay, // ✅ Add participant with proper format
              showHightlight: false,
              downloadImage: false,
              media: null,
              style: {},
              agent: safeAgent,
              isRevoked: isRevokedFlag,
              revokedTimestamp: item.revokedTimestamp || null,
              originalBody: isRevokedFlag ? item.body : null,
              _source: item.source || 'unknown'
            };
            
            // 🔥 Push to temp array INSTEAD of direct chatMessagesData
            tempMessages.push(messageObj);

            // ✅ Handle media
            const currentIndex = tempMessages.length - 1;
            
            if (item?._data?.deprecatedMms3Url) {
              if (item?.downloadedMedia) {
                tempMessages[currentIndex]["media"] = item.downloadedMedia?.data
                  ? "data:" + item.downloadedMedia.mimetype + ";base64," + item.downloadedMedia.data
                  : "data:" + item.downloadedMedia.mimetype + ";base64," + item._data.body;
                tempMessages[currentIndex]['style'] = { filter: "blur(0px)" }
                tempMessages[currentIndex]['downloadImage'] = false
              } else {
                if (item.type === "image" || item.type === "chat") {
                  tempMessages[currentIndex]['style'] = { filter: "blur(3px)" }
                  tempMessages[currentIndex]['downloadImage'] = true
                  var mimeType = item?._data?.mimetype || "image/png";
                  item._data.type = "image";
                  tempMessages[currentIndex]["media"] =
                    "data:" + mimeType + ";base64," + item._data.body;
                }
              }
              
              switch (item?._data?.type) {
                case "sticker":
                  tempMessages[currentIndex]["type"] = "sticker";
                  break;
                case "image":
                  tempMessages[currentIndex]["type"] = "image";
                  var caption_body = item?._data?.caption || '';
                  caption_body = caption_body?.replace(regexItalic, `<i>$2</i>`);
                  caption_body = caption_body?.replace(regexBold, `<b>$2</b>`);
                  caption_body = caption_body?.replace(regexStrike, `<strike>$2</strike>`);
                  tempMessages[currentIndex]["message"] = caption_body;
                  break;
                case "video":
                  tempMessages[currentIndex]["type"] = "video";
                  tempMessages[currentIndex]["message"] = "<i>Unsupported Message Content</i>";
                  break;
              }
            }
            // ✅ Handle WAHA media format (_data.message.imageMessage etc.)
            else if (!isRevokedFlag && item?._data?.message) {
              const wahaMsg = item._data.message;
              const wahaMedia = wahaMsg.imageMessage || wahaMsg.videoMessage || wahaMsg.documentMessage || wahaMsg.audioMessage || wahaMsg.stickerMessage;
              if (wahaMedia) {
                const thumbData = wahaMedia.jpegThumbnail;
                if (thumbData) {
                  const thumbBase64 = typeof thumbData === 'string'
                    ? thumbData
                    : (thumbData.data
                      ? (typeof thumbData.data === 'string' ? thumbData.data : btoa(new Uint8Array(thumbData.data).reduce(function(s, b) { return s + String.fromCharCode(b); }, '')))
                      : null);
                  if (thumbBase64) {
                    tempMessages[currentIndex]['media'] = 'data:image/jpeg;base64,' + thumbBase64;
                  }
                } else if (wahaMedia.url) {
                  tempMessages[currentIndex]['media'] = wahaMedia.url;
                }
                tempMessages[currentIndex]['hasMedia'] = true;
                tempMessages[currentIndex]['style'] = { filter: 'blur(3px)' };
                tempMessages[currentIndex]['downloadImage'] = true;
                if (wahaMsg.imageMessage) {
                  tempMessages[currentIndex]['type'] = 'image';
                  var wahaCaption = wahaMedia.caption || '';
                  wahaCaption = wahaCaption.replace(regexItalic, `<i>$2</i>`);
                  wahaCaption = wahaCaption.replace(regexBold, `<b>$2</b>`);
                  wahaCaption = wahaCaption.replace(regexStrike, `<strike>$2</strike>`);
                  tempMessages[currentIndex]['message'] = wahaCaption;
                } else if (wahaMsg.videoMessage) {
                  tempMessages[currentIndex]['type'] = 'video';
                } else if (wahaMsg.stickerMessage) {
                  tempMessages[currentIndex]['type'] = 'sticker';
                } else {
                  tempMessages[currentIndex]['type'] = 'document';
                  if (wahaMsg.documentMessage) {
                    tempMessages[currentIndex]['fileName'] = wahaMsg.documentMessage.fileName || 'document';
                    tempMessages[currentIndex]['documentMimeType'] = wahaMsg.documentMessage.mimetype || 'application/octet-stream';
                  }
                }
              }
            }
            
            // 🔥 Process quoted message media if exists
            if (hasQuoted && quotedMsg) {
              if (quotedMsg.deprecatedMms3Url && quotedMsg.type !== "sticker") {
                quotedMsg.body = "data:" + quotedMsg.mimetype + ";base64," + quotedMsg.body;
              }
              // Update the reference
              tempMessages[currentIndex]["quotedMsg"] = quotedMsg;
            }
            
          } catch (msgError) {
            console.error('❌ Error processing message at index', index, msgError);
          }
        });
        
        // 🔥 CRITICAL: Assign temp array to chatMessagesData ONCE after processing
        this.chatMessagesData = tempMessages;

        // Normalize `fromMe` and `align` flags to ensure consistent truthy booleans
        this.chatMessagesData = this.chatMessagesData.map(m => {
          m.fromMe = !!m.fromMe;
          m.align = m.fromMe ? 'right' : (m.align || '');
          return m;
        });
        
        console.log('✅ Processed all messages, total:', this.chatMessagesData.length);
        console.log('📊 chatMessagesData AFTER processing:', this.chatMessagesData.length);

        // 🔥 Sync chatlist ack from conversation's last fromMe message
        if (this.chatMessagesData.length > 0) {
          const lastFromMe = [...this.chatMessagesData].reverse().find(m => m.fromMe);
          if (lastFromMe) {
            const chatIdx = this.chatData.findIndex(el =>
              el && el.telp && String(el.telp).replace(/\D/g, '') === String(this.phoneNumber).replace(/\D/g, '')
            );
            if (chatIdx !== -1 && this.chatData[chatIdx].fromMe) {
              const conversationAck = lastFromMe.ack || 0;
              if (conversationAck > (this.chatData[chatIdx].ack || 0)) {
                this.chatData[chatIdx].ack = conversationAck;
              }
            }
          }
        }

        // 🔥 Log quoted messages
        const quotedCount = this.chatMessagesData.filter(m => m.quotedMsg).length;
        console.log('💬 Messages with quotes:', quotedCount);

        // ✅ Sort messages
        if (this.chatMessagesData.length > 0) {
          this.chatMessagesData.sort(function (a, b) { return a.time - b.time });
          
          console.log('✅ Messages sorted by time');
          
          await this.$nextTick();
          
          var currentChatId = "users-chat";
          
          setTimeout(() => {
            this.scrollToBottom(currentChatId);
            console.log('✅ Scrolled to bottom');
            
            // Handle input state based on status
            if (this.userStatus === "resolved") {
              const chatInput = document.getElementById("chatInput");
              const btnSend = document.getElementById("btnSendMessage");
              
              if (chatInput) {
                chatInput.setAttribute("disabled", "disabled");
                chatInput.setAttribute("placeholder", "Customer Is Resolved");
              }
              if (btnSend) {
                btnSend.setAttribute("disabled", "disabled");
              }
            } else {
              const chatInput = document.getElementById("chatInput");
              const btnSend = document.getElementById("btnSendMessage");
              
              if (chatInput) {
                chatInput.removeAttribute("disabled");
                chatInput.setAttribute("placeholder", "Enter Message...");
              }
              if (btnSend) {
                btnSend.removeAttribute("disabled");
              }
            }
          }, 300);
        }

        // ✅ Mobile view handling
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
          let convvalue = this.chatMessagesData.length > 0 ? 1 : 0;
          await this.$nextTick();
          setTimeout(() => {
            const convEl = this.$el.querySelector("#conv-"+convvalue);
            if (convEl) {
              convEl.classList.add("user-chat-show");
            }
          }, 300);
        }

        this.loadingConversation = false;
        
        console.log('✅ chatUsername completed successfully');
        
      } catch (error) {
        console.error("❌ Error opening conversation:", error);
        this.loadingConversation = false;
        this.Toast.fire({
          icon: 'error',
          title: 'Failed to open conversation: ' + error.message
        });
      }
    },
    async resendMessage(messageData) {
      console.log('🔄 ===== RESEND MESSAGE =====');
      console.log('📌 Message Data:', messageData);
      
      let formData = null;
      const agent = JSON.parse(localStorage.getItem("userdata"));
      var agentParams = {
        ID: agent.ID,
        Name: agent.Name,
        Role: agent.Role,
        Avatar: agent.Avatar,
      };

      if (messageData.type == 'image') {
        console.log('📷 Resending IMAGE message');
        formData = new FormData();
        formData.append("phone", this.phoneNumber);
        formData.append("type", "MEDIA");
        formData.append("kodemb", agent.Company.CompanyCode);
        formData.append("media_source", "URL");
        formData.append("message", messageData.message ?? "");
        formData.append("caption", messageData.message ?? "");
        formData.append("image_url", messageData.media);
        formData.append("agent", JSON.stringify(agentParams));
      } else {
        console.log('💬 Resending TEXT message');
        formData = {
          kodemb: agent.Company.CompanyCode,
          phone: this.phoneNumber,
          message: messageData.message,
          type: 'TEXT', // ✅ Tambahkan type
          agent: JSON.stringify(agentParams),
        };
      }

      console.log('📤 Resending to WhatsApp...');

      try {
        const isFormDataResend = formData instanceof FormData;
        const messRess = await axios.post(
          process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/send",
          formData,
          {
            headers: {
              ...(isFormDataResend ? {} : { "content-type": "application/json; charset=utf-8" }),
              clientid: "abcd1234",
              authorization: agent.Company.CompanyCode,
            },
          }
        );

        console.log('📥 Resend Response:', messRess.data);

        if (messRess.data.status == 200) {
          var dataPost = new FormData();
          dataPost.append("id", messageData.chatID);
          
          // Extract message ID dengan safe navigation
          let waMessageId = messRess.data.data?.id?.id || 
                          messRess.data.data?.id?._serialized || 
                          messRess.data.data?.id;
          
          dataPost.append("message_id", waMessageId);

          var param = 
            "?ClientID=" + process.env.VUE_APP_CLIENT_ID +
            "&AccessToken=" + localStorage.getItem("jwt");
            
          await axios.post(
            process.env.VUE_APP_URL_API + "agent-api/updateChat" + param,
            dataPost
          );

          this.pushToTop(this.phoneNumber, messRess.data.data);

          let lastIndex = this.chatMessagesData.findIndex(el => {
            return parseInt(el.chatID) === parseInt(messageData.chatID)
          });
          
          if (lastIndex !== -1) {
            this.chatMessagesData.splice(lastIndex, 1);
          }
          
          console.log('✅ Resend successful');
          
          this.Toast.fire({
            icon: "success",
            title: "Message resent successfully"
          });
        } else {
          console.error('❌ Resend failed:', messRess.data.message);
          this.Toast.fire({
            title: 'Failed to resend message',
            text: messRess.data.message,
            icon: 'warning'
          });
        }
      } catch (error) {
        console.error('❌ Resend Error:', error);
        this.Toast.fire({
          title: 'Error resending message',
          text: error.message,
          icon: 'error'
        });
      }
    },
    async formSubmit() {
      this.submitted = true;
      var btnSend = document.getElementById("btnSendMessage");
      btnSend?.setAttribute("disabled", "disabled");

      this.v$?.$touch();

      if (this.v$?.$invalid && !this.showFormUpload) {
        btnSend?.removeAttribute("disabled");
        return;
      }

      // mark sending state (used by buttons inside and outside modal)
      this.isSending = true;
      console.log('📤 ===== FORM SUBMIT =====');
      console.log('📌 Is Reply?:', this.messagesReply);
      console.log('📌 Reply ID:', this.pesanId);

      // ⚡ CARA A: declare tempId outside try so catch block can access it
      let tempId = null;

      try {
        const message = this.form.message ?? "";
        const phone = this.phoneNumber;
        let formData = null;

        const agent = JSON.parse(localStorage.getItem("userdata"));
        var agentParams = {
          ID: agent.ID,
          Name: agent.Name,
          Role: agent.Role,
          Avatar: agent.Avatar,
        };

        // ===== BUILD FORM DATA =====
        
        // Case 1: Normal Text (No Upload, No Reply)
        if (!this.showFormUpload && !this.messagesReply) {
          console.log('💬 Case: Normal Text');
          formData = {
            kodemb: agent.Company.CompanyCode,
            phone: phone,
            message: message,
            type: 'TEXT',
            agent: JSON.stringify(agentParams),
          };
        } 
        // Case 2: Reply Message
        else if (this.messagesReply) {
          console.log('🔄 Case: Reply Message');
          console.log('   Reply To:', this.pesanId);
          
          if (this.showFormUpload && this.files?.length > 0) {
            // Reply with MEDIA
            console.log('📷 Reply with Media');
            formData = new FormData();
            formData.append("phone", phone);
            formData.append("type", "MEDIA");
            formData.append("kodemb", agent.Company.CompanyCode);
            formData.append("media_source", "LOCAL");
            formData.append("caption", message);
            formData.append("message", message);
            formData.append("image_local", this.files[this.files.length - 1]);
            formData.append("message_id", this.pesanId); // ✅ Reply ID
            formData.append("quoted_body", this.pesanReply);
            formData.append("quoted_type", this.isMediaReply ? 'image' : 'chat');
            formData.append("quoted_participant", this.phoneNumber);
            formData.append("quoted_participant_name", this.nameReply);
            formData.append("agent", JSON.stringify(agentParams));
          } else {
            // Reply with TEXT
            console.log('💬 Reply with Text');
            formData = {
              kodemb: agent.Company.CompanyCode,
              phone: phone,
              message: message,
              type: 'TEXT',
              message_id: this.pesanId, // ✅ Reply ID
              quoted_body: this.pesanReply,
              quoted_type: this.isMediaReply ? 'image' : 'chat',
              quoted_participant: this.phoneNumber,
              quoted_participant_name: this.nameReply,
              fetched: 25,
              agent: JSON.stringify(agentParams),
            };
          }
        } 
        // Case 3: Upload Media (No Reply)
        else if (this.showFormUpload) {
          console.log('📷 Case: Media Upload');
          formData = new FormData();
          formData.append("phone", phone);
          formData.append("type", "MEDIA");
          formData.append("kodemb", agent.Company.CompanyCode);
          formData.append("media_source", "LOCAL");
          formData.append("message", message);
          formData.append("caption", message);
          formData.append("image_local", this.files[this.files.length - 1]);
          formData.append("agent", JSON.stringify(agentParams));
        }

        // ===== SAVE TO DATABASE =====
        // Capture file type before async call so it's available in .then() closure
        const uploadedFile = this.files?.length > 0 ? this.files[this.files.length - 1] : null;
        const uploadedFileType = uploadedFile?.type || '';
        const isUploadedImage = uploadedFileType.startsWith('image/');
        const isUploadedVideo = uploadedFileType.startsWith('video/');
        const isUploadedDocument = uploadedFile !== null && !isUploadedImage && !isUploadedVideo;

        // ===== ⚡ CARA A: OPTIMISTIC PUSH (pesan tampil sebelum API selesai) =====
        tempId = 'local_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
        {
          const optMsg = {
            align: 'right',
            name: this.username,
            chatID: tempId,
            message: message || '',
            time: Math.floor(Date.now() / 1000),
            hasMedia: uploadedFile !== null,
            ack: 0,
            fromMe: true,
            phone: this.phoneNumber,
            type: isUploadedImage ? 'image' : (isUploadedVideo ? 'video' : (isUploadedDocument ? 'document' : 'chat')),
            agent: agentParams,
            pending: true,
            hasQuotedMsg: !!this.messagesReply,
            quotedMsg: this.messagesReply ? {
              body: this.pesanReply,
              type: this.isMediaReply ? 'image' : 'chat',
            } : null,
            quotedParticipant: this.messagesReply ? {
              user: this.phoneNumber,
              name: this.nameReply,
            } : null,
            showHightlight: false,
            downloadImage: false,
            media: null,
            style: {}
          };
          if (isUploadedVideo && uploadedFile) {
            optMsg.videoBlobUrl = URL.createObjectURL(uploadedFile);
            optMsg.fileName = uploadedFile.name.replace(/\.[^.]+$/, '');
            optMsg.style = { filter: 'blur(0px)' };
          } else if (isUploadedDocument && uploadedFile) {
            optMsg.documentBlobUrl = URL.createObjectURL(uploadedFile);
            optMsg.fileName = uploadedFile.name;
            optMsg.documentMimeType = uploadedFile.type;
          } else if (isUploadedImage && uploadedFile) {
            optMsg.media = URL.createObjectURL(uploadedFile);
            optMsg.style = { filter: 'blur(0px)' };
          }
          this.chatMessagesData.push(optMsg);
          this.$nextTick(() => this.scrollToBottom('users-chat'));
          console.log('⚡ [Cara A] Optimistic push:', tempId);

          // Generate thumbnail for video in background — update entry when ready
          if (isUploadedVideo && optMsg.videoBlobUrl) {
            const _vidUrl = optMsg.videoBlobUrl;
            const _tempIdSnapshot = tempId; // capture at push time
            this.generateVideoThumbnail(_vidUrl, 0.5).then(thumb => {
              if (!thumb) return;
              // Entry may have been reconciled to waMessageId by now — search broadly
              const tIdx = this.chatMessagesData.findIndex(
                m => m.chatID === _tempIdSnapshot || (m.videoBlobUrl && m.videoBlobUrl === _vidUrl)
              );
              if (tIdx !== -1) {
                const updated = { ...this.chatMessagesData[tIdx], media: thumb };
                this.chatMessagesData.splice(tIdx, 1, updated);
                console.log('🖼️ [Cara A] Video thumbnail generated for', this.chatMessagesData[tIdx]?.chatID || _tempIdSnapshot);
              }
            }).catch(() => {});
          }
        }

        var dataPost = new FormData();
        dataPost.append("AgentID", agent.ID);
        dataPost.append("MessageID", "0");
        dataPost.append("CustomerID", this.userid);
        dataPost.append("Content", message);
        // Only send image files to saveChat — PHP backend uses Image::create() which rejects video/PDF
        if (uploadedFile && isUploadedImage) {
          dataPost.append("Photo", uploadedFile);
        }
        // Signal to backend that there is media (even if not uploaded to PHP) so it won't reject empty captions
        if (uploadedFile && !isUploadedImage) {
          dataPost.append("HasMedia", "1");
        }

        console.log('💾 Saving to database...');
        
        await axios.post(
          process.env.VUE_APP_URL_API + "agent-api/saveChat", 
          dataPost, 
          {
            params: {
              ClientID: process.env.VUE_APP_CLIENT_ID,
              AccessToken: localStorage.getItem("jwt")
            }
          }
        ).then(async res => {
          let data = res.data;

          // Guard: bail out early if backend returned an error (data.Data will be absent)
          if (!data?.Data) {
            console.error('❌ Database save failed:', data?.Meta?.Message);
            // ✅ CARA A: Hapus optimistic entry on DB failure
            const _dbFailIdx = this.chatMessagesData.findIndex(m => m.chatID === tempId);
            if (_dbFailIdx !== -1) this.chatMessagesData.splice(_dbFailIdx, 1);
            this.Toast.fire({
              title: 'Internal Server Error',
              text: data?.Meta?.Message || 'Unknown error',
              icon: 'error'
            });
            return;
          }

          let sendWaFails = false;
          let ressWa = null;
          // Detect media type: use DB response for images, local file type for video/doc
          let hasMedia = false;
          let type = 'chat';
          if (isUploadedImage) {
            hasMedia = data.Data.Type === 'image';
            type = hasMedia ? 'image' : 'chat';
          } else if (isUploadedVideo) {
            hasMedia = true;
            type = 'video';
          } else if (isUploadedDocument) {
            hasMedia = true;
            type = 'document';
          }
          let waMessageId = null;

          console.log('✅ Database save success, chatID:', data.Data.ID);

          if (data.Meta.Code === 200) {
            console.log('📤 Sending to WhatsApp API...');
            
            // ===== SEND TO WHATSAPP =====
            const isFormData = formData instanceof FormData;
            const messRess = await axios.post(
              process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/send",
              formData,
              {
                headers: {
                  // For FormData (media), do NOT set content-type — axios will set
                  // multipart/form-data with the correct boundary automatically.
                  // For plain objects (text), set application/json.
                  ...(isFormData ? {} : { "content-type": "application/json; charset=utf-8" }),
                  clientid: "abcd1234",
                  authorization: agent.Company.CompanyCode,
                },
              }
            );

            console.log('📥 WhatsApp Response:', messRess.data);

            // Build message object for UI
            let pushConvertation = {
              align: "right",
              name: this.username,
              chatID: data.Data.ID, // Database ID
              id: waMessageId, // ✅ Add WhatsApp message ID
              message: data.Data.Content,
              time: data.Data.Time,
              hasMedia: hasMedia,
              ack: 0,
              fromMe: true,
              phone: this.phoneNumber,
              type: type,
              agent: data.Data.Agent,
              message_id: waMessageId, // ✅ Add explicit message_id field
              _data: { // ✅ Add WAHA-like structure
                key: {
                  id: waMessageId
                }
              }
            };

            if (hasMedia) {
              pushConvertation.style = { filter: 'blur(0px)' };
              pushConvertation.downloadImage = false;
              if (isUploadedImage && data.Data.Photo) {
                pushConvertation.media = data.Data.Photo.Original;
              } else if (isUploadedVideo && uploadedFile) {
                pushConvertation.media = null;
                pushConvertation.videoBlobUrl = URL.createObjectURL(uploadedFile);
                pushConvertation.fileName = uploadedFile.name.replace(/\.[^.]+$/, '');
              } else if (isUploadedDocument && uploadedFile) {
                pushConvertation.media = null;
                pushConvertation.documentBlobUrl = URL.createObjectURL(uploadedFile);
                pushConvertation.fileName = uploadedFile.name;
                pushConvertation.documentMimeType = uploadedFile.type;
              }
            }

            // ===== HANDLE SUCCESS =====
            if (messRess.status == 200 && messRess.data.status === 200) {
              console.log('✅ WhatsApp send SUCCESS');
              
              // ✅ Extract WA Message ID
              if (messRess.data.data) {
                const waData = messRess.data.data;
                
                if (waData.id) {
                  if (typeof waData.id === 'string') {
                    waMessageId = waData.id;
                  } else if (typeof waData.id === 'object') {
                    waMessageId = waData.id.id || waData.id._serialized;
                  }
                }
                
                if (!waMessageId && waData.key?.id) {
                  waMessageId = waData.key.id;
                }
                
                if (!waMessageId && waData._data?.key?.id) {
                  waMessageId = waData._data.key.id;
                }
              }
              
              console.log('📌 Extracted WA Message ID:', waMessageId);
              
              // ✅ CRITICAL: Update pushConvertation dengan struktur yang benar
              if (waMessageId) {
                pushConvertation.chatID = waMessageId; // ✅ Simpan WA message ID di chatID
                pushConvertation.id = waMessageId;     // ✅ Juga di id
                pushConvertation.message_id = waMessageId; // ✅ Dan message_id
                pushConvertation._data = {
                  key: { id: waMessageId }
                };
              }

              // ✅ CARA A: Reconcile tempId → WA message ID sehingga socket chat_create otomatis di-dedup
              const tempIdx = this.chatMessagesData.findIndex(m => m.chatID === tempId);
              if (tempIdx !== -1) {
                const existing = this.chatMessagesData[tempIdx];
                // Keep existing blob URL thumbnail — don't replace with PHP URL that may 404.
                // If PHP returns a valid absolute URL AND we have no blob, use it.
                const phpPhotoUrl = isUploadedImage && data.Data.Photo?.Original;
                const keepMedia = existing.media || (phpPhotoUrl && phpPhotoUrl.startsWith('http') ? phpPhotoUrl : null);
                const reconciled = {
                  ...existing,
                  chatID: waMessageId || tempId,
                  id: waMessageId,
                  message_id: waMessageId,
                  _data: { key: { id: waMessageId } },
                  ack: Math.max(existing.ack ?? 0, 1), // preserve ack if already updated by chat_status_changed
                  pending: false,
                  agent: data.Data.Agent || agentParams,
                  media: keepMedia,
                  style: existing.style || {},
                  downloadImage: existing.downloadImage || false,
                };
                this.chatMessagesData.splice(tempIdx, 1, reconciled);
                console.log('✅ [Cara A] Reconciled tempId →', waMessageId);
              } else {
                // Cek apakah chat_create sudah reconcile entry ini sebelum formSubmit selesai
                const alreadyBySocket = waMessageId
                  ? this.chatMessagesData.findIndex(m => m.chatID === waMessageId) !== -1
                  : false;
                if (alreadyBySocket) {
                  console.log('✅ [Cara A] chat_create sudah reconcile ke', waMessageId, '— skip push duplikat');
                } else {
                  // Fallback: optimistic entry tidak ada dan socket belum reconcile
                  this.chatMessagesData.push(pushConvertation);
                }
              }
              this.$nextTick(() => this.scrollToBottom('users-chat'));
              
              // Update database
              if (waMessageId) {
                var dataUpdate = new FormData();
                dataUpdate.append("id", data.Data.ID); // Database ID
                dataUpdate.append("message_id", waMessageId);

                var param = 
                  "?ClientID=" + process.env.VUE_APP_CLIENT_ID +
                  "&AccessToken=" + localStorage.getItem("jwt");
                  
                await axios.post(
                  process.env.VUE_APP_URL_API + "agent-api/updateChat" + param,
                  dataUpdate
                );
              }

              ressWa = messRess.data.data;
              
              // ✅ CRITICAL: Clear reply state after success
              if (this.messagesReply) {
                console.log('✅ Clearing reply state...');
                this.closeReply();
              }
              
            } else {
              console.warn('⚠️ WhatsApp send FAILED');
              sendWaFails = true;
              // ✅ CARA A: Tandai optimistic entry sebagai gagal
              const _waFailIdx = this.chatMessagesData.findIndex(m => m.chatID === tempId);
              if (_waFailIdx !== -1) {
                const failed = { ...this.chatMessagesData[_waFailIdx], ack: 4, pending: false };
                this.chatMessagesData.splice(_waFailIdx, 1, failed);
              } else {
                pushConvertation.ack = 4;
                this.chatMessagesData.push(pushConvertation);
              }
            }

            // Fallback for failed messages
            if (sendWaFails) {
              ressWa = {
                body: data.Data.Content,
                hasMedia: hasMedia,
                timestamp: data.Data.Time,
                fromMe: true,
                unread_count: 0,
                ack: 4,
                type: type
              };
            }

            // Update UI
            this.scrollToBottom("users-chat");
            this.pushToTop(this.phoneNumber, ressWa);
            this.cachingChatData();
            
            console.log('✅ Message processing complete');
            
          }
        }).catch(err => {
          console.error('❌ Database Error:', err);
          // ✅ CARA A: Hapus optimistic entry on axios error
          const _catchIdx = this.chatMessagesData.findIndex(m => m.chatID === tempId);
          if (_catchIdx !== -1) this.chatMessagesData.splice(_catchIdx, 1);
          this.Toast.fire({
            title: 'Internal Server Error',
            text: err.message,
            icon: 'error'
          });
        });

      } catch (error) {
        console.error('❌ Form Submit Error:', error);
        // ✅ CARA A: Hapus optimistic entry on unexpected error
        if (tempId) {
          const _errIdx = this.chatMessagesData.findIndex(m => m.chatID === tempId);
          if (_errIdx !== -1) this.chatMessagesData.splice(_errIdx, 1);
        }
        let errorData = error.response?.data || { message: error.message };
        this.Toast.fire({
          icon: "error",
          title: errorData.message || "Failed to send message"
        });
      }

      // ===== CLEANUP =====
      this.submitted = false;
      this.isSending = false;
      this.form = {};
      btnSend?.removeAttribute("disabled");

      if (this.showFormUpload) {
        this.closeFormUpload();
      }
    },
    /* 
     * function indexDB
     */
    async getAllContact() {
      return new Promise((resolve) => {
        try {
          // ✅ Validate IndexedDB exists
          if (!this.db || !this.db.objectStoreNames) {
            console.warn('⚠️ IndexedDB not initialized properly');
            resolve([]);
            return;
          }

          // ✅ Check if 'customer' store exists
          if (!this.db.objectStoreNames.contains('customer')) {
            console.warn('⚠️ Customer object store does not exist');
            resolve([]);
            return;
          }

          let trans = this.db.transaction(['customer'], 'readonly');
          let customer = [];
          
          trans.oncomplete = () => {
            console.log("✅ IndexedDB read complete:", customer.length, "contacts");
            resolve(customer);
          };

          trans.onerror = (e) => {
            console.error("❌ IndexedDB transaction error:", e);
            resolve([]); // ✅ Return empty array, don't crash
          };

          trans.onabort = (e) => {
            console.error("❌ IndexedDB transaction aborted:", e);
            resolve([]); // ✅ Return empty array, don't crash
          };

          let store = trans.objectStore("customer");
          let objStoreReq = store.getAll();

          objStoreReq.onsuccess = () => {
            try {
              const rawData = objStoreReq.result || [];
              console.log('📊 Raw IndexedDB data:', rawData.length, 'records');
              
              // ✅ Filter out corrupted/invalid records
              const validData = rawData.filter(item => {
                const isValid = (
                  item &&
                  typeof item === 'object' &&
                  item.ID !== undefined &&
                  item.Phone !== undefined &&
                  item.Name !== undefined
                );
                
                if (!isValid && item) {
                  console.warn('⚠️ Invalid record found:', {
                    hasID: !!item.ID,
                    hasPhone: !!item.Phone,
                    hasName: !!item.Name
                  });
                }
                
                return isValid;
              });
              
              console.log('✅ Valid contacts:', validData.length, 'out of', rawData.length);
              
              // ✅ Safe sort with fallback timestamps
              try {
                validData.sort((a, b) => {
                  let aTime = 0;
                  let bTime = 0;
                  
                  // Try TimestampLastChat first
                  if (a.TimestampLastChat) {
                    try {
                      aTime = new Date(a.TimestampLastChat).getTime();
                    } catch (e) {
                      aTime = (a.CreatedTime || 0) * 1000;
                    }
                  } else {
                    aTime = (a.CreatedTime || 0) * 1000;
                  }
                  
                  if (b.TimestampLastChat) {
                    try {
                      bTime = new Date(b.TimestampLastChat).getTime();
                    } catch (e) {
                      bTime = (b.CreatedTime || 0) * 1000;
                    }
                  } else {
                    bTime = (b.CreatedTime || 0) * 1000;
                  }
                  
                  return bTime - aTime; // Descending (newest first)
                });
              } catch (sortError) {
                console.error('❌ Error sorting contacts:', sortError);
                // Continue with unsorted data
              }
              
              customer = validData;
              
            } catch (processError) {
              console.error('❌ Error processing IndexedDB data:', processError);
              customer = objStoreReq.result || [];
            }
          };

          objStoreReq.onerror = (e) => {
            console.error("❌ IndexedDB getAll error:", e);
            resolve([]); // ✅ Return empty array, don't crash
          };
          
        } catch (error) {
          console.error("❌ Critical error in getAllContact:", error);
          resolve([]); // ✅ Always resolve, never reject
        }
      });
    },
    async addCustomerToDB(cust){
      return new Promise((resolve, reject) => {
        let trans = this.db.transaction(['customer'], 'readwrite')
        let store = trans.objectStore('customer')
        
        for (let _ = 0; _ < cust.length; _++) {
          const item = cust[_];
          item['id'] = item.ID
          // store.add(item);
          store.put(item); // ✅ put = insert or update
        }

        /* cust.map(item => {
          item.id = item?.ID ?? 0
          store.add(item);
        }) */

        trans.oncomplete = () => {
          return resolve()
        }

        trans.onerror = e => {
          return reject(e);
        }
      })
    },
    async cleanDataDB()
    {
      return new Promise((resolve, reject) => {
        let trans = this.db.transaction(['customer'], 'readwrite')
        let objectStore = trans.objectStore("customer");

        let clearRequest = objectStore.clear();
        clearRequest.onsuccess = () => {
          resolve();
        }

        clearRequest.onerror = () => {
          reject();
        }
      })
    },
    cleanObjectForIndexedDB(obj) {
      // Method 1: Simple deep clone (removes functions & circular refs)
      try {
        return JSON.parse(JSON.stringify(obj));
      } catch (e) {
        // Method 2: Manual cleaning if JSON method fails
        console.warn('⚠️ JSON clone failed, using manual clean:', e);
        
        const cleaned = {
          ID: obj.ID,
          Name: obj.Name,
          Phone: obj.Phone,
          Email: obj.Email,
          Status: obj.Status,
          CreatedTime: obj.CreatedTime,
          TimestampLastChat: obj.TimestampLastChat,
          Avatar: obj.Avatar ? {
            Original: obj.Avatar.Original,
            Thumbnail: obj.Avatar.Thumbnail
          } : null,
          Tags: obj.Tags ? obj.Tags.map(tag => ({
            Title: tag.Title,
            ID: tag.ID
          })) : []
        };
        
        return cleaned;
      }
    },
    async getUser(params, start = 0, to = this.itemsInPages, isLoadMore = false) {
      console.log('🔄 getUser called:', { params, start, to, isLoadMore, itemsInPages: this.itemsInPages });
      
      await this.checkWhatsappStatus();
      
      // 🔥 FIX: Track current filter status
      const currentStatus = params.toLowerCase();
      const statusChanged = this.currentStatusFilter !== currentStatus;
      
      if (!isLoadMore || statusChanged) {
        this.chatData = [];
        this.pages = { data: { Data: [] } };
        this.currentStatusFilter = currentStatus; // Save current filter
        this.finishedContacts = false; // Reset finished flag
        console.log('🔄 Reset chatData and pages due to:', statusChanged ? 'status change' : 'initial load');
      } else {
        console.log('📄 LoadMore mode - preserving', this.pages.data?.Data?.length || 0, 'items');
      }

      this.shimmerOn = true;
      this.fetchChatRoom = true;
      // When performing a load-more operation we should NOT clear
      // the currently opened conversation (if any). Clearing
      // `username`/`chatMessagesData` here caused the UI to
      // auto-close an open chat when the scroll-triggered
      // load-more fired.
      if (!isLoadMore) {
        this.chatMessagesData = [];
        this.username = "";
      } else {
        console.log('📄 getUser: load-more - preserving open conversation state');
      }

      // ========================================
      // 🔥 FIX: ALWAYS FETCH FROM API WHEN STATUS CHANGES
      // ========================================
      
      if (isLoadMore && !statusChanged) {
        console.log('📡 LoadMore: Fetching from API');
        
        const apiParams = {
          ClientID: process.env.VUE_APP_CLIENT_ID,
          AccessToken: localStorage.getItem("jwt"),
          Start: start,
          Count: 10,
          Kodemb: JSON.parse(localStorage.getItem("user")).Company.CompanyCode
        };
        
        if (currentStatus !== 'all') {
          apiParams.status = currentStatus;
        }
        
        console.log('📡 API Request:', apiParams);
        
        try {
          const response = await axios.get(`${process.env.VUE_APP_URL_API}customer-api/getCustomerData`, {
            params: apiParams
          });

          console.log('📥 API Response:', {
            status: response.status,
            metaCode: response.data?.Meta?.Code,
            dataCount: response.data?.Data?.length || 0
          });

          if (response.data.Meta.Code == 200 && response.data.Data && response.data.Data.length > 0) {
            const newData = response.data.Data;
            console.log('✅ API returned:', newData.length, 'new items');
            
            const beforeCount = this.pages.data.Data.length;
            
            newData.forEach(item => {
              const exists = this.pages.data.Data.find(el => el.ID === item.ID);
              if (!exists) {
                this.pages.data.Data.push(item);
              }
            });
            
            console.log('✅ Merged:', {
              before: beforeCount,
              after: this.pages.data.Data.length,
              added: this.pages.data.Data.length - beforeCount
            });
            
          } else {
            console.warn('⚠️ No more data from API');
            this.finishedContacts = true;
          }
        } catch (error) {
          console.error('❌ API error:', error.message);
        }
        
      } else {
        // ========================================
        // 🔥 FIX: ALWAYS FETCH FROM API ON STATUS CHANGE OR INITIAL LOAD
        // ========================================
        
        console.log('🌐 Fetching from API (status:', currentStatus, ')');
        
        const apiParams = {
          ClientID: process.env.VUE_APP_CLIENT_ID,
          AccessToken: localStorage.getItem("jwt"),
          Start: 0,
          Count: this.itemsInPages,
          Kodemb: JSON.parse(localStorage.getItem("user")).Company.CompanyCode
        };
        
        // 🔥 CRITICAL: Add status parameter for filtering
        if (currentStatus !== 'all') {
          apiParams.status = currentStatus;
        }
        
        // console.log('📡 API Request with status:', apiParams);
        
        try {
          const response = await axios.get(`${process.env.VUE_APP_URL_API}customer-api/getCustomerData`, {
            params: apiParams
          });

          console.log('📥 API Response:', {
            status: response.status,
            metaCode: response.data?.Meta?.Code,
            dataCount: response.data?.Data?.length || 0
          });

          if (response.data.Meta.Code == 200) {
            this.pages = response;
            console.log('✅ Set pages from API:', this.pages.data.Data.length, 'items with status:', currentStatus);
          } else {
            this.pages = { data: { Data: [] } };
            console.error('❌ API returned non-200');
          }
        } catch (error) {
          console.error('❌ API error:', error.message);
          this.pages = { data: { Data: [] } };
        }
      }

      // ========================================
      // SORT & SAVE TO INDEXEDDB (PER STATUS)
      // ========================================
      
      if (!this.pages.data.Data || !Array.isArray(this.pages.data.Data)) {
        console.warn('⚠️ Invalid pages.data.Data');
        this.pages.data.Data = [];
      }

      console.log('📊 Total data:', this.pages.data.Data.length);

      if (this.pages.data.Data.length > 0) {
        try {
          // Sort
          this.pages.data.Data.sort((a, b) => 
            this.toTimeStamp(b.TimestampLastChat) - this.toTimeStamp(a.TimestampLastChat)
          );
          console.log('✅ Data sorted');
          
          // 🔥 FIX: Save to IndexedDB with status key
          if (isLoadMore && !statusChanged) {
            const newItems = this.pages.data.Data.slice(start, this.pages.data.Data.length);
            
            console.log('💾 Saving NEW items to IndexedDB:', {
              start: start,
              total: this.pages.data.Data.length,
              newItems: newItems.length,
              status: currentStatus
            });
            
            if (newItems.length > 0) {
              const cleanedItems = newItems.map(item => this.cleanObjectForIndexedDB(item));
              await this.addCustomerToDB(cleanedItems, currentStatus); // Pass status
              console.log('✅ Saved', cleanedItems.length, 'items to IndexedDB');
            }
          } else {
            console.log('💾 Saving ALL items to IndexedDB:', this.pages.data.Data.length, 'status:', currentStatus);
            
            await this.cleanDataDB(currentStatus); // Clear only current status
            
            const cleanedItems = this.pages.data.Data.map(item => this.cleanObjectForIndexedDB(item));
            await this.addCustomerToDB(cleanedItems, currentStatus); // Pass status
            console.log('✅ Saved to IndexedDB for status:', currentStatus);
          }
        } catch (error) {
          console.error('❌ Error processing data:', error);
        }
      }

      // ========================================
      // PROCESS CONTACTS (UI RENDERING)
      // ========================================
      
      console.log('📊 Processing contacts...');

      if (this.pages.data.Data.length !== 0) {
        
        if (!this.whatsappStatus) {
          console.log('⚠️ WhatsApp not ready');
          this.shimmerOn = false;

          for (let _i = start; _i < this.pages.data.Data.length; _i++) {
            const item = this.pages.data.Data[_i];
            
            let Tag = [];
            if (item.Tags && Array.isArray(item.Tags)) {
              item.Tags.forEach(element => {
                if (element && element.Title) {
                  Tag.push(element.Title);
                }
              });
            }

            this.chatData.push({
              id: item.ID,
              image: item.Avatar?.Original || this.profile,
              name: item.Name,
              telp: parseInt(item.Phone),
              message: "<i>WhatsApp not ready</i>",
              hasMedia: false,
              ack: 0,
              Tags: Tag.join(","),
              timestamp: item.CreatedTime,
              unread_count: 0,
              fromMe: false,
              status: item.Status,
              firstTimeChat: item.CreatedTime,
              shimmer: false,
              type: "chat"
            });
          }
          
          this.fetchChatRoom = false;
          console.log('⚠️ WhatsApp not ready. Loaded:', this.chatData.length);
          return;
        }

        // WhatsApp ready
        console.log('✅ WhatsApp ready - processing');
        this.shimmerOn = false;

        // Build chat data with shimmer
        for (let _idx = start; _idx < this.pages.data.Data.length; _idx++) {
          const contactItem = this.pages.data.Data[_idx];
          
          let Tag = [];
          if (contactItem.Tags && Array.isArray(contactItem.Tags)) {
            contactItem.Tags.forEach(element => {
              if (element && element.Title) {
                Tag.push(element.Title);
              }
            });
          }

          // 🔥 FIX: Use status-specific cache
          let cacheChatData = null;
          const cacheKey = `ChatData_${currentStatus}`;
          if (localStorage.getItem(cacheKey)) {
            try {
              const chatDataCache = JSON.parse(localStorage.getItem(cacheKey));
              if (Array.isArray(chatDataCache)) {
                cacheChatData = chatDataCache.find(el => {
                  return parseInt(el.id) === parseInt(contactItem.ID);
                });
              }
            } catch (e) {
              console.warn('⚠️ Invalid ChatData cache');
            }
          }

          let chatDataReadyIdx = this.chatData.findIndex(el => 
            el.id === contactItem.ID || 
            String(el.telp).replace(/\D/g, '') === String(contactItem.Phone).replace(/\D/g, '')
          );
          
          if (chatDataReadyIdx === -1) {
            this.chatData.push({
              id: contactItem.ID,
              image: contactItem.Avatar?.Original || this.profile,
              name: contactItem.Name,
              telp: parseInt(contactItem.Phone),
              message: cacheChatData?.message || "Loading...",
              hasMedia: cacheChatData?.hasMedia || false,
              ack: cacheChatData?.ack || 0,
              Tags: Tag.join(","),
              timestamp: cacheChatData?.timestamp || contactItem.CreatedTime || 0,
              unread_count: cacheChatData?.unread_count || 0,
              fromMe: cacheChatData?.fromMe || false,
              status: contactItem.Status,
              firstTimeChat: contactItem.CreatedTime,
              shimmer: true,
              type: cacheChatData?.type || "chat"
            });
          } else {
            // ✅ DEDUP FIX: Update existing entry instead of duplicating
            this.chatData[chatDataReadyIdx].id = contactItem.ID;
            this.chatData[chatDataReadyIdx].status = contactItem.Status;
            
            // Prefer name from SS if available
            if (contactItem.Name && contactItem.Name !== contactItem.Phone) {
              this.chatData[chatDataReadyIdx].name = contactItem.Name;
            }
            if (contactItem.Avatar?.Original) {
              this.chatData[chatDataReadyIdx].image = contactItem.Avatar.Original;
            }
            if (Tag.length > 0) {
              this.chatData[chatDataReadyIdx].Tags = Tag.join(",");
            }
          }
        }

        // Sort after processing all items
        this.sortChatRooms();

        console.log('📊 Chat data prepared:', this.chatData.length, 'for status:', currentStatus);

        // 🔥 FIX: Fetch chat rooms dari awal untuk mendapat semua data
        try {
          // Saat load more, kita harus fetch SEMUA chat rooms dari awal
          // karena API chat-rooms perlu data lengkap untuk update yang sudah ada
          const chatRoomsStart = isLoadMore ? 0 : 0;
          const chatRoomsCount = this.chatData.length; // Fetch semua yang ada di chatData

          console.log(`📡 Fetching chat rooms - start: ${chatRoomsStart}, count: ${chatRoomsCount}, isLoadMore: ${isLoadMore}`);

          const waGateway = await axios.post(
            process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/chat-rooms",
            {
              kodemb: JSON.parse(localStorage.getItem("user")).Company.CompanyCode,
              start: chatRoomsStart,
              count: chatRoomsCount,
              // Kirim daftar phone yang diharapkan agar backend bisa fallback ke MongoDB
              requestedPhones: this.chatData.map(c => String(c.telp)),
              ...(this.phonesFilter && this.phonesFilter.length > 0 && { phones: this.phonesFilter })
            },
            {
              headers: {
                ClientID: "abcd1234",
                AccessToken: localStorage.getItem("jwt")
              },
              timeout: 30000
            }
          );

          console.log('📥 Response:', {
            status: waGateway.data.status,
            count: Array.isArray(waGateway.data.data) ? waGateway.data.data.length : 0,
            message: waGateway.data.message,
            meta: waGateway.data.meta
          });

          if (waGateway.data.status === 200 && Array.isArray(waGateway.data.data)) {
            const chatRoomsMap = new Map();

            waGateway.data.data.forEach(room => {
              const phone = String(room.telp || room.phone);
              chatRoomsMap.set(phone, room);
            });

            console.log(`✅ Received ${chatRoomsMap.size} chat rooms`);

            // 🔥 FILTER: If phonesFilter is set, only update matching phones
            if (this.phonesFilter && this.phonesFilter.length > 0) {
              console.log('🔍 Applying phone filter:', this.phonesFilter);
              
              // Filter chatData to only include phones in phonesFilter
              this.chatData = this.chatData.filter(chatItem => {
                const phone = String(chatItem.telp);
                return this.phonesFilter.includes(phone);
              });
              
              console.log('✅ Filtered chatData to', this.chatData.length, 'items');
            }

            // 🔥 FIX: Update chat data - PRESERVE data lama jika tidak ada di response
            let updatedCount = 0;
            for (let index = 0; index < this.chatData.length; index++) {
              const chatItem = this.chatData[index];
              const phone = String(chatItem.telp);
              
              const roomData = chatRoomsMap.get(phone);
              
              if (roomData) {
                // Ada data dari API - update
                // Always update type/hasMedia/ack regardless of message body
                chatItem.hasMedia = roomData.hasMedia || false;
                chatItem.ack = roomData.ack || 0;
                chatItem.timestamp = roomData.timestamp || chatItem.firstTimeChat;
                chatItem.unread_count = roomData.unread_count || 0;
                chatItem.fromMe = roomData.fromMe || false;
                chatItem.type = roomData.type || 'chat';
                if (roomData.image) {
                  chatItem.image = roomData.image;
                }
                chatItem.shimmer = false;

                if (roomData.message && roomData.message.trim() !== '') {
                  chatItem.message = roomData.message;
                  updatedCount++;
                } else {
                  chatItem.message = '';
                }
              } else {
                // ✅ CRITICAL FIX: PRESERVE data lama jika tidak ada di response
                // Jangan set kosong! Hanya matikan shimmer jika masih loading
                if (chatItem.shimmer) {
                  // Item baru yang belum punya data - set default
                  chatItem.message = '';
                  chatItem.hasMedia = false;
                  chatItem.ack = 0;
                  chatItem.timestamp = chatItem.firstTimeChat;
                  chatItem.unread_count = 0;
                  chatItem.fromMe = false;
                  chatItem.type = 'chat';
                }
                // Jika sudah punya data (shimmer=false), JANGAN DIUBAH!
                chatItem.shimmer = false;
              }
            }

            console.log('✅ Updated:', updatedCount, 'items');

            this.sortChatRooms();
            this.cachingChatData(currentStatus); // Pass status to cache
            
            console.log('✅ Chat rooms updated for status:', currentStatus);
          } else {
            console.error('❌ Invalid response');
            
            this.chatData.forEach(chat => {
              chat.message = '';
              chat.shimmer = false;
              chat.timestamp = chat.firstTimeChat;
            });
          }
        } catch (error) {
          console.error('❌ Chat rooms error:', error.message);
          
          this.chatData.forEach(chat => {
            chat.message = '<i>Failed to load</i>';
            chat.shimmer = false;
            chat.timestamp = chat.firstTimeChat;
          });
        }
        
      } else {
        this.shimmerOn = false;
        console.log('ℹ️ No contacts for status:', currentStatus);
      }
      
      this.fetchChatRoom = false;
      console.log('✅ getUser completed:', {
        status: currentStatus,
        pagesData: this.pages.data.Data.length,
        chatData: this.chatData.length
      });
    },
    cachingChatData() {
      const key = "ChatData";
      let isChatCahche = localStorage.getItem(key);
      let dataLocal = this.chatData;
      if (isChatCahche) {
        dataLocal = JSON.parse(isChatCahche);
        this.chatData.forEach(item => {
          const existingIdx = dataLocal.findIndex(el => el.id == item.id);
          if (existingIdx === -1) {
            dataLocal.push(item);
          } else {
            dataLocal[existingIdx] = item;
          }
        });
      }
      localStorage.setItem(key, JSON.stringify(dataLocal));
    },
    toTimeStamp(date) {
      return new Date(Date.parse(date)).getTime() / 1000
    },
    async pushToTop(phone, message) {
      console.log('🔝 pushToTop called', { phone, hasMessage: !!message });
      
      try {
        // Find chat in chatData
        const index = this.chatData.findIndex(
          el => parseInt(el.telp) === parseInt(phone) || parseInt(el.phone) === parseInt(phone)
        );
        
        if (index === -1) {
          console.log('⚠️ Chat not found in chatData, phone:', phone);
          return; // Can't push to top if not found
        }
        
        // Update message info
        if (message) {
          // Label pesan dokumen diubah menjadi unsupported content message
          const mediaLabel = { image: 'Image', video: 'Video', document: 'unsupported content message', audio: 'Audio', sticker: 'Sticker' };
          const isMedia = message.hasMedia || (message.type && message.type !== 'chat' && message.type !== 'revoked');
          this.chatData[index].message = isMedia ? (mediaLabel[message.type] || 'Media') : (message.body || '');
          this.chatData[index].timestamp = message.timestamp || Date.now();
          this.chatData[index].ack = message.ack || 0;
          this.chatData[index].fromMe = message.fromMe || false;
          this.chatData[index].hasMedia = message.hasMedia || false;
          this.chatData[index].type = message.type || 'chat';
        }
        
        // Move to top
        const chatItem = this.chatData.splice(index, 1)[0];
        this.chatData.unshift(chatItem);
        
        console.log('✅ Chat moved to top:', chatItem.name);
        
      } catch (error) {
        console.error('❌ Error in pushToTop:', error);
      }
    },
    sortChatRooms() {
      this.chatData.sort((a, b) => b.timestamp - a.timestamp);
    },
    convertToDateTime(timestamp) {
      var dateTime = dayjs.unix(timestamp)
      return dateTime;
    },
    chatRoomTime(timestamp) {
      // var dateTime = new Date(parseInt(timestamp) * 1000);
      var dateTime = this.convertToDateTime(timestamp);
      return dayjs().to(dayjs(dateTime));
    },
    chatConvertationTime(timestamp) {
      // var dateTime = new Date(parseInt(timestamp) * 1000);
      let dateTime = dayjs(parseInt(timestamp) * 1000);
      return dayjs().calendar(dateTime, {
        sameDay: '[Today at]',
        nextDay: '[Yesterday at]',
        nextWeek: 'dddd',
        lastDay: '[Tomorrow at]',
        lastWeek: '[Last] dddd',
        sameElse: '['+dayjs(parseInt(timestamp) * 1000).format("DD-MM-YYYY")+' at]',
      })+" "+dayjs(parseInt(timestamp) * 1000).format("HH:mm");
    },
    async storeChat(msg) {
      const res = msg;
      const chatFrom = res.from.split("@");

      // const dataCustomer = {
      //   "name": res._data.notifyName,
      //   "phone": chatFrom[0]
      // }

      const formData = new FormData();
      formData.append("nama", res._data.notifyName);
      formData.append("phone", chatFrom[0]);

      // for debugging allow save number
      const validation = [
        62895326339070, 6285655401980, 628977219772, 628996752029,
      ];

      const isValid = validation.some((el) => el === parseInt(chatFrom[0]));

      if (isValid) {
        // store chat in db
        await axios
          .post(
            process.env.VUE_APP_BASE_URL + "api-helper/storeUserChat",
            formData
          )
          .then((response) => {
            if (response.data.Code == 200) {
              this.getUser("all");
            }
          })
          .catch(() => {
            // intentionally empty
          });
      }
    },
    closeProfileSidebar() {
      console.log('🚪 [DEBUG] Closing profile sidebar');
      const closeBtn = document.getElementById('btnCanvasClose');
      if (closeBtn) {
        closeBtn.click();
      }
    },
    async assignAgent(agent_id, customerID) {
      console.log('🚀 [DEBUG] Method Triggered: assignAgent', { agent_id, customerID });
      try {
        const currentUser = this.user || JSON.parse(localStorage.getItem("user"));
        const currentAgentID = currentUser?.AgentID || currentUser?.ID;

        console.log('📝 [DEBUG] Preparing API call for assignAgent', { customerID, agent_id, currentAgentID });

        let extaParam = "?ClientID=" + process.env.VUE_APP_CLIENT_ID + "&AccessToken=" + localStorage.getItem("jwt")
        let url = process.env.VUE_APP_URL_API + "customer-api/changeStatus" + extaParam

        let formData = new FormData();
        formData.append("Status", 1);
        formData.append("CustomerID", customerID);
        formData.append("AgentID", agent_id);

        console.log('📡 [DEBUG] Sending POST request to:', url);
        const changeStatus = await axios.post(url, formData)
        let data = changeStatus.data
        console.log('📥 [DEBUG] API response:', data);

        if (data.Meta.Code !== 200) {
          throw new Error(data.Meta.Message || 'Failed to assign agent');
        }

        this.Toast.fire({
          icon: 'success',
          title: data.Meta.Message
        });

        this.userStatus = "assigned";
        
        // 🔥 RECTIVE UI SYNC:
        // If NOT assigned to me (and I am an agent), remove from list
        // Note: Principals usually want to keep seeing it in 'Assigned' tab
        const isPrincipal = currentUser?.Jabatan?.Code === 'principal';
        
        if (!isPrincipal && parseInt(agent_id) !== parseInt(currentAgentID)) {
          console.log('🗑️ [REACTIVE] Removing chat because assigned to another agent');
          let idxNowChatData = this.chatData.findIndex(el => parseInt(el.id) === parseInt(customerID));
          if (idxNowChatData !== -1) {
            this.chatData.splice(idxNowChatData, 1);
          }
        } else {
          // Just update status
          let idxNowChatData = this.chatData.findIndex(el => parseInt(el.id) === parseInt(customerID));
          if (idxNowChatData !== -1) {
            this.chatData[idxNowChatData]['status'] = this.userStatus;
          }
        }

        await this.refreshContact();
        this.closeProfileSidebar();

        // 🚀 [CLIENT-PUSH] Direct notify Node for instant room-wide sync
        if (this.socket) {
          console.log('📡 [CLIENT-PUSH] Notifying Node of assignment change');
          this.socket.emit('client_assignment_sync', {
            type: 'assign',
            customerID: customerID,
            phone: this.phoneNumber,
            agentID: agent_id
          });
        }
      } catch (error) {
        console.error('❌ [CRITICAL] assignAgent failed:', error);
        this.Toast.fire({
          icon: 'error',
          title: 'Gagal Assign: ' + error.message
        });
      }
    },
    async openConvertation() {
      var kodemb = JSON.parse(localStorage.getItem("user")).Company.CompanyCode;

      const convertation = await axios.post(
        process.env.VUE_APP_WA_BASE_URL +
        "api/waha/whatsapp/conversation?clientid=abcd1234",
        {
          phone: String(this.$route.params.id).replace(/\D/g, ''),
          limit: 25,
          fetched: this.chatMessagesData.length,
          kodemb,
        }
      );

      if (convertation.data.status == 200) {
        this.chatMessagesData = [];
        convertation.data.data.forEach((item) => {
          const regexItalic = /(_)([^_]+?)(_)/gs;
          const regexBold = /(\*)([^*]+?)(\*)/gs;

          var body = item.body;
          body = body.replace(regexItalic, `<i>$2</i>`);
          body = body.replace(regexBold, `<b>$2</b>`);

          this.chatMessagesData.push({
            align: item.fromMe === true ? "right" : "",
            name: this.username,
            message: body,
            time: item.timestamp,
            ack: item.ack,
            media: item.downloadedMedia
              ? item.downloadedMedia.data
              : item._data.body,
            fromMe: item.fromMe,
            phone: this.phoneNumber,
          });
        });

        var currentChatId = "users-chat";
        this.scrollToBottom(currentChatId);
      }
    },
    imageSend() {
      this.showFormUpload = true;
    },
    closeFormUpload() {
      this.showFormUpload = false;
      this.files = []
      this.dropzoneFile = ""
      this.imagesPreview = ""
      this.$nextTick(() => {
        try { this.scrollToBottom('users-chat'); } catch (err) { console.warn('scrollToBottom failed after closeFormUpload', err); }
      });
    },
    deleteRecord(ele) {
      ele.target.parentElement.parentElement.remove();
      this.files = []
      this.dropzoneFile = ""
      this.imagesPreview = ""
    },
    showMessageNotif(data) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      const resChat = JSON.parse(data);
      // Ubah label notifikasi tipe dokumen menjadi unsupported content message
      const mediaTypeLabel = { image: '📷 Image', video: '🎥 Video', document: '📄 unsupported content message', audio: '🎵 Audio', sticker: '🖼️ Sticker' };
      const isMedia = resChat.hasMedia || (resChat.type && resChat.type !== 'chat' && resChat.type !== 'revoked');
      const notifText = isMedia
        ? (mediaTypeLabel[resChat.type] || '📎 Media')
        : (resChat.body || '');
      Toast.fire({
        title: (resChat._data?.notifyName || resChat.notifyName || '').toUpperCase(),
        text: notifText,
      });
    },
    async resolveCustomer(status) {
      var indexCust = this.chatData.findIndex(
        (cust) => parseInt(cust.telp) === parseInt(this.phoneNumber)
      );

      var headers = new Headers();
      headers.append("ClientID", process.env.VUE_APP_CLIENT_ID);
      headers.append("AccessToken", localStorage.getItem("jwt"));

      var bodyParam = new FormData();
      bodyParam.append("Status", status);
      bodyParam.append("CustomerID", this.chatData[indexCust].id);
      if (status == 1) {
        bodyParam.append("AgentID", 0);
      } else {
        bodyParam.append("AgentID", parseInt(localStorage.getItem("userid")));
      }

      var query = `?ClientID=${process.env.VUE_APP_CLIENT_ID
        }&AccessToken=${localStorage.getItem("jwt")}`;
      const setStatus = await axios.post(
        process.env.VUE_APP_URL_API + "customer-api/changeStatus" + query,
        bodyParam
      );
      const res = setStatus.data;
      const chatDataNow = this.chatData[indexCust];
      if (res.Meta.Code === 200) {
        if (status === 3) {
          chatDataNow['status'] = 'resolved';
          this.userStatus = 'resolved';
          document
            .getElementById("chatInput")
            .setAttribute("disabled", "disabled");
          document
            .getElementById("chatInput")
            .setAttribute("placeholder", "Customer Is Resolved");
          document
            .getElementById("btnSendMessage")
            .setAttribute("disabled", "disabled");
        } else {
          chatDataNow['status'] = 'assigned';
          this.userStatus = 'assigned';
          document.getElementById("btnCanvasClose").click();
          document.getElementById("chatInput").removeAttribute("disabled");
          document.getElementById("btnSendMessage").removeAttribute("disabled");
          document.getElementById("chatInput").setAttribute("placeholder", "Enter Message...")
        }
      }

      await this.refreshContact();
      this.closeProfileSidebar();
    },
    async saveEdit() {
      let tagSave = [];
      if (this.tagValue) {
        this.tagValue.map((item) => {
          var checkTagOption = this.tagoption.findIndex(
            (idx) => idx.value === item
          );
          if (checkTagOption !== -1)
            tagSave.push({
              ID: item,
              Title: this.tagoption[checkTagOption].label,
            });
          else
            tagSave.push({
              ID: 0,
              Title: item,
            });
        });
      }

      const dataEdit = new FormData();
      dataEdit.append("ID", this.userid);
      dataEdit.append("Note", this.note);
      dataEdit.append("Tags", JSON.stringify(tagSave));

      var ClientID = process.env.VUE_APP_CLIENT_ID;
      var AccessToken = localStorage.getItem("jwt");

      const saveEdited = await axios
        .post(
          process.env.VUE_APP_URL_API +
          "customer-api/editCustomer?ClientID=" +
          ClientID +
          "&AccessToken=" +
          AccessToken,
          dataEdit
        )
        .then((response) => {
          return response;
        })
        .catch((er) => {
          return er;
        });

      var responseStatusCode = saveEdited.data.Meta.Code;
      var responseStatusMsg = saveEdited.data.Meta.Message;

      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      if (responseStatusCode != 200) {
        Toast.fire({
          icon: "error",
          title: responseStatusMsg,
        });
      } else {
        var index = this.chatData.findIndex(
          (item) => item.telp === this.phoneNumber
        );
        this.chatData[index].Tags = tagSave
          .map((el) => {
            return el.Title;
          })
          .join(",");
        Toast.fire({
          icon: "success",
          title: responseStatusMsg,
        });
      }
    },
    async downloadMedia(idx_chat) {
      // Re-lookup by chatID in case the index shifted after re-renders
      let messageData = this.chatMessagesData[idx_chat];
      console.log('[downloadMedia] idx_chat:', idx_chat, '| messageData:', messageData ? { chatID: messageData.chatID, type: messageData.type } : null, '| array length:', this.chatMessagesData.length);
      if (!messageData) {
        console.error('[downloadMedia] idx_chat out of range:', idx_chat, '| array length:', this.chatMessagesData.length);
        this.Toast.fire({ title: 'Pesan tidak ditemukan, coba refresh chat', icon: 'warning' });
        return;
      }

      // Guard against double-download
      if (messageData._downloading) return;

      // Mark as downloading to prevent duplicate requests
      const updatedLoading = { ...messageData, _downloading: true };
      this.chatMessagesData.splice(idx_chat, 1, updatedLoading);
      messageData = updatedLoading;

      const postData = {
        phone: messageData.phone,
        fetched: ((this.chatMessagesData.length - idx_chat) + 10),
        kodemb: JSON.parse(localStorage.getItem("user")).Company.CompanyCode,
        message_id: messageData.chatID,
        show_log: false
      };

      try {
        const response = await axios.post(process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/download-media", postData, {
          headers: { clientid: 'abcd1234' },
          timeout: 30000
        });

        // Re-find by chatID after async (array may have shifted)
        const currentIdx = this.chatMessagesData.findIndex(m => m.chatID === messageData.chatID);

        if (response.status !== 200) {
          if (currentIdx !== -1) {
            const restored = { ...this.chatMessagesData[currentIdx], _downloading: false };
            this.chatMessagesData.splice(currentIdx, 1, restored);
          }
          this.Toast.fire({ title: response.statusText || 'Download gagal', icon: 'error' });
          return;
        }

        const resData = response.data;

        if (resData.status !== 200) {
          if (currentIdx !== -1) {
            const restored = { ...this.chatMessagesData[currentIdx], _downloading: false };
            this.chatMessagesData.splice(currentIdx, 1, restored);
          }
          this.Toast.fire({ title: resData.message || 'Download gagal', icon: 'warning' });
          return;
        }

        const imageDownloaded = resData.data;
        console.log('[downloadMedia] imageDownloaded:', imageDownloaded ? { hasMedia: imageDownloaded.hasMedia, mediaKeys: imageDownloaded.media ? Object.keys(imageDownloaded.media) : null, mediaData: imageDownloaded.media?.data ? 'base64(present)' : null, mediaUrl: imageDownloaded.media?.url } : null);

        if (currentIdx !== -1 && imageDownloaded && imageDownloaded.media) {
          let fullMedia = null;
          let videoBlobUrl = null;
          let documentBlobUrl = null;
          const m = imageDownloaded.media;

          // Detect media type by mimetype OR by the stored message type
          const mimeType = (m.mimetype || '').toLowerCase();
          const isVideo = mimeType.startsWith('video') ||
            (this.chatMessagesData[currentIdx] && this.chatMessagesData[currentIdx].type === 'video');
          const isDocument = !isVideo && (
            this.chatMessagesData[currentIdx] && this.chatMessagesData[currentIdx].type === 'document'
          );

          if (m.data) {
            if (isVideo) {
              // Convert base64 → Blob URL for playback. Stored separately from thumbnail.
              try {
                const blob = this.base64ToBlob(m.data, m.mimetype || 'video/mp4');
                videoBlobUrl = URL.createObjectURL(blob);
                // If no thumbnail provided, try to generate one from the video blob
                if (!fullMedia && videoBlobUrl) {
                  try {
                    const thumb = await this.generateVideoThumbnail(videoBlobUrl, 0.5);
                    if (thumb) fullMedia = thumb;
                  } catch (e) {
                    console.warn('[downloadMedia] generate thumbnail failed', e);
                  }
                }
              } catch (e) {
                console.warn('[downloadMedia] blob conversion failed, falling back to data URI', e);
                videoBlobUrl = 'data:' + (m.mimetype || 'video/mp4') + ';base64,' + m.data;
                if (!fullMedia && videoBlobUrl && videoBlobUrl.startsWith('data:')) {
                  try {
                    const thumb = await this.generateVideoThumbnail(videoBlobUrl, 0.5);
                    if (thumb) fullMedia = thumb;
                  } catch (e) {
                    console.warn('[downloadMedia] generate thumbnail failed', e);
                  }
                }
              }
            } else if (isDocument) {
              // Convert to blob for file download with proper extension
              try {
                const blob = this.base64ToBlob(m.data, m.mimetype || 'application/octet-stream');
                documentBlobUrl = URL.createObjectURL(blob);
              } catch (e) {
                console.warn('[downloadMedia] doc blob conversion failed', e);
                documentBlobUrl = 'data:' + (m.mimetype || 'application/octet-stream') + ';base64,' + m.data;
              }
            } else {
              fullMedia = 'data:' + (m.mimetype || 'image/jpeg') + ';base64,' + m.data;
            }
          } else if (m.url) {
            fullMedia = m.url;
          }

          if (!fullMedia && !videoBlobUrl && !documentBlobUrl) {
            if (currentIdx !== -1) {
              const restored = { ...this.chatMessagesData[currentIdx], _downloading: false };
              this.chatMessagesData.splice(currentIdx, 1, restored);
            }
            this.Toast.fire({ title: 'Media tidak dapat dimuat (url dan data kosong)', icon: 'warning' });
            return;
          }

          const done = {
            ...this.chatMessagesData[currentIdx],
            // For video/document: keep the original thumbnail in 'media'; store blob separately
            media: (isVideo || isDocument) ? this.chatMessagesData[currentIdx].media : fullMedia,
            videoBlobUrl: videoBlobUrl,
            documentBlobUrl: documentBlobUrl,
            downloadImage: false,
            _downloading: false,
            style: { filter: 'blur(0px)' },
            // Update type when download reveals the actual media type
            type: isVideo ? 'video' : (isDocument ? 'document' : this.chatMessagesData[currentIdx].type)
          };
          this.chatMessagesData.splice(currentIdx, 1, done);

          this.Toast.fire({ title: 'Media berhasil dimuat', icon: 'success', timer: 1500 });

          // Auto-open/download media based on type
          this.$nextTick(() => {
            if (isVideo) {
              this.videoFileName = (done.fileName || 'video') + '.mp4';
              this.videoModalUrl = videoBlobUrl;
              this.showVideoModal = true;
              // Wait one more tick so <video ref="videoPlayer"> is mounted before calling play
              this.$nextTick(() => this.tryPlayVideo());
            } else if (isDocument) {
              // Auto-trigger file download
              this.downloadDocument(documentBlobUrl, done.fileName || 'document');
            } else {
              this.openModal = true;
              this.imageModal = fullMedia;
              this.captionModal = messageData.message || '';
              this.sourcesImages = fullMedia;
              this.toggler = !this.toggler;
            }
          });
        } else {
          if (currentIdx !== -1) {
            const restored = { ...this.chatMessagesData[currentIdx], _downloading: false };
            this.chatMessagesData.splice(currentIdx, 1, restored);
          }
          console.warn('[downloadMedia] No media in response:', JSON.stringify(resData));
          this.Toast.fire({ title: resData.message || 'Media tidak tersedia', icon: 'warning' });
        }
      } catch (e) {
        const currentIdx = this.chatMessagesData.findIndex(m => m.chatID === messageData.chatID);
        if (currentIdx !== -1) {
          const restored = { ...this.chatMessagesData[currentIdx], _downloading: false };
          this.chatMessagesData.splice(currentIdx, 1, restored);
        }
        this.Toast.fire({ title: 'Gagal download media: ' + (e.message || ''), icon: 'error' });
      }
    },
    async unassign(status, agent_id) {
      console.log('🚀 [DEBUG] Method Triggered: unassign', { status, agent_id, customerID: this.userid });
      try {
        let customerID = this.userid;
        const currentUser = this.user || JSON.parse(localStorage.getItem("user"));
        const currentAgentID = currentUser?.AgentID || currentUser?.ID;
        
        console.log('📝 [DEBUG] Preparing API call for unassign', { customerID, currentAgentID });

        let extaParam = "?ClientID=" + process.env.VUE_APP_CLIENT_ID + "&AccessToken=" + localStorage.getItem("jwt")
        let url = process.env.VUE_APP_URL_API + "customer-api/changeStatus" + extaParam

        let formData = new FormData();
        formData.append("Status", status);
        formData.append("CustomerID", customerID);
        formData.append("AgentID", agent_id);

        console.log('📡 [DEBUG] Sending POST request to:', url);
        const changeStatus = await axios.post(url, formData)
        let data = changeStatus.data
        console.log('📥 [DEBUG] API response:', data);

        if (data.Meta.Code !== 200) {
          throw new Error(data.Meta.Message || 'Failed to change status');
        }

        this.Toast.fire({
          icon: 'success',
          title: data.Meta.Message
        });

        // Update local state for the agent handled list
        let indexAgentremove = this.agentHandle.findIndex(el => parseInt(el.ID) === parseInt(agent_id));
        if (indexAgentremove !== -1) {
          this.agentHandle.splice(indexAgentremove, 1);
        }

        // 🔥 RECTIVE UI SYNC:
        // If the unassigned agent is the CURRENT agent, remove from sidebar immediately
        if (parseInt(agent_id) === parseInt(currentAgentID)) {
          console.log('🗑️ [REACTIVE] Removing chat from list because I unassigned myself');
          let chatDataIndex = this.chatData.findIndex(el => parseInt(el.id) === parseInt(customerID));
          if (chatDataIndex !== -1) {
            this.chatData.splice(chatDataIndex, 1);
            
            // If current open chat is the unassigned one, close it
            if (this.userid === customerID) {
              console.log('🏠 [REACTIVE] Closing current chat view');
              this.userid = null;
              this.phoneNumber = null;
            }
          }
        } else {
          // Just update status for others visibility
          let chatDataIndex = this.chatData.findIndex(el => parseInt(el.id) === parseInt(customerID));
          if (chatDataIndex !== -1) {
            this.chatData[chatDataIndex]['status'] = 'unassigned';
          }
        }

        await this.refreshContact();
        this.closeProfileSidebar();

        // 🚀 [CLIENT-PUSH] Direct notify Node for instant room-wide sync
        if (this.socket) {
          console.log('📡 [CLIENT-PUSH] Notifying Node of unassignment');
          this.socket.emit('client_assignment_sync', {
            type: 'unassign',
            customerID: customerID,
            phone: this.phoneNumber,
            agentID: agent_id
          });
        }
      } catch (error) {
        console.error('❌ [CRITICAL] unassign failed:', error);
        this.Toast.fire({
          icon: 'error',
          title: 'Gagal Unassign: ' + error.message
        });
      }
    },
    loadMoreContact(el) {
      var self = this;
      el.addEventListener("scroll", () => {
        let scrolPosisi = Math.round((el.scrollTop + 1) + el.getBoundingClientRect().height);
        if (scrolPosisi >= el.scrollHeight && !self.isLoadingContacts && !self.finishedContacts) {
          self.isLoadingContacts = true;
          let start = self.chatData.length
          let to = self.itemsInPages + self.chatData.length
          
          setTimeout(async () => {
            let statusActive = document.querySelector("ul.tabStatus > li.tabLi > a.active")
            let statusTabs = statusActive ? statusActive.getAttribute("data-status") : 'all'
            
            let length = 0;
            try {
              let contact = await axios.get(`${process.env.VUE_APP_URL_API}customer-api/countCustomer`,{
                params: {
                  ClientID: process.env.VUE_APP_CLIENT_ID,
                  AccessToken: localStorage.getItem("jwt"),
                  Kodemb: JSON.parse(localStorage.getItem("user")).Company.CompanyCode,
                  Status: statusTabs
                }
              });
              
              if(contact.status == 200){
                length = contact.data.Data;
              }
            } catch (error) {
              console.error('Error counting customers:', error);
            }

            if (start < length) {
              console.log('🔄 Loading more contacts:', { start, to, total: length });
              await self.getUser(statusTabs, start, to, true);
            } else {
              self.finishedContacts = true;
              console.log('✅ No more contacts to load');
            }
            self.isLoadingContacts = false;
          }, 600);
        }
      })
    },
    async refreshChatRoom() {
      console.log('🔄 Refreshing chat rooms from API');
      
      this.fetchChatRoom = true;
      
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const kodemb = user.Company.CompanyCode;
        
        console.log('📤 Sending request with kodemb:', kodemb);
        console.log('📤 User data:', user);
        
        const response = await axios.post(
          process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/chat-rooms",
          {
            kodemb: kodemb,
            ...(this.phonesFilter && this.phonesFilter.length > 0 && { phones: this.phonesFilter })
          },
          {
            headers: { 
              clientid: "abcd1234",
              AccessToken: localStorage.getItem("jwt")
            }
          }
        );
        
        console.log('📥 Response received:', {
          status: response.data.status,
          message: response.data.message,
          dataLength: response.data.data?.length || 0,
          meta: response.data.meta
        });
        
        if (response.data.status === 200) {
          console.log('✅ Chat rooms refreshed:', response.data.data?.length || 0);
          
          let filteredData = response.data.data || [];
          
          // 🔥 FILTER: If phonesFilter is set, only include matching phones
          if (this.phonesFilter && this.phonesFilter.length > 0) {
            console.log('🔍 Applying phone filter to refresh:', this.phonesFilter);
            filteredData = filteredData.filter(chat => {
              const phone = String(chat.telp || chat.phone);
              return this.phonesFilter.includes(phone);
            });
            console.log('✅ Filtered refresh data to', filteredData.length, 'items');
          }
          
          // Merge ke chatData yang sudah ada - JANGAN replace agar image tidak hilang
          const refreshMap = new Map();
          filteredData.forEach(room => {
            const phone = String(room.telp || room.phone);
            refreshMap.set(phone, room);
          });

          for (const chatItem of this.chatData) {
            const phone = String(chatItem.telp);
            const roomData = refreshMap.get(phone);
            if (roomData) {
              chatItem.hasMedia = roomData.hasMedia || false;
              chatItem.ack = roomData.ack || 0;
              chatItem.timestamp = roomData.timestamp || chatItem.firstTimeChat;
              chatItem.unread_count = roomData.unread_count || 0;
              chatItem.fromMe = roomData.fromMe || false;
              chatItem.type = roomData.type || 'chat';
              // Hanya update image jika API mengembalikan nilai - jangan nol-kan
              if (roomData.image) {
                chatItem.image = roomData.image;
              }
              chatItem.shimmer = false;
              if (roomData.message && roomData.message.trim() !== '') {
                chatItem.message = roomData.message;
              }
            }
          }

          this.sortChatRooms();
          this.cachingChatData();
          
          console.log('✅ Chat rooms updated successfully');
        }
        
      } catch (error) {
        console.error('❌ Error refreshing chat rooms:', error);
      } finally {
        this.fetchChatRoom = false;
      }
    },
    async refreshContact(phone = 0) {
      console.log("refresh contact chat.vue");
      let userChat;
      let dataSave = [];
      let oldContact = await this.getAllContact();

      if(!oldContact.length){
        phone = 0;
      }

      if(phone != 0){
        console.log("Old Contact : ", oldContact);
        
        userChat = await axios.get(`${process.env.VUE_APP_URL_API}customer-api/getCustomerByPhone`, {
          params: {
            ClientID: process.env.VUE_APP_CLIENT_ID,
            AccessToken: localStorage.getItem("jwt"),
            Phone: phone
          }
        })

        let responseData = null;
        if(userChat.status == 200){
          let response = userChat.data;
          if(response.Meta.Code == 200){
            responseData = response.Data;
          }
        }

        if(responseData !== null){
          oldContact.push(responseData);
        }
        dataSave = oldContact;
      } else {
        userChat = await axios.get(`${process.env.VUE_APP_URL_API}customer-api/getCustomerData`, {
          params: {
            ClientID: process.env.VUE_APP_CLIENT_ID,
            AccessToken: localStorage.getItem("jwt"),
            Kodemb: JSON.parse(localStorage.getItem("user")).Company.CompanyCode,
            status: 'all',
            Start: 0,
            Count: 10
          }
        });

        if (userChat.data.Data !== null) {
          let sortContact = userChat.data.Data.sort((a, b) => this.toTimeStamp(b.TimestampLastChat) - this.toTimeStamp(a.TimestampLastChat))
          userChat.data.Data = sortContact
          dataSave = userChat.data.Data;
        }
      }

      await this.cleanDataDB();
      await this.addCustomerToDB(dataSave);
      await this.getUser("All");
    },
    searchChat(textSearch) {
      var searchKeyword = textSearch.toLocaleLowerCase();

      if (searchKeyword !== '' && searchKeyword.length >= 2) {
        let dataSearch = this.chatMessagesData.filter((data) => {
          return data.message.includes(searchKeyword);
        });

        this.resultSearchMessage = dataSearch;

        /* for (let _idx = 0; _idx < dataSearch.length; _idx++) {
          const item = dataSearch[_idx];
          let idxChat = this.chatMessagesData.findIndex(el => el.chatID === item.chatID);
          let message = this.chatMessagesData[idxChat]['message'].toLowerCase().trim();
          let startIdxMsg = message.indexOf(searchKeyword);
          let subMessage = message.substr(startIdxMsg);
          let splitMessage = subMessage.split(" ")[0];
          let lengthSearch = splitMessage.length;
          let msg = subMessage.substr(0, lengthSearch);
          let messageMark = `<mark>${msg}</mark>`;
          let re = new RegExp(msg, "g");
          this.chatMessagesData[idxChat]['message'] = message.replace(re, messageMark);
        } */
      }
    },
    debounce(func, timeout = 300) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(func, timeout);
    },
    goToMessageSearch(data) {
      let idxChatClick = this.chatMessagesData.findIndex(el => {
        return data.chatID === el.chatID;
      })
      this.chatMessagesData[idxChatClick]['showHightlight'] = true;

      let elementChat = document.querySelector(`#buble-${idxChatClick}`)
      elementChat.scrollIntoView();
    },
    
    scrollToMessage(messageData) {
      console.log('🔍 Scrolling to message:', messageData);
      
      // Cari pesan berdasarkan message_id, id, atau chatID
      let messageIndex = -1;
      
      // Priority 1: message_id (dari search backend)
      if (messageData.message_id) {
        messageIndex = this.chatMessagesData.findIndex(msg => 
          msg.message_id === messageData.message_id || 
          msg.id === messageData.message_id ||
          msg.chatID === messageData.message_id
        );
      }
      
      // Priority 2: id (database ID)
      if (messageIndex === -1 && messageData.id) {
        messageIndex = this.chatMessagesData.findIndex(msg => 
          msg.id === messageData.id
        );
      }
      
      // Priority 3: chatID (jika messageData punya chatID)
      if (messageIndex === -1 && messageData.chatID) {
        messageIndex = this.chatMessagesData.findIndex(msg => 
          msg.chatID === messageData.chatID
        );
      }
      
      // Priority 4: timestamp (jika unik)
      if (messageIndex === -1 && messageData.timestamp) {
        messageIndex = this.chatMessagesData.findIndex(msg => 
          Math.abs(msg.timestamp - messageData.timestamp) < 1000 // within 1 second
        );
      }
      
      console.log('🔍 Search result - messageIndex:', messageIndex);
      console.log('🔍 messageData keys:', Object.keys(messageData));
      console.log('🔍 First few chatMessagesData:', this.chatMessagesData.slice(0, 3).map((m, i) => ({ index: i, id: m.id, message_id: m.message_id, chatID: m.chatID, timestamp: m.timestamp })));
      
      if (messageIndex !== -1) {
        console.log('✅ Found message at index:', messageIndex);
        
        // ✅ Reset retry count on success
        this.loadMoreRetryCount = 0;
        
        // Highlight pesan
        this.chatMessagesData[messageIndex]['showHightlight'] = true;
        
        // Scroll ke pesan
        const elementChat = document.querySelector(`#buble-${messageIndex}`);
        if (elementChat) {
          elementChat.scrollIntoView({ behavior: 'smooth', block: 'center' });
          
          // Hapus highlight setelah 3 detik
          setTimeout(() => {
            if (this.chatMessagesData[messageIndex]) {
              this.chatMessagesData[messageIndex]['showHightlight'] = false;
            }
          }, 3000);
        } else {
          console.warn('❌ Element not found for message index:', messageIndex);
        }
      } else {
        console.warn('❌ Message not found in chatMessagesData, attempting to load more...');
        
        // ✅ Jika tidak ditemukan, coba load more messages
        this.loadMoreMessagesForSearch(messageData);
      }
    },
    
    async loadMoreMessagesForSearch(messageData) {
      // ✅ Prevent infinite loop - max 3 retries
      if (this.loadMoreRetryCount >= 3) {
        console.warn('❌ Max retry reached for loading messages');
        this.loadMoreRetryCount = 0; // Reset for next search
        return;
      }
      
      // Prevent if already have too many messages (likely reached the end)
      if (this.chatMessagesData.length > 200) {
        console.warn('Too many messages loaded, likely reached conversation end');
        this.loadMoreRetryCount = 0;
        return;
      }
      
      // ✅ Prevent concurrent load more
      if (this.isLoadingMore) {
        console.log('Load more already in progress, waiting...');
        setTimeout(() => this.loadMoreMessagesForSearch(messageData), 1000);
        return;
      }
      
      this.loadMoreRetryCount++;
      console.log('Loading more messages (attempt', this.loadMoreRetryCount, ') to find:', messageData.id);
      
      // Simulasi scroll ke atas untuk trigger load more
      const chatContainer = document.getElementById('users-chat');
      if (chatContainer) {
        const simpleBar = chatContainer.querySelector('.simplebar-content-wrapper');
        if (simpleBar) {
          // Set scroll to top to trigger load more
          simpleBar.scrollTop = 0;
          
          // Wait for load more to complete (max 5 seconds)
          setTimeout(() => {
            // Try scrolling again
            this.scrollToMessage(messageData);
          }, 3000);
        }
      }
    },
    async checkWhatsappStatus()
    {
      let kodemb = JSON.parse(localStorage.getItem("user")).Company.CompanyCode
      let urlStateWa = process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/status?kodemb=" + kodemb
      const statusWa = await axios.get(urlStateWa, {
        headers: {
          clientid: "abcd1234"
        }
      })

      let responseData = statusWa.data
      // Hanya set true jika WA benar-benar CONNECTED — bukan FAILED/STOPPED/STARTING/WAITING
      this.whatsappStatus = responseData.data === 'CONNECTED';
    },
    closeConvertation() {
      console.log('� Closing conversation...');
      
      // 🔥 CRITICAL: Clear phoneNumber to null (prevents socket cross-contamination)
      this.phoneNumber = null;
      this.username = "";
      this.userid = null;
      
      // Clear conversation data
      this.chatMessagesData = [];
      this.resultSearchMessage = [];
      this.searchChatInput = "";
      
      // Clear user details
      this.profile = require("@/assets/images/users/user-dummy-img.jpg");
      this.userStatus = null;
      this.loadingConversation = false;
      this.note = null;
      this.tagValue = [];
      this.agentHandle = [];
      this.assignedAgent = null;
      
      // Close any open forms
      this.closeFormUpload();
      this.closeReply();
      this.form = { message: "" };
      
      // Remove active class from all contacts
      document.querySelectorAll('.contact-list-item').forEach(item => {
        item.classList.remove('active');
      });
      
      console.log('✅ Conversation closed - phoneNumber:', this.phoneNumber);
    },

    showRouteSpinner() {
      try {
        if (document.getElementById('route-lookup-spinner')) return;
        const spinner = document.createElement('div');
        spinner.id = 'route-lookup-spinner';
        spinner.innerHTML = `
          <div class="rls-backdrop">
            <div class="rls-spinner">
              <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div>
              <div class="rls-text">Mencari contact...</div>
            </div>
          </div>`;
        document.body.appendChild(spinner);
      } catch (e) {
        console.error('showRouteSpinner error', e);
      }
    },

    hideRouteSpinner() {
      try {
        const el = document.getElementById('route-lookup-spinner');
        if (el) el.remove();
      } catch (e) {
        console.error('hideRouteSpinner error', e);
      }
    },
    isConversationOpen() {
      return !!(this.phoneNumber && this.username);
    },
    isConversationEmpty() {
      return this.chatMessagesData.length === 0;
    },
    async showDeleteModal(messageData) {
      console.log('[MODAL_START]', new Date().toISOString());
      
      // ✅ Langsung tampilkan confirm modal
      const result = await Swal.fire({
        title: 'Delete this message?',
        html: '<p class="text-muted mb-0">This action cannot be undone</p>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Yes, delete it',
        cancelButtonText: 'Cancel'
      });

      if (result.isConfirmed) {
        console.log('[CONFIRMED] Deleting message');
        this.deleteMessage(messageData);
      }
    },
    async deleteMessage(messageData) {
      const startTime = Date.now();
      console.log('[START] deleteMessage at', new Date().toISOString());
      
      const messageId = messageData.id || messageData.message_id || messageData.chatID || messageData.chatIDRaw || messageData;

      // Robustly extract a clean WA message id when messageId is an object
      const extractMessageId = (mid) => {
        if (!mid && mid !== 0) return "";
        if (typeof mid === 'string') return mid;
        if (typeof mid === 'number') return String(mid);
        try {
          // common shapes
          if (mid.id) return mid.id;
          if (mid.message_id) return mid.message_id;
          if (mid.chatID) return mid.chatID;
          if (mid._data && mid._data.key && mid._data.key.id) return mid._data.key.id;
          if (mid._data && mid._data.id) return mid._data.id;
          if (mid.messageId) return mid.messageId;
        } catch (e) {
          // fallthrough
        }
        // Fallback to stringify (will be cleaned later)
        return String(mid);
      };

      // Normalize messageId to string before using string methods
      const messageIdStr = extractMessageId(messageId) || "";

      // Prefer explicit currentPhone, fallback to phoneNumber
      let phone = this.currentPhone || this.phoneNumber || null;
      const phoneDigits = phone ? String(phone).replace(/\D/g, "") : "";

      if (!phoneDigits || phoneDigits.length < 10) {
        const match = messageIdStr.match(/(\d+)@c\.us/);
        if (match && match[1]) {
          phone = match[1];
        }
      }

      // Coerce phone to digits-only string for downstream checks
      phone = phone ? String(phone).replace(/\D/g, "") : phone;
      
      console.log('[VALIDATE] Time:', Date.now() - startTime, 'ms');
      
      if (!messageId || !phone || phone.length < 10) {
        this.Toast.fire({
          icon: 'error',
          title: 'Invalid message data'
        });
        return;
      }
      
      Swal.fire({
        title: 'Deleting...',
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading()
      });
      
      console.log('[LOADING] Time:', Date.now() - startTime, 'ms');
      
      const param = "?clientid=abcd1234";
      const url = process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/delete-message" + param;

      // Determine kodemb (session identifier). Prefer explicit currentKodemb,
      // then fall back to the logged-in user's Company code from localStorage.
      const kodembFromUser = (() => {
        try {
          return JSON.parse(localStorage.getItem('user'))?.Company?.CompanyCode || '';
        } catch (e) {
          return '';
        }
      })();

      const kodemb = this.currentKodemb || kodembFromUser || '';

      if (!kodemb) {
        Swal.close();
        this.Toast.fire({
          icon: 'error',
          title: 'No WA session (kodemb) configured'
        });
        return;
      }

      console.log('[BEFORE_REQUEST] Time:', Date.now() - startTime, 'ms');

      try {
        const response = await axios.post(url, {
          kodemb: kodemb,
          phone: phone,
          // send normalized string id to avoid objects being serialized as [object Object]
          message_id: messageIdStr
        }, {
          timeout: 30000
        });

        console.log('[RESPONSE] Time:', Date.now() - startTime, 'ms');
        
        Swal.close();
        
        const result = response.data;

        if (result.status === 200 || result.success) {
          // Normalize ids when searching the local array to remove the message
          const idMatches = (a, b) => {
            if (!a || !b) return false;
            const sa = String(a);
            const sb = String(b);
            return sa === sb || sa.endsWith(sb) || sb.endsWith(sa);
          };

          const messageIndex = this.chatMessagesData.findIndex(msg => {
            const candidate = msg.id || msg.message_id || msg.chatID;
            return idMatches(candidate, messageIdStr);
          });

          if (messageIndex !== -1) {
            const orig = this.chatMessagesData[messageIndex];
            // Buat object baru agar Vue 3 deteksi perubahan sebagai item baru
            const revokedMsg = {
              ...orig,
              isRevoked: true,
              type: 'revoked',
              hasMedia: false,
              fromMe: true,
              message: 'Anda menghapus pesan ini',
              originalBody: orig.originalBody || orig.message,
              originalType: orig.originalType || orig.type
            };
            this.chatMessagesData.splice(messageIndex, 1, revokedMsg);
            console.log('Message marked as revoked in array');

            // Update preview di chat list dengan object baru
            const chatIdx = this.chatData.findIndex(c =>
              c.telp && String(c.telp).replace(/\D/g, '') === String(phone)
            );
            if (chatIdx !== -1) {
              this.chatData.splice(chatIdx, 1, {
                ...this.chatData[chatIdx],
                message: 'Anda menghapus pesan ini',
                type: 'revoked'
              });
            }
          }

          this.Toast.fire({
            icon: 'success',
            title: 'Message deleted'
          });
        } else {
          this.Toast.fire({
            icon: 'error',
            title: result.data || result.message || 'Failed to delete'
          });
        }
        
        console.log('[DONE] Total time:', Date.now() - startTime, 'ms');
        
      } catch (error) {
        Swal.close();
        console.error('[ERROR] Time:', Date.now() - startTime, 'ms', error);
        
        let errorMessage = 'Failed to delete message';
        
        if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
          errorMessage = 'Request timeout';
        } else if (error.response?.data) {
          errorMessage = error.response.data.data || error.response.data.message || 'Server error';
        }
        
        this.Toast.fire({
          icon: 'error',
          title: errorMessage
        });
      }
    },
    updateChatListAfterDelete(phone) {
      
      // Find chat in list
      const chatIndex = this.chatData.findIndex(el => 
        el && el.telp && String(el.telp).replace(/\D/g, '') === String(phone).replace(/\D/g, '')
      );
      
      if (chatIndex !== -1) {
        // ✅ Cari pesan terakhir yang tersisa dari chatMessagesData
        const lastMessage = this.chatMessagesData.length > 0 
          ? this.chatMessagesData[this.chatMessagesData.length - 1] 
          : null;
        
        if (lastMessage) {
          // Update dengan pesan terakhir
          this.chatData[chatIndex].message = lastMessage.message || '';
          this.chatData[chatIndex].hasMedia = lastMessage.hasMedia || false;
          this.chatData[chatIndex].ack = lastMessage.ack || 0;
          this.chatData[chatIndex].timestamp = lastMessage.time || Date.now() / 1000;
          this.chatData[chatIndex].fromMe = lastMessage.fromMe || false;
          this.chatData[chatIndex].type = lastMessage.type || 'chat';
          
        } else {
          // Tidak ada pesan tersisa - kosongkan
          this.chatData[chatIndex].message = '';
          this.chatData[chatIndex].hasMedia = false;
          this.chatData[chatIndex].ack = 0;
          this.chatData[chatIndex].timestamp = this.chatData[chatIndex].firstTimeChat || Date.now() / 1000;
          this.chatData[chatIndex].fromMe = false;
          this.chatData[chatIndex].type = 'chat';
          
        }
        
        // Re-sort chat rooms
        this.sortChatRooms();
        
        // Update cache
        this.cachingChatData();
      }
    },
    async refreshChatListItem(phone) {
      
      try {
        // Fetch fresh data dari server untuk contact ini
        const response = await axios.post(
          process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/chat-rooms",
          {
            phones: [phone],
            kodemb: JSON.parse(localStorage.getItem("user")).Company.CompanyCode,
          },
          {
            headers: { ClientID: "abcd1234" },
            timeout: 10000
          }
        );
        
        if (response.data.status === 200 && Array.isArray(response.data.data) && response.data.data.length > 0) {
          const roomData = response.data.data[0];
          
          // Find dan update chat list
          const chatIndex = this.chatData.findIndex(el => 
            el && el.telp && String(el.telp).replace(/\D/g, '') === String(phone).replace(/\D/g, '')
          );
          
          if (chatIndex !== -1) {
            if (roomData.message && roomData.message.trim() !== '') {
              this.chatData[chatIndex].message = roomData.message;
              this.chatData[chatIndex].hasMedia = roomData.hasMedia || false;
              this.chatData[chatIndex].ack = roomData.ack || 0;
              this.chatData[chatIndex].timestamp = roomData.timestamp;
              this.chatData[chatIndex].fromMe = roomData.fromMe || false;
              this.chatData[chatIndex].type = roomData.type || 'chat';
            } else {
              // No message
              this.chatData[chatIndex].message = '';
              this.chatData[chatIndex].hasMedia = false;
              this.chatData[chatIndex].ack = 0;
              this.chatData[chatIndex].timestamp = this.chatData[chatIndex].firstTimeChat;
              this.chatData[chatIndex].fromMe = false;
              this.chatData[chatIndex].type = 'chat';
            }
            
            
            // Re-sort dan cache
            this.sortChatRooms();
            this.cachingChatData();
          }
        }
      } catch (error) {
        console.error('❌ Error refreshing chat list item:', error);
      }
    },
    toggleSearch() {
      this.showSearch = !this.showSearch;
      
      if (this.showSearch) {
        this.$nextTick(() => {
          this.$refs.searchInput?.focus();
        });
      } else {
        this.exitSearchMode();
      }
    },
    
    clearSearch() {
      this.exitSearchMode();
    },
    
    exitSearchMode() {
      if (this.isSearchMode && this.chatDataBackup.length > 0) {
        this.chatData = [...this.chatDataBackup];
      }
      
      this.searchQuery = '';
      this.showSearch = false;
      this.globalSearchResults = [];
      this.globalSearchMeta = null;
      this.searchChats = [];
      this.searchContacts = [];
      this.searchMessages = [];
      this.isSearchMode = false;
      this.chatDataBackup = [];
    },
    
    async handleSearch() {
      this.debounce(async () => {
        if (this.searchQuery.length < 2) {
          if (this.isSearchMode && this.chatDataBackup.length > 0) {
            this.chatData = [...this.chatDataBackup];
            this.isSearchMode = false;
          }
          this.globalSearchResults = [];
          this.globalSearchMeta = null;
          this.searchChats = [];
          this.searchContacts = [];
          this.searchMessages = [];
          return;
        }
        
        // Backup hanya sekali
        if (!this.isSearchMode) {
          this.chatDataBackup = [...this.chatData];
          this.isSearchMode = true;
        }
        
        this.globalSearchLoading = true;
        this.globalSearchPage = 1;
        
        try {
          const kodemb = JSON.parse(localStorage.getItem("user")).Company.CompanyCode;
          const response = await axios.post(
            process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/search-messages",
            {
              kodemb: kodemb,
              keyword: this.searchQuery,
              page: this.globalSearchPage,
              limit: 100
            },
            {
              headers: {
                'Authorization': `Bearer ${localStorage.getItem("jwt")}`
              }
            }
          );
          
          if (response.data.status === 200 && response.data.data) {
            // Store categorized results
            this.searchChats = response.data.data.chats || [];
            this.searchContacts = response.data.data.contacts || [];
            this.searchMessages = response.data.data.messages || [];
            this.globalSearchMeta = response.data.meta || null;
            
            // Convert to chatData format for display
            this.chatData = this.convertSearchResultsToChatData();
          } else {
            this.searchChats = [];
            this.searchContacts = [];
            this.searchMessages = [];
            this.globalSearchMeta = null;
            this.chatData = [];
          }
        } catch (error) {
          console.error('Global search error:', error);
          this.searchChats = [];
          this.searchContacts = [];
          this.searchMessages = [];
          this.chatData = [];
        } finally {
          this.globalSearchLoading = false;
        }
      }, 300);
    },
    
    convertSearchResultsToChatData() {
      const results = [];
      
      // Category 1: Chats (existing conversations matching name/phone)
      for (const chat of this.searchChats) {
        results.push({
          id: `chat_${chat.phone}`,
          category: 'chat',
          categoryLabel: 'Chat',
          name: chat.name || chat.phone,
          telp: chat.phone,
          image: chat.picture || null,  // Photo from WA
          message: chat.lastMessage || '',
          messageHighlight: chat.lastMessage ? this.highlightKeyword(chat.lastMessage, this.searchQuery) : '',
          timestamp: chat.timestamp || Date.now() / 1000,
          status: 'chat',
          fromMe: false,
          hasMedia: false,
          type: 'chat',
          ack: 0,
          unread_count: 0,
          shimmer: false,
          isSearchResult: true,
          searchKeyword: this.searchQuery,
          Tags: null
        });
      }
      
      // Category 2: Contacts (from Silverstripe that are not in chats)
      for (const contact of this.searchContacts) {
        results.push({
          id: `contact_${contact.id || contact.phone}`,
          category: 'contact',
          categoryLabel: 'Kontak',
          name: contact.name || contact.phone,
          telp: contact.phone,
          image: contact.picture || null,  // Photo from WA/API
          message: contact.tags || 'Tap to start chat',
          messageHighlight: contact.tags ? this.highlightKeyword(contact.tags, this.searchQuery) : 'Tap to start chat',
          timestamp: contact.timestamp || 0,
          status: contact.status || 'contact',
          fromMe: false,
          hasMedia: false,
          type: 'contact',
          ack: 0,
          unread_count: 0,
          shimmer: false,
          isSearchResult: true,
          searchKeyword: this.searchQuery,
          Tags: contact.tags
        });
      }
      
      // Category 3: Messages (each message shown individually)
      for (const msg of this.searchMessages) {
        results.push({
          id: `msg_${msg.id}_${msg.timestamp}`,
          category: 'message',
          categoryLabel: 'Pesan',
          name: msg.contactName || msg.phone,
          telp: msg.phone,
          message: msg.body,
          messageHighlight: this.highlightKeyword(msg.body, this.searchQuery),
          timestamp: msg.timestamp,
          status: 'message',
          fromMe: msg.fromMe,
          hasMedia: msg.hasMedia,
          type: msg.type || 'chat',
          ack: 0,
          unread_count: 0,
          shimmer: false,
          isSearchResult: true,
          searchKeyword: this.searchQuery,
          Tags: null,
          messageData: msg  // ✅ Tambahkan data lengkap untuk scroll
        });
      }
      
      return results;
    },
    
    async loadMoreSearchResults() {
      if (!this.globalSearchMeta?.hasMore || this.globalSearchLoading) return;
      
      this.globalSearchLoading = true;
      this.globalSearchPage++;
      
      try {
        const kodemb = JSON.parse(localStorage.getItem("user")).Company.CompanyCode;
        const response = await axios.post(
          process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/search-messages",
          {
            kodemb: kodemb,
            keyword: this.searchQuery,
            page: this.globalSearchPage,
            limit: 50
          }
        );
        
        if (response.data.status === 200 && response.data.data) {
          this.globalSearchResults = [...this.globalSearchResults, ...response.data.data];
          this.globalSearchMeta = response.data.meta;
          // Update chatData dengan hasil baru
          this.chatData = this.convertSearchResultsToChatData(this.globalSearchResults);
        }
      } catch (error) {
        console.error('Load more search error:', error);
      } finally {
        this.globalSearchLoading = false;
      }
    },
    
    // Filter chat rooms by phone numbers
    async filterChatRoomsByPhones(phoneArray) {
      console.log('🔍 Filtering chat rooms by phones:', phoneArray);
      
      if (!Array.isArray(phoneArray)) {
        console.error('❌ phoneArray must be an array');
        return;
      }
      
      // Set phones filter
      this.phonesFilter = phoneArray.map(phone => String(phone).replace(/\D/g, ''));
      
      // Clear current chat data and fetch filtered results
      this.chatData = [];
      this.chatDataBackup = [];
      this.isSearchMode = false;
      
      // Fetch filtered chat rooms
      await this.getUser("All");
      
      console.log('✅ Filtered chat rooms loaded:', this.chatData.length);
    },
    
    // Clear phone filter
    clearPhoneFilter() {
      console.log('🧹 Clearing phone filter');
      this.phonesFilter = [];
      this.getUser("All");
    },
    
    async openSearchResult(result) {
      // Tutup search mode dengan smooth transition
      this.showSearch = false;
      this.searchQuery = '';
      
      const phone = result.telp || result.phone;
      const contactName = result.name || result.contact?.name || phone;
      
      // Cari contact di backup data (lebih cepat)
      let contact = this.chatDataBackup.find(c => 
        String(c.telp).replace(/\D/g, '') === String(phone).replace(/\D/g, '')
      );
      
      // Restore chatData dulu
      if (this.isSearchMode && this.chatDataBackup.length > 0) {
        this.chatData = [...this.chatDataBackup];
        this.isSearchMode = false;
      }
      
      // Clear search state
      this.globalSearchResults = [];
      this.globalSearchMeta = null;
      this.chatDataBackup = [];
      
      // Langsung buka chat tanpa delay
      const messageLoadLimit = result.category === 'message' ? 100 : 25;  // ✅ Load lebih banyak untuk search message
      
      // 🔥 FIX: Gunakan dummy image sebagai default jika tidak ada image
      const defaultImage = require("@/assets/images/users/user-dummy-img.jpg");
      
      if (contact) {
        // Gunakan image dari contact atau default dummy
        const contactImage = contact.image || defaultImage;
        await this.chatUsername(contact.name, contactImage, contact.telp, contact.id, messageLoadLimit);
      } else {
        // Gunakan data dari result, pastikan image = dummy jika tidak ada
        const resultImage = result.image || defaultImage;
        await this.chatUsername(contactName, resultImage, phone, result.id || 0, messageLoadLimit);
      }
      
      // ✅ Jika ini hasil search message, scroll ke pesan tersebut
      if (result.category === 'message' && result.messageData) {
        // Tunggu sebentar untuk memastikan chatMessagesData sudah ter-load
        setTimeout(() => {
          this.scrollToMessage(result.messageData);
        }, 500);
      }
    },
  },
  watch: {
    searchChatInput(value) {
      this.chatMessagesData.forEach((item, idx) => {
        // this.chatMessagesData[idx]['message'] = item.message.replace(/(<([^>]+)>)/ig, "");
        this.chatMessagesData[idx]['showHightlight'] = false;
      })

      this.debounce(() => {
        this.resultSearchMessage = [];
        this.searchChat(value)
      }, 1000);
    }
  },
  computed: {
    inputPlaceholder() {
      if (!this.phoneNumber) {
        return 'Select a contact first...';
      }
      if (this.userStatus === 'resolved') {
        return 'Customer Is Resolved';
      }
      if (this.chatMessagesData.length === 0) {
        return 'Start the conversation...';
      }
      return 'Enter Message...';
    },
    
    // ✅ Check if input should be disabled
    isInputDisabled() {
      return !this.phoneNumber || this.userStatus === 'resolved';
    },
    searchAgent() {
      if (this.searchAgentInput) {
        var keyword = document
          .getElementById("searchAgent")
          .value.toLowerCase();
        return this.agentData.filter((data) => {
          return data.Name.toLowerCase().includes(keyword);
        });
      } else {
        return this.agentData.slice(0, this.agentData.length);
      }
    },
    contactCount() {
      let numberOfPages = Math.ceil(this.chatData.length / this.page);
      return numberOfPages
    },
    contactListpaginate() {
      /* let page = this.page;
      let perPage = this.itemsInPages;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return this.chatData.slice(from, to); */
      return this.chatData;
    },
  },
  async beforeMount() {
    await this.checkWhatsappStatus();
    this.onNewMessageReceived = null;
    this.user = JSON.parse(localStorage.getItem("user"));

    axios
      .get(
        process.env.VUE_APP_URL_API +
        "agent-api/getAgentList?All=true&IsActive=on&ClientID=" +
        process.env.VUE_APP_CLIENT_ID +
        "&AccessToken=" +
        localStorage.getItem("jwt")
      )
      .then((response) => {
        if (response.data.Data !== null) {
          this.agentData = response.data.Data;
          if (!(this.agentData instanceof Array)) {
            this.agentData = [this.agentData];
          }
          // normalize avatar fields for consistent use in dropdown
          this.agentData = this.agentData.map((el) => {
            let copy = Object.assign({}, el);
            if (copy.Avatar && typeof copy.Avatar === 'object' && copy.Avatar.Original) {
              copy.avatar = copy.Avatar.Original;
            } else if (copy.Avatar && typeof copy.Avatar === 'string') {
              copy.avatar = copy.Avatar;
            } else {
              copy.avatar = this.profile;
            }
            return copy;
          });
        }

        /* this.agentData.forEach((element, index) => {
          if (!element.Avatar) {
            element.Avatar = "https://i.pravatar.cc/160?img=29";
          } else {
            element.Avatar = element.Avatar.Original;
          }
          this.agentData[index] = element;
        }); */
      });

    if(this.whatsappStatus){
      this.Toast.fire({
        icon: "info",
        title: "WhatsApp connected, you mode Online"
      })
    } else {
      Swal.fire({
        title: 'WhatsApp is Offline',
        text: "Continue access offline ?",
        icon: 'warning',
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: 'Yes',
      })
    }
  },
  async mounted() {
    console.log("masuk mounted chat component");
    await this.getUser("All");

    var id = "contactChatMessageList"
    var contactList = document.getElementById(id).querySelector("#contactSimpleBar .simplebar-content-wrapper")
      ? document.getElementById(id).querySelector("#contactSimpleBar .simplebar-content-wrapper")
      : "";
    this.loadMoreContact(contactList)

    if (this.$route.params.id) {
      (async () => {
        console.log('[DEBUG] Route params.id detected:', this.$route.params.id);
        this.routeLookupLoading = true;
        this.showRouteSpinner();

        const targetId = String(this.$route.params.id).replace(/\D/g, '');

        // retry a few times while chatData is loading
        const maxAttempts = 10;
        for (let attempt = 0; attempt < maxAttempts; attempt++) {
          console.log('[DEBUG] tryOpenChat attempt', attempt, 'chatData len', this.chatData.length);
          const idx = this.chatData.findIndex((el) => {
            try {
              const phones = [el && el.telp, el && el.phone, el && el.Phone].map(p => String(p || '').replace(/\D/g, ''));
              return phones.includes(targetId);
            } catch (e) { return false; }
          });
          if (idx !== -1) {
            const users = this.chatData[idx];
            console.log('[DEBUG] Opening chat from chatData:', users);
            this.chatUsername(users.name, users.image || this.userNotFound, users.telp || users.phone || users.Phone, users.id);
            try { this.$router.replace({ path: '/chat' }); } catch (err) { console.warn('router replace failed', err); }
            this.routeLookupLoading = false;
            this.hideRouteSpinner();
            return;
          }
          await new Promise((r) => setTimeout(r, 500));
        }

        // Not found in chatData; fallback to contacts / API
        try {
          console.log('[DEBUG] Not found in chatData, checking contacts from IndexedDB');
          const contacts = await this.getAllContact();
          if (contacts && Array.isArray(contacts)) {
            const contact = contacts.find((el) => {
              if (!el) return false;
              const phones = [el.Phone, el.phone].map(p => String(p || '').replace(/\D/g, ''));
              return phones.includes(targetId);
            });
            if (contact) {
              const name = contact.Name || contact.name || contact.pushName || '-';
              const phone = contact.Phone || contact.phone || targetId;
              const id = contact.ID || contact.id || phone;
              let avatar = this.userNotFound;
              if (contact.Avatar && contact.Avatar.Original) avatar = contact.Avatar.Original;
              else if (contact.avatar) avatar = contact.avatar;
              else if (contact.profilePicThumb) avatar = contact.profilePicThumb;

              console.log('[DEBUG] Opening chat with contact data:', name, phone);
              this.chatUsername(name, avatar, phone, id);
              try { this.$router.replace({ path: '/chat' }); } catch (err) { console.warn('router replace failed', err); }
              this.routeLookupLoading = false;
              this.hideRouteSpinner();
              return;
            }
          }

          // Try API lookup
          try {
            const apiResp = await axios.get(`${process.env.VUE_APP_URL_API}customer-api/getCustomerByPhone`, {
              params: { ClientID: process.env.VUE_APP_CLIENT_ID, AccessToken: localStorage.getItem('jwt'), Phone: targetId }
            });
            if (apiResp.status === 200 && apiResp.data && apiResp.data.Data) {
              const c = apiResp.data.Data;
              const phone = c.Phone || c.phone || targetId;
              const name = c.Name || c.name || c.pushName || `Contact ${phone}`;
              const id = c.ID || c.id || phone;
              let avatar = this.userNotFound;
              if (c.Avatar && c.Avatar.Original) avatar = c.Avatar.Original;
              else if (c.avatar) avatar = c.avatar;
              try { if (this.db) this.addCustomerToDB([c]); } catch (e) { /* ignore */ }
              console.log('[DEBUG] Fetched contact from API:', name, phone, id);
              this.chatUsername(name, avatar, phone, id);
              try { this.$router.replace({ path: '/chat' }); } catch (err) { console.warn('router replace failed', err); }
              this.routeLookupLoading = false;
              this.hideRouteSpinner();
              return;
            }
          } catch (err) {
            console.warn('[DEBUG] API lookup failed', err);
          }

          // Last resort: use route query as fallback
          const q = this.$route && this.$route.query ? this.$route.query : {};
          if (q.name || q.avatar) {
            const nameQ = q.name || `Contact ${targetId}`;
            const avatarQ = q.avatar || this.userNotFound;
            this.chatUsername(nameQ, avatarQ, targetId, targetId);
            try { this.$router.replace({ path: '/chat' }); } catch (err) { console.warn('router replace failed', err); }
            this.routeLookupLoading = false;
            this.hideRouteSpinner();
            return;
          }

          this.Toast.fire({ icon: 'warning', title: `Contact ${targetId} tidak tersedia` });
          try { this.$router.replace({ path: '/chat' }); } catch (err) { console.warn('router replace failed', err); }
          this.routeLookupLoading = false;
          this.hideRouteSpinner();
        } catch (err) {
          console.error('[DEBUG] Error loading contacts:', err);
          this.Toast.fire({ icon: 'error', title: 'Failed to load contact data' });
          this.routeLookupLoading = false;
          this.hideRouteSpinner();
        }
      })();

      // Attach handler so that when image modal (Bootstrap modal) closes,
      // the chat scrolls to bottom instead of jumping to top.
      try {
        const zoomModal = document.getElementById('zoomInModal');
        if (zoomModal && typeof zoomModal.addEventListener === 'function') {
          zoomModal.addEventListener('hidden.bs.modal', () => {
            this.$nextTick(() => {
              try { this.scrollToBottom('users-chat'); } catch (err) { console.warn('scrollToBottom failed on modal hidden', err); }
            });
          });
        }
      } catch (err) {
        console.warn('failed to attach modal hidden listener', err);
      }
    }

    if (this.chatMessagesData.length != 0) {
      var currentChatId = "users-chat";
      this.scrollToBottom(currentChatId);
      document.getElementById("copyClipBoard").style.display = "none";
      var userChatElement = document.querySelectorAll(".user-chat");

      document
        .querySelectorAll(".chat-user-list li a")
        .forEach(function (item) {
          item.addEventListener("click", function () {
            userChatElement.forEach(function (elm) {
              elm.classList.add("user-chat-show");
            });

            // chat user list link active
            var chatUserList = document.querySelector(
              ".chat-user-list li.active"
            );
            if (chatUserList) chatUserList.classList.remove("active");
            this.parentNode.classList.add("active");
          });
        });

      // user-chat-remove
      document.querySelectorAll(".user-chat-remove").forEach(function (item) {
        item.addEventListener("click", function () {
          userChatElement.forEach(function (elm) {
            elm.classList.remove("user-chat-show");
          });
        });
      });
    }

    /* setInterval(() => {
      console.log("Setup on 2 minutes refresh contact");
      document.querySelector("#btnRefresh").click();
    }, 120000); */
  },
  async created() {
    console.log("masuk created component chat");
    var self = this;

    this.initSocket();

    this.onNewMessageReceived = ({ phone, data }) => {
      console.log('📨 [Chat.vue] Received new message callback:', phone);
      
      // Check if this is the active conversation
      const currentPhone = this.phoneNumber ? String(this.phoneNumber).replace(/\D/g, '') : null;
      const messagePhone = String(phone).replace(/\D/g, '');
      
      if (currentPhone && currentPhone === messagePhone) {
        console.log('✅ [Chat.vue] Active conversation - adding message');
        
        // Apply formatting
        let body = data.body || '';
        body = body.replace(/(_)([^_]+?)(_)/gs, `<i>$2</i>`);
        body = body.replace(/(\*)([^*]+?)(\*)/gs, `<b>$2</b>`);
        body = body.replace(/(~)([^~]+?)(~)/gs, `<strike>$2</strike>`);
        const displayBody = body.replace(/\n/g, "<br/>");
        
        // Extract message ID
        let cleanMessageId = null;
        if (data._data?.key?.id) {
          cleanMessageId = data._data.key.id;
        } else if (data.id) {
          if (typeof data.id === 'string') {
            cleanMessageId = data.id.includes('_') ? data.id.split('_').pop() : data.id;
          } else if (typeof data.id === 'object') {
            cleanMessageId = data.id.id || data.id._serialized;
          }
        }
        
        if (!cleanMessageId) {
          cleanMessageId = `msg_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        }
        
        // Check for duplicates
        const existingMsgIdx = this.chatMessagesData.findIndex(
          msg => msg.chatID === cleanMessageId
        );
        
        if (existingMsgIdx !== -1) {
          console.log('⚠️ [Chat.vue] Duplicate message, skipping');
          return;
        }
        
        // Add message
        this.chatMessagesData.push({
          align: data.fromMe === true ? "right" : "",
          name: this.username,
          chatID: cleanMessageId,
          message: displayBody,
          time: data.timestamp || Math.floor(Date.now() / 1000),
          hasMedia: data.hasMedia || false,
          ack: data.ack || 0,
          fromMe: data.fromMe || false,
          phone: this.phoneNumber,
          type: data.type || 'chat',
          quotedMsg: null,
          quotedParticipant: null,
          showHightlight: false,
          downloadImage: false,
          media: null,
          style: {}
        });
        
        const index = this.chatMessagesData.length - 1;
        
        // Handle media
        if (data._data && "deprecatedMms3Url" in data._data) {
          // wwebjs format
          this.chatMessagesData[index].media = "data:" + (data._data.mimetype || "image/png") + ";base64," + data._data.body;
          if (data.type === 'image' || data.type === 'chat') {
            this.chatMessagesData[index].style = { filter: 'blur(3px)' };
            this.chatMessagesData[index].downloadImage = true;
          }
        } else if (data.hasMedia && data._data?.message) {
          // WAHA format: imageMessage / videoMessage / documentMessage
          const msgContent = data._data.message;
          const mediaMsg = msgContent.imageMessage || msgContent.videoMessage || msgContent.documentMessage || msgContent.audioMessage || msgContent.stickerMessage;
          if (mediaMsg) {
            if (mediaMsg.jpegThumbnail?.data) {
              const thumbBase64 = typeof mediaMsg.jpegThumbnail.data === 'string'
                ? mediaMsg.jpegThumbnail.data
                : btoa(String.fromCharCode(...new Uint8Array(mediaMsg.jpegThumbnail.data)));
              this.chatMessagesData[index].media = 'data:image/jpeg;base64,' + thumbBase64;
            } else if (mediaMsg.url) {
              this.chatMessagesData[index].media = mediaMsg.url;
            }
            this.chatMessagesData[index].hasMedia = true;
            this.chatMessagesData[index].type = msgContent.imageMessage ? 'image' : (msgContent.videoMessage ? 'video' : 'document');
            this.chatMessagesData[index].style = { filter: 'blur(3px)' };
            this.chatMessagesData[index].downloadImage = true;
          }
        }
        
        // Scroll to bottom
        this.$nextTick(() => {
          setTimeout(() => {
            if (typeof this.scrollToBottom === 'function') {
              this.scrollToBottom("users-chat");
            }
          }, 150);
        });
        
        // Mark as read
        try {
          const user = JSON.parse(localStorage.getItem("user"));
          axios.post(
            process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/mark-as-read",
            {
              phone: messagePhone,
              kodemb: user.Company.CompanyCode,
            },
            { 
              headers: { clientid: "abcd1234" },
              timeout: 5000
            }
          );
          } catch (error) {
            console.error('[DEBUG] Error loading contacts:', error);
            this.Toast.fire({
              icon: "error",
              title: "Failed to load contact data"
            });
            try { this.$router.replace({ path: '/chat' }); } catch (err) { console.warn('router replace failed', err); }
            this.routeLookupLoading = false;
            this.hideRouteSpinner();
          }
        }};
    // CUSTOMER UNASSIGNED - Handle new customers
    // ========================================
    this.socket.on("customer_unassigned", async function (data) {
      console.log("🆕 SOCKET: customer_unassigned");
      
      try {
        let customerData = JSON.parse(data);
        console.log('📦 New customer data:', {
          ID: customerData.ID,
          Phone: customerData.Phone,
          Name: customerData.Name,
          Status: customerData.Status
        });

        const newPhone = String(customerData.Phone || '').replace(/\D/g, '');
        if (!newPhone) {
          console.warn('⚠️ customer_unassigned: phone tidak valid, skip');
          return;
        }

        // ✅ STEP 1: Cek apakah sudah ada di chatData — cegah double entry
        // Bisa sudah ada karena 'chat' event handler menambahkannya duluan via chat-rooms API
        const existingChatIdx = self.chatData.findIndex(el =>
          String(el.telp || '').replace(/\D/g, '') === newPhone
        );

        if (existingChatIdx !== -1) {
          // Update in-place saja, jangan tambah entry baru
          console.log('🔄 [DEDUP] Kontak sudah ada di chatData:', newPhone);
          // JANGAN update status dari socket payload — socket selalu 'active'.
          // refreshContact async akan update status dari SS API (assigned/unassigned) via syncContactToChatData.
          if (customerData.Name && customerData.Name !== newPhone) {
            self.chatData[existingChatIdx].name = customerData.Name;
          }
          // Trigger SS fetch untuk memperbaiki status secara async
          if (typeof self.refreshContact === 'function') {
            self.refreshContact(newPhone).catch(e => console.warn('[DEDUP] refreshContact failed:', e?.message));
          }
          return;
        }

        // ✅ STEP 2: Kontak belum ada di chatData — fetch single phone dari chat-rooms API
        // JANGAN pakai getUser("All") atau refreshContact() tanpa phone karena
        // kedua fungsi tsb push list baru ke chatData tanpa dedup → double entry
        console.log('🆕 Kontak baru, fetch dari chat-rooms API (single phone):', newPhone);
        try {
          const user = JSON.parse(localStorage.getItem("user"));
          const response = await axios.post(
            process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/chat-rooms",
            {
              kodemb: user.Company.CompanyCode,
              phones: [newPhone]
            },
            {
              headers: {
                clientid: "abcd1234",
                AccessToken: localStorage.getItem("jwt")
              },
              timeout: 8000
            }
          );

          if (response.data?.status === 200 && Array.isArray(response.data.data) && response.data.data.length > 0) {
            const newRoom = response.data.data[0];

            // Race condition guard: cek lagi setelah API fetch selesai
            const reCheck = self.chatData.findIndex(el =>
              String(el.telp || '').replace(/\D/g, '') === newPhone
            );

            if (reCheck === -1) {
              self.chatData.unshift(newRoom);
              console.log('✅ [SOCKET] Kontak baru ditambahkan ke chatData:', newRoom.name || newPhone);
            } else {
              // Sudah ada (race condition), update statusnya saja
              console.log('⏭️ [RACE] Kontak sudah muncul saat API fetch selesai, update status saja:', newPhone);
              if (newRoom.status) self.chatData[reCheck].status = newRoom.status;
            }
          } else {
            console.warn('⚠️ chat-rooms API tidak mengembalikan data untuk:', newPhone);
          }
        } catch (fetchErr) {
          console.error('❌ Gagal fetch chat-room untuk kontak baru:', fetchErr.message);
        }
        
      } catch (error) {
        console.error('❌ Error handling customer_unassigned:', error);
      }
    });

    // ========================================
    // CHAT EVENT - Handle incoming messages
    // ========================================
    this.socket.on("chat", async function (data) {
      console.log("📨 SOCKET: chat event received");
      if (self.debugSocketData) self.debugSocketData('chat raw', data);
      
      try {
        var res = JSON.parse(data);
        
        // ✅ Extract phone number
        var phone = "";
        var chatFrom = "";
        
        if (res.fromMe) {
          chatFrom = res.to.split("@")[0];
          phone = res.to.split("@")[0];
        } else {
          chatFrom = res.from.split("@")[0];
          phone = res.from.split("@")[0];
        }
        
        // ✅ Clean phone (remove non-digits)
        phone = phone.replace(/\D/g, '');
        chatFrom = chatFrom.replace(/\D/g, '');
        
        console.log('📞 SOCKET Chat:', {
          rawFrom: res.from,
          rawTo: res.to,
          extractedPhone: phone,
          currentPhone: self.phoneNumber,
          currentUsername: self.username
        });

        // 🔒 Filter: pesan outgoing (fromMe) selalu diproses;
        // pesan incoming hanya diproses jika kontak ada di IndexedDB/ChatData agent ini
        if (!res.fromMe) {
          let isMyContact = false;
          try {
            const contacts = await self.getAllContact();
            if (Array.isArray(contacts)) {
              isMyContact = contacts.some(c =>
                c && c.Phone && String(c.Phone).replace(/\D/g, '') === String(phone)
              );
            }
          } catch (e) {
            // fallback ke ChatData jika IndexedDB gagal
            const chatArr = JSON.parse(localStorage.getItem("ChatData") || '[]');
            isMyContact = Array.isArray(chatArr) && chatArr.some(el =>
              el && el.telp && String(el.telp).replace(/\D/g, '') === String(phone)
            );
          }

          if (!isMyContact) {
            console.log('[FILTER chat.vue] ⏭️ Kontak belum ada di list agent, mencoba sinkronisasi dari server:', phone);
            
            // ✅ Fix issue chat baru pertama kali tidak muncul otomatis
            if (typeof self.refreshContact === 'function') {
                await self.refreshContact(phone);
                
                // Cek ulang setelah refresh
                try {
                    const retryContacts = await self.getAllContact();
                    if (Array.isArray(retryContacts)) {
                        isMyContact = retryContacts.some(c =>
                            c && c.Phone && String(c.Phone).replace(/\D/g, '') === String(phone)
                        );
                    }
                } catch (e) {
                    console.error('Error re-checking contact:', e);
                }
            }

            if (!isMyContact) {
                console.log('[FILTER chat.vue] ⏭️ Kontak BENAR-BENAR bukan milik agent ini, skip:', phone);
                return;
            } else {
                console.log('✅ [FILTER chat.vue] Kontak berhasil disinkronisasi, memproses pesan!', phone);
            }
          }
        }
        
        // ✅ Apply WhatsApp formatting
        const regexItalic = /(_)([^_]+?)(_)/gs;
        const regexBold = /(\*)([^*]+?)(\*)/gs;
        const regexStrike = /(~)([^~]+?)(~)/gs;

        var body = res.body || '';
        body = body.replace(regexItalic, `<i>$2</i>`);
        body = body.replace(regexBold, `<b>$2</b>`);
        body = body.replace(regexStrike, `<strike>$2</strike>`);

        // ✅ Find chat in chatData
        var idxChatdata = self.chatData.findIndex(
          (e) => String(e.telp).replace(/\D/g, '') === String(phone) || 
                String(e.phone).replace(/\D/g, '') === String(phone)
        );

        if (idxChatdata !== -1) {
          // Update existing chat
          self.chatData[idxChatdata]["type"] = res.type || 'chat';
          self.chatData[idxChatdata]["hasMedia"] = res.hasMedia || false;
          self.chatData[idxChatdata]["message"] = body;
          self.chatData[idxChatdata]["timestamp"] = res.timestamp || Math.floor(Date.now() / 1000);
          self.chatData[idxChatdata]["fromMe"] = res.fromMe || false;
          self.chatData[idxChatdata]["ack"] = res.ack || 0;
          
          console.log('✅ Updated chat list:', self.chatData[idxChatdata].name);
          
          // Move to top
          await self.pushToTop(String(chatFrom), res);
        } else {
          console.log('⚠️ Chat not found in chatData:', phone);
          
          // ✅ Fetch ONLY this contact (don't refresh all)
          try {
            const user = JSON.parse(localStorage.getItem("user"));
            
            if (!user || !user.Company || !user.Company.CompanyCode) {
              console.error('❌ User data not found in localStorage');
              return;
            }
            
            const response = await axios.post(
              process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/chat-rooms",
              {
                kodemb: user.Company.CompanyCode,
                phones: [phone]
              },
              { 
                headers: { 
                  clientid: "abcd1234",
                  AccessToken: localStorage.getItem("jwt")
                },
                timeout: 5000
              }
            );
            
            if (response.data?.status === 200 && Array.isArray(response.data.data) && response.data.data.length > 0) {
              const newContact = response.data.data[0];

              // 🔧 FIX BADGE: unread_count dari API sudah akurat (termasuk pesan ini).
              // SocketMixins.js akan increment +1 lagi via updateUnreadCount,
              // jadi kurangi 1 untuk kompensasi agar badge tampil 1 (bukan 2).
              if (newContact.unread_count > 0) {
                newContact.unread_count = newContact.unread_count - 1;
              }
              
              // Add to beginning of chatData
              self.chatData.unshift(newContact);
              
              // Add to IndexedDB
              await self.addCustomerToDB([newContact]);
              
              // Update localStorage
              localStorage.setItem("ChatRooms", JSON.stringify(self.chatData));
              
              console.log('✅ New contact added:', newContact.name, '| unread_count (pre-compensated):', newContact.unread_count);
              idxChatdata = 0;

              // 🔧 FIX STATUS: /chat-rooms API selalu return status: 'active' (dari WAHA/MongoDB).
              // Trigger refreshContact async untuk dapat status 'assigned' dari SS API.
              // syncContactToChatData() akan mengupdate chatData setelah SS merespons.
              if (typeof self.refreshContact === 'function') {
                self.refreshContact(phone).catch(e => console.warn('refreshContact for status fix failed:', e?.message));
              }
            }
          } catch (error) {
            console.error('❌ Failed to fetch contact:', error.message);
          }
        }
        
        // ✅ Show notification
        if (typeof self.showMessageNotif === 'function') {
          self.showMessageNotif(data);
        }

        // ✅ Cache to localStorage
        if (localStorage.getItem("ChatRooms") !== null) {
          localStorage.removeItem("ChatRooms");
          localStorage.setItem("ChatRooms", JSON.stringify(self.chatData));
        }

        // ========================================
        // 🔥 CHECK IF THIS IS THE ACTIVE CONVERSATION
        // ========================================
        
        console.log('🔍 Checking conversation...');
        
        // ✅ STRICT CHECK: Only use phoneNumber as single source of truth
        const currentPhone = self.phoneNumber ? String(self.phoneNumber).replace(/\D/g,'') : null;
        const messagePhone = String(phone).replace(/\D/g,'');
        
        // ✅ CRITICAL FIX: Only check by phone number (most reliable)
        const isConversationActive = currentPhone && currentPhone === messagePhone;
        
        console.log('🔍 Active conversation check:', {
          currentPhone,
          messagePhone,
          isActive: isConversationActive,
          conversationOpen: !!self.phoneNumber
        });
        
        // ❌ SAFETY CHECK: Prevent cross-contamination
        if (!currentPhone) {
          console.log('ℹ️ No conversation open, skipping message addition');
          return;
        }
        
        // ✅ IF ACTIVE CONVERSATION
        if (isConversationActive) {
          console.log('✅ ACTIVE CONVERSATION - Adding message');
          
          // Mark as read
          try {
            const user = JSON.parse(localStorage.getItem("user"));
            
            await axios.post(
              process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/mark-as-read",
              {
                phone: chatFrom,
                kodemb: user.Company.CompanyCode,
              },
              { 
                headers: { clientid: "abcd1234" },
                timeout: 5000
              }
            );
            console.log('✅ Marked as read');
          } catch (err) {
            console.error('❌ Mark as read failed:', err.message);
          }

          var displayBody = body.replace(/\n/g, "<br/>");

          // Extract clean message ID
          let cleanMessageId = null;
          if (res._data?.key?.id) {
            cleanMessageId = res._data.key.id;
          } else if (res.id) {
            if (typeof res.id === 'string') {
              cleanMessageId = res.id.includes('_') ? res.id.split('_').pop() : res.id;
            } else if (typeof res.id === 'object') {
              cleanMessageId = res.id.id || res.id._serialized;
            }
          }
          
          if (!cleanMessageId) {
            cleanMessageId = `msg_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
          }

          console.log('🆔 Message ID:', cleanMessageId);

          // Check for duplicates
          const existingMsgIdx = self.chatMessagesData.findIndex(
            msg => msg.chatID === cleanMessageId
          );
          
          if (existingMsgIdx !== -1) {
            console.log('⚠️ Duplicate message, skipping');
            return;
          }

          // ✅ ADD MESSAGE TO CONVERSATION
          console.log('➕ Adding message to conversation');
          
          self.chatMessagesData.push({
            align: res.fromMe === true ? "right" : "",
            name: self.username,
            chatID: cleanMessageId,
            message: displayBody,
            time: res.timestamp || Math.floor(Date.now() / 1000),
            hasMedia: res.hasMedia || false,
            ack: res.ack || 0,
            fromMe: res.fromMe || false,
            phone: self.phoneNumber,
            type: res.type || 'chat',
            quotedMsg: null,
            quotedParticipant: null,
            showHightlight: false,
            downloadImage: false,
            media: null,
            style: {}
          });

          var index = self.chatMessagesData.length - 1;
          console.log('✅ Message added at index:', index);

          // Handle quoted message (support both wwebjs and WAHA format)
          let hasQuoted = false;
          let quotedData = null;
          let quotedParticipant = null;
          
          // Method 1: Check wwebjs format (hasQuotedMsg + _data.quotedMsg)
          if (res.hasQuotedMsg && res._data && "quotedMsg" in res._data) {
            hasQuoted = true;
            quotedData = res._data.quotedMsg;
            if ("deprecatedMms3Url" in quotedData) {
              quotedData.body = "data:" + quotedData.mimetype + ";base64;" + quotedData.body;
            }
            var splitParticipant = res._data.quotedParticipant.split("@");
            quotedParticipant = {
              user: splitParticipant[0],
              server: splitParticipant[1],
              _serialized: res._data.quotedParticipant,
              name: (parseInt(splitParticipant[0]) === parseInt(self.phoneNumber) ? self.username : "Anda") || splitParticipant[0] || 'Unknown'
            };
            console.log('🔍 [DEBUG] chat (wwebjs) Quoted Payload:', {
              rawParticipant: res._data.quotedParticipant,
              processed: quotedParticipant
            });
          }
          // Method 2: Check WAHA format (extendedTextMessage.contextInfo.quotedMessage)
          else if (res?._data?.message?.extendedTextMessage?.contextInfo?.quotedMessage) {
            hasQuoted = true;
            const quotedMessage = res._data.message.extendedTextMessage.contextInfo.quotedMessage;
            
            quotedData = {
              body: quotedMessage.conversation || '',
              type: 'chat',
              id: res._data.message.extendedTextMessage.contextInfo.stanzaId || ''
            };
            
            // Extract participant info from contextInfo
            const participant = res._data.message.extendedTextMessage.contextInfo.participant || '';
            const participantPhone = participant.replace(/[^\d]/g, '');
            
            quotedParticipant = {
              user: participantPhone,
              name: (participantPhone === self.phoneNumber ? self.username : 'Anda') || participantPhone || 'Unknown'
            };
            console.log('🔍 [DEBUG] chat (WAHA) Quoted Payload:', {
              rawParticipant: participant,
              processed: quotedParticipant
            });
          }
          
          if (hasQuoted) {
            self.chatMessagesData[index]["quotedMsg"] = quotedData;
            self.chatMessagesData[index]["quotedParticipant"] = quotedParticipant;
            console.log('✅ Added quoted message:', quotedData.body);
          }

          // Handle media - check WAHA format first (has actual thumbnail), then legacy
          if (res.hasMedia && res._data?.message) {
            // WAHA format: use imageMessage / videoMessage / documentMessage
            const msgContent = res._data.message;
            const mediaMsg = msgContent.imageMessage || msgContent.videoMessage || msgContent.documentMessage || msgContent.audioMessage || msgContent.stickerMessage;
            if (mediaMsg) {
              const thumbData = mediaMsg.jpegThumbnail;
              if (thumbData) {
                const thumbBase64 = typeof thumbData === 'string'
                  ? thumbData
                  : (thumbData.data
                    ? (typeof thumbData.data === 'string' ? thumbData.data : btoa(String.fromCharCode.apply(null, new Uint8Array(thumbData.data))))
                    : null);
                if (thumbBase64) {
                  self.chatMessagesData[index]['media'] = 'data:image/jpeg;base64,' + thumbBase64;
                }
              } else if (mediaMsg.url) {
                self.chatMessagesData[index]['media'] = mediaMsg.url;
              }
              self.chatMessagesData[index]['hasMedia'] = true;
              self.chatMessagesData[index]['type'] = msgContent.imageMessage ? 'image' : (msgContent.videoMessage ? 'video' : 'document');
              self.chatMessagesData[index]['style'] = { filter: 'blur(3px)' };
              self.chatMessagesData[index]['downloadImage'] = true;
              if (msgContent.documentMessage) {
                self.chatMessagesData[index]['fileName'] = msgContent.documentMessage.fileName || 'document';
                self.chatMessagesData[index]['documentMimeType'] = msgContent.documentMessage.mimetype || 'application/octet-stream';
              }
              // Only set caption if it actually has content
              if (mediaMsg.caption && mediaMsg.caption.trim()) {
                self.chatMessagesData[index]['message'] = mediaMsg.caption;
              } else {
                self.chatMessagesData[index]['message'] = '';
              }
              console.log('✅ Added media (WAHA imageMessage)');
            }
          } else if (res.hasMedia && res._data?.sentImageUrl) {
            // Fallback: use sentImageUrl from backend — show blurred, allow click-to-load
            self.chatMessagesData[index]['media'] = res._data.sentImageUrl;
            self.chatMessagesData[index]['sentMediaUrl'] = res._data.sentImageUrl; // full image already available
            self.chatMessagesData[index]['hasMedia'] = true;
            self.chatMessagesData[index]['type'] = 'image';
            self.chatMessagesData[index]['style'] = { filter: 'blur(3px)' };
            self.chatMessagesData[index]['downloadImage'] = true;
            // Only set caption if it actually has content
            if (res._data.caption && res._data.caption.trim()) {
              self.chatMessagesData[index]['message'] = res._data.caption;
            } else {
              self.chatMessagesData[index]['message'] = '';
            }
            console.log('✅ Added media (sentImageUrl) — blurred until clicked');
          } else if (res._data && "deprecatedMms3Url" in res._data) {
            // Legacy wwebjs / WAHA fallback: detect type by res.type or mimetype
            const mimeType = res._data.mimetype || '';
            const isVid = mimeType.startsWith('video/') || res.type === 'video';
            if (isVid) {
              const hasRealData = res._data.body && res._data.body.trim().length > 200;
              const effectiveMime = mimeType.startsWith('video/') ? mimeType : 'video/mp4';
              if (hasRealData) {
                try {
                  const vBlob = self.base64ToBlob(res._data.body, effectiveMime);
                  self.chatMessagesData[index].videoBlobUrl = URL.createObjectURL(vBlob);
                  self.chatMessagesData[index].downloadImage = false;
                  self.chatMessagesData[index].style = { filter: 'blur(0px)' };
                } catch (e) {
                  self.chatMessagesData[index].videoBlobUrl = 'data:' + effectiveMime + ';base64,' + res._data.body;
                  self.chatMessagesData[index].downloadImage = false;
                  self.chatMessagesData[index].style = { filter: 'blur(0px)' };
                }
              } else {
                self.chatMessagesData[index].downloadImage = true;
                self.chatMessagesData[index].style = { filter: 'blur(3px)' };
              }
              self.chatMessagesData[index].type = 'video';
              self.chatMessagesData[index].hasMedia = true;
              self.chatMessagesData[index].media = null;
              console.log('✅ Added media (wwebjs) — video', hasRealData ? '(embedded)' : '(needs download)');
            } else {
              if (res._data.body && res._data.body.trim().length > 0) {
                self.chatMessagesData[index]["media"] = "data:" + (mimeType || "image/jpeg") + ";base64," + res._data.body;
              }
              if (res.type === 'image' || res.type === 'chat') {
                self.chatMessagesData[index]['style'] = { filter: 'blur(3px)' };
                self.chatMessagesData[index]['downloadImage'] = true;
              }
              console.log('✅ Added media (wwebjs) — image');
            }
          }

          // Scroll to bottom
          self.$nextTick(() => {
            setTimeout(() => {
              if (typeof self.scrollToBottom === 'function') {
                self.scrollToBottom("users-chat");
              }
              console.log('✅ Scrolled to bottom');
            }, 150);
          });
          
          console.log('🎉 MESSAGE ADDED SUCCESSFULLY');
          
        } else {
          console.log('ℹ️ Not active conversation');
        }

      } catch (error) {
        console.error('❌ Error handling chat:', error);
      }
    });


    // ========================================
    // [DEBUG] RAW SOCKET EVENT LOGGER — log ALL incoming events to see what arrives
    // ========================================
    const _origOnevent = self.socket.onevent;
    self.socket.onevent = function(packet) {
      const args = packet.data || [];
      if (args[0] !== 'connect' && args[0] !== 'disconnect' && args[0] !== 'ping' && args[0] !== 'pong') {
        console.log('%c[SOCKET RAW]', 'background:#222;color:#0f0;font-weight:bold', args[0], args.slice(1));
      }
      _origOnevent.call(this, packet);
    };

    // ─────────────────────────────────────────────────────────────────────────
    // Shared ACK update helper
    // Extracts ALL candidate phone numbers from a WAHA ack payload and applies
    // the new ack value to chatList + open conversation.
    // ─────────────────────────────────────────────────────────────────────────
    // Label ACK: 0=PENDING, 1=TERKIRIM, 2=DITERIMA, 3=DIBACA, 4=DIPUTAR
    const ackLabel = (ack) => {
      const labels = { 0: '⏳ PENDING', 1: '✅ TERKIRIM', 2: '✅✅ DITERIMA', 3: '💙 DIBACA', 4: '▶️ DIPUTAR' };
      return labels[ack] ?? `❓ UNKNOWN(${ack})`;
    };

    const applyAckUpdate = (res) => {
      try {
        const newAck = res.ack;
        if (newAck === undefined || newAck === null) return;

        // ── Step 1: kumpulkan semua candidate phone dari payload ──
        const phones = new Set();
        const addPhone = (raw) => {
          if (!raw) return;
          const p = String(raw).split('@')[0].replace(/\D/g, '');
          if (p.length >= 8) phones.add(p);
        };

        addPhone(res.from);
        addPhone(res.to);
        // phoneResolved: diisi server ketika from berisi @lid dan berhasil di-resolve ke nomor HP
        if (res.phoneResolved) addPhone(res.phoneResolved);

        // WAHA serialized id: "true_628xxx@c.us_MSGID" → extract phone
        const rawId = typeof res.id === 'string'
          ? res.id
          : (res.id?.id || res.id?._serialized || '');
        if (rawId && rawId.includes('_')) {
          const parts = rawId.split('_');
          if (parts.length >= 2) addPhone(parts[1]);
        }

        addPhone(res._data?.key?.remoteJid);
        addPhone(res._data?.from);
        addPhone(res._data?.to);

        // Debug: tampilkan semua candidate phones yang terkumpul
        console.log(`[CHAT.VUE][ACK] 📋 Candidate phones: [${[...phones].join(', ')}] | ack: ${newAck} (${ackLabel(newAck)}) | phoneResolved: ${res.phoneResolved || '-'}`);

        // ── Step 2: update chatList sidebar ──
        let chatListUpdated = 0;
        phones.forEach(phone => {
          const idx = self.chatData.findIndex(el =>
            String(el.telp).replace(/\D/g, '') === phone
          );
          // Hanya update jika ack lebih tinggi — cegah ack LID duplikat menurunkan status
          if (idx !== -1 && newAck > (self.chatData[idx].ack ?? 0)) {
            self.chatData[idx].ack = newAck;
            chatListUpdated++;
          } else if (idx !== -1) {
            chatListUpdated++; // ditemukan tapi tidak perlu update
          }
        });
        if (chatListUpdated === 0) {
          console.warn(`[CHAT.VUE][ACK] ⚠️ Tidak ada chatList yang cocok untuk phones: [${[...phones].join(', ')}] | total chatData: ${self.chatData?.length || 0}`);
        }

        // ── Step 3: update percakapan yang sedang dibuka ──
        const activePhone = self.phoneNumber
          ? String(self.phoneNumber).replace(/\D/g, '')
          : null;

        const conversationMatch = activePhone && [...phones].some(p => p === activePhone);

        if (conversationMatch && self.chatMessagesData?.length) {
          let updatedCount = 0;
          const targets = self.chatMessagesData
            .map((item, i) => ({ item, i }))
            .filter(({ item }) =>
              item && (item.fromMe === true || item.align === 'right') &&
              (item.ack ?? 0) < newAck
            );

          targets.forEach(({ item, i }) => {
            const liveItem = self.chatMessagesData[i];
            if (liveItem && liveItem.chatID === item.chatID) {
              self.chatMessagesData.splice(i, 1, { ...liveItem, ack: newAck });
            } else {
              const realIdx = self.chatMessagesData.findIndex(m => m.chatID === item.chatID);
              if (realIdx !== -1) {
                self.chatMessagesData.splice(realIdx, 1, { ...self.chatMessagesData[realIdx], ack: newAck });
              }
            }
            updatedCount++;
          });

          if (updatedCount > 0) {
            console.log(`[CHAT.VUE][ACK] ✅ ${updatedCount} pesan diupdate → ${ackLabel(newAck)}`);
          }
        }

        if (typeof self.cachingChatData === 'function') self.cachingChatData();

      } catch (err) {
        console.error('[CHAT.VUE][ACK] ❌ Error in applyAckUpdate:', err);
      }
    };

    // ========================================
    // CHAT STATUS CHANGED - Handle ACK updates
    // ========================================
    this.socket.on("chat_status_changed", (data) => {
      try {
        const res = JSON.parse(data);
        console.log(`[CHAT.VUE] 🔔 chat_status_changed → ack: ${res.ack} (${ackLabel(res.ack)}) | from: ${res.from} | to: ${res.to}`);
        if (!res || res.ack === undefined) return;
        applyAckUpdate(res);
      } catch (error) {
        console.error('[CHAT.VUE] ❌ Error in chat_status_changed:', error);
      }
    });

    // ========================================
    // MESSAGE ACK - raw WAHA ack event (backup)
    // ========================================
    this.socket.on("message.ack", (data) => {
      try {
        const res = typeof data === 'string' ? JSON.parse(data) : data;
        console.log(`[CHAT.VUE] 🔔 message.ack → ack: ${res.ack} (${ackLabel(res.ack)}) | from: ${res.from} | to: ${res.to}`);
        if (!res || res.ack === undefined) return;
        applyAckUpdate(res);
      } catch (error) {
        console.error('[CHAT.VUE] ❌ Error in message.ack:', error);
      }
    });

    // ========================================
    // CHAT CREATE - Handle outgoing messages
    // ========================================
    this.socket.on("chat_create", async function(data) {
      console.log("📝 [Chat.vue] chat_create event");
      if (self.debugSocketData) self.debugSocketData('chat_create raw', data);
      
      try {
        const res = typeof data === 'string' ? JSON.parse(data) : data;
        
        if (!res || !res.to) {
          console.warn('⚠️ [Chat.vue] Invalid chat_create data');
          return;
        }
        
        // Extract phone
        const chatFrom = res.to.split("@")[0].replace(/\D/g, '');
        
        console.log('📝 [Chat.vue] Message to:', chatFrom);
        console.log('🔍 [Chat.vue] Has agent:', !!res.agent);
        if (res.agent) {
          console.log('👤 [Chat.vue] Agent:', res.agent.name || res.agent.Name);
        }
        
        // ✅ Apply WhatsApp formatting
        const regexItalic = /(_)([^_]+?)(_)/gs;
        const regexBold = /(\*)([^*]+?)(\*)/gs;
        const regexStrike = /(~)([^~]+?)(~)/gs;

        let body = res.body || '';
        body = body.replace(regexItalic, `<i>$2</i>`);
        body = body.replace(regexBold, `<b>$2</b>`);
        body = body.replace(regexStrike, `<strike>$2</strike>`);
        
        // ✅ UPDATE CHAT LIST
        if (self.chatData && Array.isArray(self.chatData)) {
          const idxChatData = self.chatData.findIndex(el => 
            el && el.telp && String(el.telp).replace(/\D/g, '') === String(chatFrom)
          );
          
          if (idxChatData !== -1) {
            const mediaLabel = { image: 'Image', video: 'Video', document: 'Document', audio: 'Audio', sticker: 'Sticker' };
            const isMedia = res.hasMedia || (res.type && res.type !== 'chat' && res.type !== 'revoked');
            self.chatData[idxChatData].type = res.type || 'chat';
            self.chatData[idxChatData].hasMedia = res.hasMedia || false;
            self.chatData[idxChatData].message = isMedia ? (mediaLabel[res.type] || 'Media') : body;
            self.chatData[idxChatData].timestamp = res.timestamp || Math.floor(Date.now() / 1000);
            self.chatData[idxChatData].fromMe = true;
            self.chatData[idxChatData].ack = res.ack || 1;
            
            console.log('✅ [Chat.vue] Updated chat list');
            
            // Move to top
            if (typeof self.pushToTop === 'function') {
              await self.pushToTop(chatFrom, res);
            }
          }
        }
        
        // ✅ STRICT CHECK: Only add message to active conversation
        const currentPhone = self.phoneNumber ? String(self.phoneNumber).replace(/\D/g, '') : null;
        const messagePhone = String(chatFrom).replace(/\D/g, '');
        
        // ❌ SAFETY: Don't add if no conversation is open
        if (!currentPhone) {
          console.log('ℹ️ [Chat.vue] No conversation open, skipping');
          return;
        }
        
        const isActiveConversation = currentPhone === messagePhone;
        
        console.log('🔍 [Chat.vue] Active check:', {
          currentPhone,
          messagePhone,
          isActive: isActiveConversation
        });
        
        // ✅ IF ACTIVE CONVERSATION - ADD MESSAGE
        if (isActiveConversation && self.chatMessagesData && Array.isArray(self.chatMessagesData)) {
          console.log('✅ [Chat.vue] ACTIVE CONVERSATION - Adding message');
          
          // Extract clean message ID
          let cleanMessageId = null;
          if (res._data?.key?.id) {
            cleanMessageId = res._data.key.id;
          } else if (res.id) {
            if (typeof res.id === 'string') {
              cleanMessageId = res.id.includes('_') ? res.id.split('_').pop() : res.id;
            } else if (typeof res.id === 'object') {
              cleanMessageId = res.id.id || res.id._serialized;
            }
          }
          
          if (!cleanMessageId) {
            cleanMessageId = `msg_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
          }
          
          console.log('🆔 [Chat.vue] Message ID:', cleanMessageId);
          
          // Check for duplicates — dua strategi:
          // 1) Exact match by chatID (WA message ID)
          // 2) Pending optimistic entry dengan body+phone yang sama (belum di-reconcile saat chat_create tiba)
          let existingIdx = self.chatMessagesData.findIndex(
            msg => msg.chatID === cleanMessageId
          );

          if (existingIdx === -1) {
            const plainBody = (res.body || '').trim();
            const msgPhone = String(self.phoneNumber).replace(/\D/g, '');
            existingIdx = self.chatMessagesData.findIndex(msg =>
              msg.pending === true &&
              msg.fromMe === true &&
              String(msg.phone || '').replace(/\D/g, '') === msgPhone &&
              (msg.message || '').replace(/<[^>]+>/g, '').trim() === plainBody
            );
            if (existingIdx !== -1) {
              // Reconcile: ganti tempId dengan WA message ID yang datang dari socket
              const existing = self.chatMessagesData[existingIdx];
              const reconciled = { ...existing, chatID: cleanMessageId, id: cleanMessageId, message_id: cleanMessageId, pending: false, ack: res.ack || existing.ack || 1 };
              self.chatMessagesData.splice(existingIdx, 1, reconciled);
              console.log('[Chat.vue] chat_create — reconciled pending entry to', cleanMessageId);
              return;
            }
          }

          if (existingIdx !== -1) {
            console.log('⚠️ [Chat.vue] Duplicate message, skipping');
            const existingEntry = self.chatMessagesData[existingIdx];
            console.log('[Chat.vue] Duplicate existing entry:', {
              chatID: existingEntry.chatID,
              hasMedia: !!existingEntry.media,
              videoBlobUrl: !!existingEntry.videoBlobUrl,
              downloadImage: existingEntry.downloadImage,
              _downloading: existingEntry._downloading || false
            });

            // If socket has a direct thumbnail/base64 for images, inject it now
            if (!existingEntry.media && res._data?.sentImageUrl) {
              const updated = {
                ...existingEntry,
                media: res._data.sentImageUrl,
                style: { filter: 'blur(0px)' },
                downloadImage: false,
              };
              self.chatMessagesData.splice(existingIdx, 1, updated);
              console.log('🖼️ [Chat.vue] Injected sentImageUrl into existing entry');
            }

            // Video fallback: try to generate thumbnail from any available source
            if (res.type === 'video') {
              // 1) If entry already has a videoBlobUrl (from optimistic push), generate thumbnail from it
              if (!existingEntry.media && existingEntry.videoBlobUrl) {
                this.generateVideoThumbnail(existingEntry.videoBlobUrl, 0.5).then(thumb => {
                  if (thumb) {
                    const updated = { ...self.chatMessagesData[existingIdx], media: thumb };
                    self.chatMessagesData.splice(existingIdx, 1, updated);
                    console.log('🖼️ [Chat.vue] Generated thumbnail from videoBlobUrl for duplicate entry');
                  }
                }).catch(e => console.warn('Thumbnail generation failed', e));
              }

              // 2) If socket contains base64 video body, create blob and generate thumbnail
              else if (!existingEntry.media && res._data && res._data.body && typeof res._data.body === 'string' && res._data.body.length > 100) {
                try {
                  const mime = res._data.mimetype || 'video/mp4';
                  const blob = self.base64ToBlob(res._data.body, mime);
                  const url = URL.createObjectURL(blob);
                  this.generateVideoThumbnail(url, 0.5).then(thumb => {
                    if (thumb) {
                      const updated = { ...self.chatMessagesData[existingIdx], media: thumb, videoBlobUrl: url };
                      self.chatMessagesData.splice(existingIdx, 1, updated);
                      console.log('🖼️ [Chat.vue] Generated thumbnail from base64 body for duplicate entry');
                    }
                  }).catch(e => console.warn('Thumbnail from base64 failed', e));
                } catch (e) {
                  console.warn('Failed to create blob from base64 video body', e);
                }
              }

              // 3) Otherwise, call downloadMedia to let backend provide thumbnail/base64
              else if (!existingEntry.media && typeof self.downloadMedia === 'function') {
                try {
                  if (!existingEntry._downloading) {
                    console.log('🔍 [Chat.vue] Calling downloadMedia for duplicate video entry to fetch thumbnail');
                    self.downloadMedia(existingIdx);
                  }
                } catch (e) {
                  console.warn('Failed to fetch video thumbnail for duplicate message', e);
                }
              }
            }

            return;
          }
          
          // ✅ Extract agent info safely
          let safeAgent = null;
          if (res.agent) {
            const agentName = res.agent.name || res.agent.Name;
            const agentRole = res.agent.role || res.agent.Role?.Title || res.agent.Role;
            
            if (agentName) {
              safeAgent = {
                ID: res.agent.id || res.agent.ID || 0,
                Name: agentName,
                Role: {
                  Title: agentRole || 'Agent',
                  Code: res.agent.Role?.Code || 'agent'
                }
              };
              
              console.log('✅ [Chat.vue] Agent extracted:', safeAgent.Name);
            }
          }
          
          // Prepare display body (clear for media-only messages)
          const displayBody = (res.hasMedia && (!body || !body.trim())) ? '' : body.replace(/\n/g, "<br/>");
          
          // ✅ ADD MESSAGE TO CONVERSATION
          self.chatMessagesData.push({
            align: "right",
            name: self.username,
            chatID: cleanMessageId,
            message: displayBody,
            time: res.timestamp || Math.floor(Date.now() / 1000),
            hasMedia: res.hasMedia || false,
            ack: res.ack || 1,
            fromMe: true,
            phone: self.phoneNumber,
            type: res.type || 'chat',
            agent: safeAgent,
            hasQuotedMsg: res.hasQuotedMsg || !!res._data?.quotedMsg,
            quotedMsg: res._data?.quotedMsg ? {
              body: res._data.quotedMsg.body || "",
              type: res._data.quotedMsg.type || "chat"
            } : null,
            quotedParticipant: res._data?.quotedParticipant ? {
              user: String(res._data.quotedParticipant).replace(/\D/g, ''),
              name: res._data.quotedParticipantName || (String(res._data.quotedParticipant).replace(/\D/g, '') === String(self.phoneNumber).replace(/\D/g, '') ? self.username : 'Anda') || String(res._data.quotedParticipant).replace(/\D/g, '') || 'Unknown'
            } : null,
            showHightlight: false,
            downloadImage: false,
            media: null,
            style: {}
          });
          
          const msgIndex = self.chatMessagesData.length - 1;
          console.log('✅ [Chat.vue] Message added at index:', msgIndex);
          if (res._data?.quotedMsg || res.hasQuotedMsg) {
            console.log('🔍 [DEBUG] chat_create (NEW) Quoted Payload:', {
              rawParticipant: res._data?.quotedParticipant,
              rawParticipantName: res._data?.quotedParticipantName,
              processed: self.chatMessagesData[msgIndex].quotedParticipant
            });
          }
          
          // ✅ Handle media - check WAHA format first, then legacy, then sentImageUrl fallback
          if (res.hasMedia && res._data?.message) {
            // WAHA format: imageMessage / videoMessage / documentMessage
            const msgContent = res._data.message;
            const mediaMsg = msgContent.imageMessage || msgContent.videoMessage || msgContent.documentMessage || msgContent.audioMessage || msgContent.stickerMessage;
            if (mediaMsg) {
              const thumbData = mediaMsg.jpegThumbnail;
              if (thumbData) {
                const thumbBase64 = typeof thumbData === 'string'
                  ? thumbData
                  : (thumbData.data
                    ? (typeof thumbData.data === 'string' ? thumbData.data : btoa(String.fromCharCode.apply(null, new Uint8Array(thumbData.data))))
                    : null);
                if (thumbBase64) {
                  self.chatMessagesData[msgIndex].media = 'data:image/jpeg;base64,' + thumbBase64;
                }
              } else if (mediaMsg.url) {
                self.chatMessagesData[msgIndex].media = mediaMsg.url;
              }
              self.chatMessagesData[msgIndex].hasMedia = true;
              self.chatMessagesData[msgIndex].type = msgContent.imageMessage ? 'image' : (msgContent.videoMessage ? 'video' : 'document');
              self.chatMessagesData[msgIndex].style = { filter: 'blur(3px)' };
              self.chatMessagesData[msgIndex].downloadImage = true;
              if (msgContent.documentMessage) {
                self.chatMessagesData[msgIndex].fileName = msgContent.documentMessage.fileName || 'document';
                self.chatMessagesData[msgIndex].documentMimeType = msgContent.documentMessage.mimetype || 'application/octet-stream';
              }
              // Only set caption if it actually has content
              if (mediaMsg.caption && mediaMsg.caption.trim()) {
                self.chatMessagesData[msgIndex].message = mediaMsg.caption;
              } else {
                self.chatMessagesData[msgIndex].message = '';
              }
              console.log('✅ [Chat.vue] Media added (WAHA imageMessage)');
            }
          } else if (res.hasMedia && res._data?.sentImageUrl) {
            // Fallback: use sentImageUrl from backend (direct image URL or base64) — show blurred
            self.chatMessagesData[msgIndex].media = res._data.sentImageUrl;
            self.chatMessagesData[msgIndex].sentMediaUrl = res._data.sentImageUrl; // full image already available
            self.chatMessagesData[msgIndex].hasMedia = true;
            self.chatMessagesData[msgIndex].type = 'image';
            self.chatMessagesData[msgIndex].style = { filter: 'blur(3px)' };
            self.chatMessagesData[msgIndex].downloadImage = true;
            // Only set caption if it actually has content
            if (res._data.caption && res._data.caption.trim()) {
              self.chatMessagesData[msgIndex].message = res._data.caption;
            } else {
              self.chatMessagesData[msgIndex].message = '';
            }
            console.log('✅ [Chat.vue] Media added (sentImageUrl) — blurred until clicked');
          } else if (res.hasMedia && res.media) {
            // WAHA top-level media field (present when _data.message is absent)
            const mimeType = (res.media.mimetype || '').toLowerCase();
            const isVideo = mimeType.startsWith('video/') || res.type === 'video';
            const isDoc = !isVideo && res.type === 'document';
            if (res.media.jpegThumbnail) {
              self.chatMessagesData[msgIndex].media = 'data:image/jpeg;base64,' + res.media.jpegThumbnail;
            }
            self.chatMessagesData[msgIndex].hasMedia = true;
            self.chatMessagesData[msgIndex].downloadImage = true;
            self.chatMessagesData[msgIndex].style = { filter: 'blur(3px)' };
            if (isVideo) {
              self.chatMessagesData[msgIndex].type = 'video';
            } else if (isDoc) {
              self.chatMessagesData[msgIndex].type = 'document';
              self.chatMessagesData[msgIndex].fileName = res.media.filename || 'document';
              self.chatMessagesData[msgIndex].documentMimeType = mimeType;
            }
            console.log('✅ [Chat.vue] Media added (WAHA media) —', isVideo ? 'video' : (isDoc ? 'document' : 'image'));
          } else if (res._data && "deprecatedMms3Url" in res._data) {
            // wwebjs / WAHA fallback: detect type by res.type or mimetype
            const mimeType = res._data.mimetype || '';
            const isWwebjsVideo = mimeType.startsWith('video/') || res.type === 'video';
            if (isWwebjsVideo) {
              // Real wwebjs embeds full base64 video in body (very long string).
              // WAHA only puts a space placeholder — detect by length.
              const hasRealVideoData = res._data.body && res._data.body.trim().length > 200;
              const effectiveMime = mimeType.startsWith('video/') ? mimeType : 'video/mp4';
              if (hasRealVideoData) {
                try {
                  const vBlob = self.base64ToBlob(res._data.body, effectiveMime);
                  self.chatMessagesData[msgIndex].videoBlobUrl = URL.createObjectURL(vBlob);
                  self.chatMessagesData[msgIndex].downloadImage = false;
                  self.chatMessagesData[msgIndex].style = { filter: 'blur(0px)' };
                } catch (e) {
                  console.warn('[Chat.vue] wwebjs video blob failed, fallback to data URI', e);
                  self.chatMessagesData[msgIndex].videoBlobUrl = 'data:' + effectiveMime + ';base64,' + res._data.body;
                  self.chatMessagesData[msgIndex].downloadImage = false;
                  self.chatMessagesData[msgIndex].style = { filter: 'blur(0px)' };
                }
                self.chatMessagesData[msgIndex].fileName = res._data.filename || 'video';
              } else {
                // No embedded video data — user clicks to download via API
                self.chatMessagesData[msgIndex].downloadImage = true;
                self.chatMessagesData[msgIndex].style = { filter: 'blur(3px)' };
              }
              self.chatMessagesData[msgIndex].type = 'video';
              self.chatMessagesData[msgIndex].hasMedia = true;
              self.chatMessagesData[msgIndex].media = null; // no thumbnail from this path
              console.log('✅ [Chat.vue] Media added (wwebjs) — video', hasRealVideoData ? '(embedded)' : '(needs download)');
            } else {
              // Image/other: use body as base64 data URI only if it looks like real data
              if (res._data.body && res._data.body.trim().length > 0) {
                self.chatMessagesData[msgIndex].media = 'data:' + (mimeType || 'image/jpeg') + ';base64,' + res._data.body;
              }
              if (res.type === 'image' || res.type === 'chat') {
                self.chatMessagesData[msgIndex].style = { filter: 'blur(3px)' };
                self.chatMessagesData[msgIndex].downloadImage = true;
              }
              console.log('✅ [Chat.vue] Media added (wwebjs) — image');
            }
          }
          
          // ✅ Handle quoted message (support both formats)
          if (res.hasQuotedMsg && res._data?.quotedMsg) {
            // wwebjs format
            self.chatMessagesData[msgIndex].quotedMsg = res._data.quotedMsg;
            self.chatMessagesData[msgIndex].quotedParticipant = {
              user: String(res._data.quotedParticipant).replace(/\D/g, ''),
              name: res._data.quotedParticipantName || (String(res._data.quotedParticipant).replace(/\D/g, '') === String(self.phoneNumber).replace(/\D/g, '') ? self.username : 'Anda') || String(res._data.quotedParticipant).replace(/\D/g, '') || 'Unknown'
            };
            console.log('✅ [Chat.vue] Quoted message added (wwebjs)');
            console.log('🔍 [DEBUG] chat_create (UPDATE-wwebjs) Quoted Payload:', {
              rawParticipant: res._data?.quotedParticipant,
              rawParticipantName: res._data?.quotedParticipantName,
              processed: self.chatMessagesData[msgIndex].quotedParticipant
            });
          } else if (res?._data?.message?.extendedTextMessage?.contextInfo?.quotedMessage) {
            // WAHA format
            const quotedMessage = res._data.message.extendedTextMessage.contextInfo.quotedMessage;
            const participant = res._data.message.extendedTextMessage.contextInfo.participant || '';
            const participantPhone = participant.replace(/[^\d]/g, '');
            
            self.chatMessagesData[msgIndex].quotedMsg = {
              body: quotedMessage.conversation || '',
              type: 'chat',
              id: res._data.message.extendedTextMessage.contextInfo.stanzaId || ''
            };
            
            self.chatMessagesData[msgIndex].quotedParticipant = {
              user: participantPhone,
              name: (participantPhone === self.phoneNumber ? self.username : 'Anda') || participantPhone || 'Unknown'
            };
            
            console.log('✅ [Chat.vue] Quoted message added (WAHA)');
            console.log('🔍 [DEBUG] chat_create (UPDATE-WAHA) Quoted Payload:', {
              rawParticipant: participant,
              processed: self.chatMessagesData[msgIndex].quotedParticipant
            });
          }
          
          // ✅ Scroll to bottom
          self.$nextTick(() => {
            setTimeout(() => {
              if (typeof self.scrollToBottom === 'function') {
                self.scrollToBottom("users-chat");
              }
              console.log('✅ [Chat.vue] Scrolled to bottom');
            }, 150);
          });
          
          console.log('🎉 [Chat.vue] MESSAGE ADDED SUCCESSFULLY');
          
        } else {
          console.log('ℹ️ [Chat.vue] Not active conversation');
        }
        
        // ✅ Update localStorage
        if (typeof self.cachingChatData === 'function') {
          self.cachingChatData();
        }
        
      } catch (error) {
        console.error('❌ [Chat.vue] Error handling chat_create:', error);
      }
    });

    this.socket.on("message_deleted", function(data) {
      console.log("[Chat.vue] message_deleted event");
      
      try {
        const res = typeof data === 'string' ? JSON.parse(data) : data;
        
        if (!res || !res.messageId) {
          console.warn('[Chat.vue] Invalid message_deleted data');
          return;
        }
        
        const messageId = res.messageId;
        const extractDigits = v => (v ? String(v).replace(/\D/g, '').replace(/^0/, '62') : null);
        const phone = extractDigits(res.phone) || extractDigits(res.originalPhone) || extractDigits(res.lid) || null;
        
        console.log('[Chat.vue] Delete event:', { messageId, phone });
        
        // ✅ UPDATE ACTIVE CONVERSATION - remove message
        const currentPhone = self.phoneNumber ? String(self.phoneNumber).replace(/\D/g, '') : null;
        const messagePhone = phone;
        const isActiveConversation = currentPhone && currentPhone === messagePhone;
        
        if (isActiveConversation && self.chatMessagesData && Array.isArray(self.chatMessagesData)) {
          console.log('[Chat.vue] ACTIVE CONVERSATION - Removing message');
          
          const messageIndex = self.chatMessagesData.findIndex(msg => {
            const msgId = msg.chatID || msg.id || msg.message_id;
            
            if (msgId === messageId) return true;
            
            if (messageId.includes('_')) {
              const cleanId = messageId.split('_').pop();
              if (msgId === cleanId || (msgId && msgId.includes(cleanId))) {
                return true;
              }
            }
            
            return false;
          });
          
          if (messageIndex !== -1) {
            // ✅ Hapus dari conversation
            self.chatMessagesData.splice(messageIndex, 1);
            console.log('[Chat.vue] Message removed from conversation');
            
            // ✅ UPDATE CHAT LIST
            self.updateChatListAfterDelete(phone);
          } else {
            console.warn('[Chat.vue] Message not found:', messageId);
          }
        } else {
          // ✅ Tidak active conversation - refresh chat list dari server (also try to update preview)
          console.log('[Chat.vue] Not active - fetching fresh data for chat list');
          // Try to update chat preview locally first using multiple phone candidates
          if (self.chatData && Array.isArray(self.chatData)) {
            const normalize = v => String(v || '').replace(/\D/g, '').replace(/^0/, '62');
            const phoneCandidates = [res.phone, res.originalPhone, res.lid].map(extractDigits).filter(Boolean);
            let chatIndex = -1;
            for (const candidate of phoneCandidates) {
              chatIndex = self.chatData.findIndex(chat =>
                (chat.telp && normalize(chat.telp) === candidate) ||
                (chat.phone && normalize(chat.phone) === candidate) ||
                (chat.telp_no && normalize(chat.telp_no) === candidate)
              );
              if (chatIndex !== -1) break;
            }
            if (chatIndex !== -1) {
              self.chatData[chatIndex].message = '🚫 Pesan dihapus';
              self.chatData[chatIndex].type = 'revoked';
              self.chatData.splice(chatIndex, 1, self.chatData[chatIndex]);
            } else if (phone) {
              // No local match, ask server to refresh chat list item (handles LID mapping too)
              self.refreshChatListItem(phone);
            }
          }
        }
        
      } catch (error) {
        console.error('❌ [Chat.vue] Error handling message_deleted:', error);
      }
    });

    // ========================================
    // MESSAGE REVOKE - Handle revoked messages
    // ========================================
    this.socket.on("message_revoke", function(data) {
      console.log("📨 SOCKET: message_revoke event received");
      console.log("📨 SOCKET: message_revoke data:", data);
      
      try {
        const res = typeof data === 'string' ? JSON.parse(data) : data;
        console.log("📨 SOCKET: parsed message_revoke data:", res);
        
        if (!res || !res.messageId) {
          console.warn('[Chat.vue] Invalid message_revoke data');
          return;
        }
        
        const messageId = res.messageId;
        const extractDigits = v => (v ? String(v).replace(/\D/g, '').replace(/^0/, '62') : null);
        const phone = extractDigits(res.phone) || extractDigits(res.originalPhone) || extractDigits(res.lid) || null;
        
        console.log('[Chat.vue] Revoke event:', { messageId, phone });
        
        // ✅ UPDATE ACTIVE CONVERSATION - cari langsung via messageId, tanpa bergantung phone match
        // Ini menangani kasus LID di mana phone di socket (digit LID) ≠ phoneNumber aktif (nomor WA asli)
        const currentPhone = self.phoneNumber ? String(self.phoneNumber).replace(/\D/g, '') : null;
        let revokedMsgFound = false;

        if (self.chatMessagesData && Array.isArray(self.chatMessagesData)) {
          const msgIndex = self.chatMessagesData.findIndex(msg => {
            const msgId = msg.chatID || msg.id || msg.message_id;
            
            if (msgId === messageId) return true;
            
            // Coba dengan full ID
            if (res.fullMessageId && msgId === res.fullMessageId) return true;
            
            // Coba strip prefix (format: xxx_yyy → yyy)
            if (messageId.includes('_')) {
              const cleanId = messageId.split('_').pop();
              if (msgId === cleanId || (msgId && msgId.includes(cleanId))) {
                return true;
              }
            }
            
            return false;
          });
          
          if (msgIndex !== -1) {
            revokedMsgFound = true;
            console.log('[Chat.vue] Marking message as revoked');
            const message = self.chatMessagesData[msgIndex];

            // Jika sudah di-mark revoked oleh deleteMessage(), lewati agar tidak override
            if (message.isRevoked) {
              console.log('[Chat.vue] Message already marked revoked (by deleteMessage), skip socket override');
            } else {
              // Buat object baru agar Vue 3 deteksi perubahan sebagai item baru
              const revokedMsg = {
                ...message,
                isRevoked: true,
                revokedTimestamp: res.timestamp,
                type: 'revoked',
                hasMedia: false,
                fromMe: !!message.fromMe,
                align: message.fromMe ? 'right' : (message.align || ''),
                message: message.fromMe
                  ? 'Anda menghapus pesan ini'
                  : 'Pesan ini dihapus',
                originalBody: message.originalBody || message.message,
                originalType: message.originalType || message.type
              };

              self.chatMessagesData.splice(msgIndex, 1, revokedMsg);
              console.log('✅ [Chat.vue] Message marked as revoked');
            }
          } else {
            console.log('⚠️ [Chat.vue] Message not found in conversation:', messageId);
          }
        }
        
        // ✅ UPDATE CHAT LIST - update preview (cocokkan multiple phone field)
        if (self.chatData && Array.isArray(self.chatData)) {
          const normalize = v => String(v || '').replace(/\D/g, '').replace(/^0/, '62');
          const phoneCandidates = [res.phone, res.originalPhone, res.lid].map(extractDigits).filter(Boolean);
          let chatIndex = -1;
          for (const candidate of phoneCandidates) {
            chatIndex = self.chatData.findIndex(chat =>
              (chat.telp && normalize(chat.telp) === candidate) ||
              (chat.phone && normalize(chat.phone) === candidate) ||
              (chat.telp_no && normalize(chat.telp_no) === candidate)
            );
            if (chatIndex !== -1) break;
          }

          // Fallback: jika phone LID tidak cocok di chatData tapi pesan ditemukan di percakapan aktif,
          // gunakan currentPhone (nomor WA asli) untuk menemukan entry chatData yang benar
          if (chatIndex === -1 && revokedMsgFound && currentPhone) {
            chatIndex = self.chatData.findIndex(chat =>
              chat.telp && normalize(chat.telp) === currentPhone
            );
          }

          if (chatIndex !== -1) {
            // Buat object baru agar Vue 3 deteksi perubahan sebagai item baru
            const updatedChat = {
              ...self.chatData[chatIndex],
              message: res.fromMe ? 'Anda menghapus pesan ini' : 'Pesan ini dihapus',
              type: 'revoked',
              isRevoked: true
            };
            if (res.previewTimestamp) updatedChat.timestamp = res.previewTimestamp;
            self.chatData.splice(chatIndex, 1, updatedChat);
          } else if (phone) {
            // Tidak ada match lokal, refresh dari server
            self.refreshChatListItem(phone);
          }
        }
        
      } catch (error) {
        console.error('❌ [Chat.vue] Error handling message_revoke:', error);
      }
    });


  },
};
</script>

<style>
@import "~vue-awesome-notifications/dist/styles/style.css";
/* Contact List Hover Effect */
.contact-list-item {
  position: relative;
  transition: background-color 0.2s ease;
}

.contact-list-item:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

/* ✅ Dropdown Container - Sejajar dengan badge assigned */
.contact-dropdown-toggle {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  z-index: 100;
}

/* ✅ Show dropdown on hover */
.contact-list-item:hover .contact-dropdown-toggle {
  opacity: 1;
  visibility: visible;
}

/* ✅ Badge geser ke kiri saat hover */
.contact-status-badge {
  transition: transform 0.2s ease;
  transform: translateX(0);
}

.contact-list-item:hover .contact-status-badge {
  transform: translateX(-32px);
}

/* ✅ Dropdown button styling - Tanpa background */
.dropdown-toggle-icon {
  width: 24px;
  height: 24px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: transparent; /* ✅ Tanpa background */
  border: none; /* ✅ Tanpa border */
  transition: all 0.2s ease;
}

.dropdown-toggle-icon:hover {
  background: rgba(0, 0, 0, 0.05); /* ✅ Subtle hover effect */
}

.dropdown-toggle-icon i {
  font-size: 16px;
  color: #6c757d; /* ✅ Abu-abu */
  transition: transform 0.2s ease, color 0.2s ease;
}

.dropdown-toggle-icon:hover i {
  color: #495057; /* ✅ Abu lebih gelap saat hover */
}

/* ✅ Rotate arrow when dropdown is open */
.dropdown-toggle-icon[aria-expanded="true"] i {
  transform: rotate(180deg);
  color: #495057; /* ✅ Lebih gelap saat open */
}

/* ✅ Dropdown menu styling */
.contact-dropdown-toggle .dropdown-menu {
  z-index: 1050;
  min-width: 180px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.08);
  margin-top: 4px;
}

/* ✅ Dropdown items styling */
.contact-dropdown-toggle .dropdown-item {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  transition: background-color 0.15s ease;
}

.contact-dropdown-toggle .dropdown-item:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.contact-dropdown-toggle .dropdown-item i {
  width: 18px;
  font-size: 14px;
}

.contact-dropdown-toggle .dropdown-item.text-danger:hover {
  background-color: rgba(220, 53, 69, 0.1);
}

/* Smooth fade in for messages */
.chat-conversation-list {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Loading spinner animation */
.spinner-border {
  animation: spin 0.75s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Revoked message styling */
.revoked-text {
  color: #ffffff !important;
}
.revoked-inline {
  color: #ffffff !important;
  font-style: italic;
}
.revoked-preview-text {
  color: #a6a6a6; /* muted by default */
  font-style: italic;
}

/* Improve vertical spacing for revoked preview in chat list */
.contact-list-item .revoked-preview-text,
.contact-list-item .deleted-svg {
  /* display: inline-flex;
  align-items: center; */
  padding-top: 2px;
  padding-bottom: 2%;
  line-height: 1.25;
}

/* Make revoked preview white when the chat row is active */
.contact-list-item.active .revoked-preview-text {
  color: #ffffff !important;
}

/* Also handle server-provided HTML that uses .deleted-svg and inline SVG fill */
.contact-list-item .deleted-svg {
  color: #a6a6a6;
}
.contact-list-item.active .deleted-svg,
.contact-list-item.active .deleted-svg i {
  color: #ffffff !important;
}
.contact-list-item.active .deleted-svg svg {
  fill: #ffffff !important;
}

/* Spacing for revoked message row: add targeted gap and vertical centering for outgoing (fromMe) messages
   Keep incoming layout unchanged to avoid shifting bubbles. */
/* Outgoing revoked messages (li.chat-list.right) - center timestamp and add gap */
.chat-list.right .ctext-wrap.revoked-row {
  display: flex;
  align-items: center;
}
.chat-list.right .ctext-wrap.revoked-row .ctext-wrap-content {
  margin-right: 0px !important; /* tighter gap to match image 1 */
  flex: 1 1 auto;
}
.chat-list.right .ctext-wrap.revoked-row .conversation-name {
  margin-top: 0;
  align-self: center !important;
  margin-left: 8px !important;
}

/* Add spacing after agent attribution for outgoing revoked messages (prevents crowding with check icon) */
.chat-list.right .ctext-wrap.revoked-row .conversation-name small.time + small.time {
  margin-right: 12px !important;
}

/* Incoming revoked messages: keep previous behavior (no bubble shift) */
.chat-list.left .ctext-wrap.revoked-row {
  display: flex;
  /* vertically center timestamp with bubble for incoming revoked messages */
  align-items: center;
}
.chat-list.left .ctext-wrap.revoked-row .ctext-wrap-content {
  margin-right: 12px;
  flex: 1 1 auto;
}
.chat-list.left .ctext-wrap.revoked-row .conversation-name {
  margin-top: 0;
  align-self: center !important;
  margin-left: 8px !important;
}

.slide-down-enter-active {
  transition: all 0.3s ease-out;
}

.slide-down-leave-active {
  transition: all 0.3s ease-in;
}

.slide-down-enter-from {
  transform: translateY(-10px);
  opacity: 0;
}

.slide-down-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-input {
  padding-right: 35px;
  height: 36px;
  font-size: 0.750rem;
}

/* Chat input dropups: no extra CSS needed, handled by Bootstrap dropup class */

.btn-close-search {
  position: absolute;
  right: 8px;
  background: none;
  border: none;
  padding: 4px 6px;
  cursor: pointer;
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  transition: color 0.15s ease-in-out;
}

.btn-close-search:hover {
  color: #495057;
}

.btn-close-search i {
  font-size: 16px;
}
/* Spinner overlay for route lookup */
.rls-backdrop {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  /* subtler translucent layer + lighter blur for backdrop */
  background: rgba(0,0,0,0.08);
  backdrop-filter: blur(1.5px);
  -webkit-backdrop-filter: blur(1.5px);
  z-index: 2000;
  pointer-events: auto; /* block interactions while searching */
}
.rls-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  /* remove boxed pill - keep spinner centered with transparent background */
  background: transparent;
  padding: 0;
  border-radius: 0;
  box-shadow: none;
  pointer-events: none;
}
.rls-spinner .spinner-border {
  width: 48px;
  height: 48px;
  border-width: 4px;
  border-top-color: #6f42c1; /* purple */
  border-right-color: #6366F1; /* indigo */
  border-bottom-color: rgba(99,102,241,0.3);
  border-left-color: rgba(0,163,255,0.25);
}
.rls-text {
  font-size: 0.95rem;
  color: #6f42c1; /* purple text */
  font-weight: 600;
}

/* Global Search Results */
.search-results-container {
  background: var(--vz-card-bg);
  border-radius: 4px;
  border: 1px solid var(--vz-border-color);
}
.search-results-list {
  scrollbar-width: thin;
}
.search-result-item {
  transition: background-color 0.15s ease;
}
.search-result-item:hover {
  background-color: var(--vz-light);
}
.search-result-item mark,
.search-highlight {
  background-color: #ffc107;
  color: #000;
  padding: 0 2px;
  border-radius: 2px;
}

/* Search Category Headers */
.search-category-header {
  background-color: var(--vz-light);
  padding: 6px 12px;
  margin-top: 4px;
  border-bottom: 1px solid var(--vz-border-color);
}
.search-category-header .category-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--vz-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.search-category-header .category-label i {
  font-size: 12px;
}

/* WA-style media card: image/video/document + caption in one bubble */
.media-card {
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  width: 300px;
  max-width: 100%;
  display: block;
  /* Default (received = left): same as .ctext-wrap-content left bubble */
  background-color: var(--vz-card-bg-custom, #fff);
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 4px;
}
/* Sent (right) bubble: match $xmarks2 = #47B6D1 */
.chat-list.right .media-card {
  background-color: #47B6D1;
  border-color: transparent;
  color: #fff;
}
.chat-list.right .media-card .media-card-caption {
  color: #fff;
}
/* The image itself fills the padded inner area with its own rounded corners */
.message-img .media-card-img {
  max-width: none !important;
  width: 100%;
  display: block;
  object-fit: cover;
  max-height: 320px;
  min-height: 120px;
  background: #000;
  /* Top radius only when caption follows; full radius when no caption (handled below) */
  border-radius: 7px;
}
/* Caption sits below the image with card padding in between — keep all corners rounded */
.media-card-img-has-caption {
  border-radius: 7px !important;
}
.media-card-caption {
  padding: 5px 6px 4px;
  font-size: 13px;
  line-height: 1.45;
  word-break: break-word;
  text-align: left;
}
.media-card-play-btn {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

/* Video modal overlay styles */
.video-modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.6);
  z-index: 4000;
  padding: 20px;
}
.video-modal-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Attachment overlay modal to avoid layout shift when uploading */
.attachment-modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.65);
  z-index: 5000;
  padding: 20px;
}
.attachment-modal-container {
  width: 100%;
  max-width: 720px;
  background: var(--vz-card-bg, #fff);
  color: var(--vz-body-color, #212529);
  border-radius: 10px;
  box-shadow: 0 16px 48px rgba(0,0,0,0.55);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--vz-border-color, rgba(0,0,0,0.1));
}
.attachment-modal-header {
  padding: 14px 18px;
  border-bottom: 1px solid var(--vz-border-color, rgba(0,0,0,0.1));
  background: var(--vz-card-cap-bg, var(--vz-card-bg, #fff));
  color: var(--vz-heading-color, var(--vz-body-color, #212529));
}
.attachment-modal-header h5 {
  color: var(--vz-heading-color, var(--vz-body-color, #212529));
  margin: 0;
}
.attachment-modal-body {
  padding: 14px 18px;
  max-height: 65vh;
  overflow: auto;
  background: var(--vz-card-bg, #fff);
}
.attachment-modal-footer {
  padding: 12px 18px;
  border-top: 1px solid var(--vz-border-color, rgba(0,0,0,0.1));
  background: var(--vz-card-cap-bg, var(--vz-card-bg, #fff));
}

/* Dark mode overrides for attachment modal */
[data-layout-mode="dark"] .attachment-modal-container {
  background: #212529;
  color: #ced4da;
  border-color: rgba(255,255,255,0.1);
}
[data-layout-mode="dark"] .attachment-modal-header {
  background: #212529;
  border-bottom-color: rgba(255,255,255,0.1);
}
[data-layout-mode="dark"] .attachment-modal-header h5 {
  color: #eff2f7;
}
[data-layout-mode="dark"] .attachment-modal-body {
  background: #212529;
}
[data-layout-mode="dark"] .attachment-modal-footer {
  background: #212529;
  border-top-color: rgba(255,255,255,0.1);
}

/* ✅ SOCKET DEBUG PANEL */
.debug-panel-overlay {
  position: fixed;
  top: 70px;
  right: 20px;
  width: 350px;
  max-height: 80vh;
  background: var(--vz-card-bg, #fff);
  border: 1px solid var(--vz-border-color);
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.15);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: 'Courier New', Courier, monospace;
}
.debug-panel-header {
  padding: 10px 15px;
  background: var(--vz-light);
  border-bottom: 1px solid var(--vz-border-color);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.debug-panel-body {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  font-size: 11px;
}
.debug-log-item {
  padding: 8px;
  border-bottom: 1px solid var(--vz-border-color);
  margin-bottom: 5px;
  border-radius: 4px;
  background: rgba(0,0,0,0.02);
}
.debug-log-time {
  color: var(--vz-secondary);
  font-weight: bold;
  margin-right: 5px;
}
.debug-log-event {
  color: var(--vz-primary);
  font-weight: 800;
  text-transform: uppercase;
}
.debug-log-payload {
  margin-top: 5px;
  white-space: pre-wrap;
  word-break: break-all;
  color: var(--vz-body-color);
  background: rgba(0,0,0,0.03);
  padding: 5px;
  border-radius: 3px;
}
.debug-empty {
  text-align: center;
  padding: 20px;
  color: var(--vz-muted);
}
[data-layout-mode="dark"] .debug-log-payload {
  background: rgba(255,255,255,0.05);
}
</style>

<template>
  <Layout>
    <div class="chat-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1">
      <div class="chat-leftsidebar" id="contactChatMessageList">
        <div class="pt-4">
          <div class="px-4">
            <div class="d-flex align-items-start">
              <div class="flex-grow-1">
                <h5 class="mb-4">Inbox</h5>
              </div>
              <div class="flex-shrink-0" v-if="this.fetchChatRoom">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </div>
              <template v-else>
                <div class="flex-shrink-0 me-2">
                  <button type="button" 
                    class="btn btn-outline-primary btn-sm btn-icon waves-effect waves-light shadow-none"
                    @click="toggleSearch">
                    <i class="ri-search-line"></i>
                  </button>
                </div>
                <!-- Socket Debugger Button (Hidden) -->
                <div v-if="false" class="flex-shrink-0 ms-2">
                  <div class="flex-shrink-0 ms-2">
                  <button type="button" 
                    :class="['btn btn-outline-info btn-sm btn-icon waves-effect waves-light shadow-none', { 'active': showDebugPanel }]"
                    @click="showDebugPanel = !showDebugPanel"
                    title="Socket Debugger">
                    <i class="ri-bug-line"></i>
                  </button>
                </div>
                </div>
                <div class="flex-shrink-0 ms-2">
                  <button type="button" id="btnRefresh"
                    class="btn btn-outline-primary btn-sm btn-icon waves-effect waves-light shadow-none"
                    @click="refreshChatRoom">
                    <i class="ri-refresh-line"></i>
                  </button>
                </div>
              </template>
            </div>

            <!-- Search Field dengan Transition -->
            <transition name="slide-down">
              <div v-if="showSearch" class="mb-3">
                <div class="search-wrapper">
                  <input 
                    type="text" 
                    class="form-control form-control-sm search-input" 
                    placeholder="Search all messages..."
                    v-model="searchQuery"
                    @input="handleSearch"
                    ref="searchInput">
                  <button class="btn-close-search" type="button" @click="clearSearch">
                    <i class="ri-close-line"></i>
                  </button>
                </div>
                
                <!-- Search Status Info -->
                <div v-if="searchQuery.length >= 2" class="search-status-info mt-2 px-1">
                  <div v-if="globalSearchLoading" class="text-muted small">
                    <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                    Searching...
                  </div>
                  <div v-else-if="globalSearchMeta" class="d-flex align-items-center justify-content-between">
                    <span class="text-muted small">
                      <i class="ri-search-line me-1"></i>
                      {{ globalSearchMeta.totalChats }} chat, {{ globalSearchMeta.totalContacts }} kontak, {{ globalSearchMeta.totalMessages }} pesan
                    </span>
                  </div>
                  <div v-else-if="!globalSearchLoading && chatData.length === 0" class="text-muted small">
                    No results found for "{{ searchQuery }}"
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <!-- Nav tabs - Hidden when in search mode -->
          <ul v-show="!isSearchMode" class="tabStatus nav nav-tabs nav-tabs-custom nav-success nav-justified" role="tablist"
            style="font-size: 9px;">
            <li class="nav-item tabLi">
              <a class="nav-link active" data-bs-toggle="tab" href="#all" data-status="all" @click="getUser('all')"
                role="tab">
                All
              </a>
            </li>
            <li class="nav-item tabLi">
              <a class="nav-link" data-bs-toggle="tab" href="#all" data-status="unassigned" @click="getUser('unassigned')"
                role="tab">
                Unassigned
              </a>
            </li>
            <li class="nav-item tabLi">
              <a class="nav-link" data-bs-toggle="tab" href="#all" data-status="assigned" @click="getUser('assigned')"
                role="tab">
                Assigned
              </a>
            </li>
            <li class="nav-item tabLi">
              <a class="nav-link" data-bs-toggle="tab" href="#all" data-status="resolved" @click="getUser('resolved')"
                role="tab">
                Resolved
              </a>
            </li>
          </ul>
        </div>
        <!-- .p-4 -->

        <div class="chat-room-list" id="contactSimpleBar" ref="contactSimpleBar" style="max-height: calc(100vh - 235px)"
          data-simplebar>
          <div class="col-xxl-12">
            <!-- Tab panes -->
            <div class="tab-content text-muted">
              <div class="tab-pane active" id="all" role="tabpanel">
                <div v-if="this.chatData.length === 0 && !this.shimmerOn" class="chat-message-list mt-5">
                  <img :src="this.userNotFound" />
                  <p class="text-center mt-2">No User Found</p>
                </div>

                <div class="chat-message-list">
                  <SimpleBar ref="contactList" v-if="this.chatData.length !== 0"
                    class="list-unstyled chat-list chat-user-list">
                    
                    <!-- Category Headers for Search Mode -->
                    <template v-if="isSearchMode">
                      <!-- Chats Section -->
                      <template v-if="searchChats.length > 0">
                        <li class="search-category-header">
                          <span class="category-label"><i class="ri-chat-3-line me-1"></i>Chat</span>
                        </li>
                        <li v-for="data of chatData.filter(d => d.category === 'chat')" :key="data.id"
                            :class="[{ active: this.username == data.name }]" :id="`row-${data.id}`"
                            class="contact-list-item position-relative search-result-item">
                          <a href="#" @click.prevent="openSearchResult(data)" class="contact-link">
                            <div class="d-flex align-items-center w-100">
                              <div class="flex-shrink-0 chat-user-img align-self-center me-2 ms-0">
                                <div class="avatar-xs" v-if="data.image">
                                  <img :src="data.image" 
                                      class="rounded-circle img-fluid userprofile" 
                                      @error="handleImageError($event, data)"
                                      alt="" />
                                </div>
                                <div class="avatar-xs" v-else>
                                  <div class="avatar-title rounded-circle bg-success userprofile">
                                    {{ getInitials(data.name) }}
                                  </div>
                                </div>
                              </div>
                              <div class="flex-grow-1 overflow-hidden">
                                <p class="text-truncate m-0 mt-1 fw-medium">{{ data.name }}</p>
                                <p class="text-truncate text-muted mb-0" style="font-size: 10px;">
                                  <span v-if="data.messageHighlight" v-html="data.messageHighlight"></span>
                                  <span v-else>{{ data.telp }}</span>
                                </p>
                              </div>
                              <div class="flex-shrink-0 ms-2 text-end">
                                <small class="text-muted" style="font-size: 10px">{{ chatRoomTime(data.timestamp) }}</small>
                              </div>
                            </div>
                          </a>
                        </li>
                      </template>

                      <!-- Contacts Section -->
                      <template v-if="searchContacts.length > 0">
                        <li class="search-category-header">
                          <span class="category-label"><i class="ri-contacts-line me-1"></i>Kontak</span>
                        </li>
                        <li v-for="data of chatData.filter(d => d.category === 'contact')" :key="data.id"
                            :class="[{ active: this.username == data.name }]" :id="`row-${data.id}`"
                            class="contact-list-item position-relative search-result-item">
                          <a href="#" @click.prevent="openSearchResult(data)" class="contact-link">
                            <div class="d-flex align-items-center w-100">
                              <div class="flex-shrink-0 chat-user-img align-self-center me-2 ms-0">
                                <div class="avatar-xs" v-if="data.image">
                                  <img :src="data.image" 
                                      class="rounded-circle img-fluid userprofile" 
                                      @error="handleImageError($event, data)"
                                      alt="" />
                                </div>
                                <div class="avatar-xs" v-else>
                                  <div class="avatar-title rounded-circle bg-info userprofile">
                                    {{ getInitials(data.name) }}
                                  </div>
                                </div>
                              </div>
                              <div class="flex-grow-1 overflow-hidden">
                                <p class="text-truncate m-0 mt-1 fw-medium">{{ data.name }}</p>
                                <p class="text-truncate text-muted mb-0" style="font-size: 10px;">
                                  {{ data.telp }}
                                </p>
                                <p v-if="data.Tags" class="text-truncate mb-0" style="font-size: 10px;">
                                  <i class="ri-price-tag-3-line text-muted"></i>
                                  <span class="text-muted">{{ data.Tags }}</span>
                                </p>
                              </div>
                              <div class="flex-shrink-0 ms-2 text-end">
                                <span class="badge rounded-pill" :class="getStatusBadgeClass(data.status)" style="font-size: 9px">
                                  {{ data.status }}
                                </span>
                              </div>
                            </div>
                          </a>
                        </li>
                      </template>

                      <!-- Messages Section -->
                      <template v-if="searchMessages.length > 0">
                        <li class="search-category-header">
                          <span class="category-label"><i class="ri-message-2-line me-1"></i>Pesan</span>
                        </li>
                        <li v-for="data of chatData.filter(d => d.category === 'message')" :key="data.id"
                            :class="[{ active: this.username == data.name }]" :id="`row-${data.id}`"
                            class="contact-list-item position-relative search-result-item">
                          <a href="#" @click.prevent="openSearchResult(data)" class="contact-link">
                            <div class="d-flex align-items-center w-100">
                              <div class="flex-grow-1 overflow-hidden">
                                <p class="text-truncate m-0 mt-1 fw-medium">
                                  {{ data.name }}
                                </p>
                                <p class="text-truncate mb-0" style="font-size: 11px;">
                                  <span v-if="data.fromMe" class="text-primary">Anda: </span>
                                  <span v-html="data.messageHighlight"></span>
                                </p>
                              </div>
                              <div class="flex-shrink-0 ms-2 text-end">
                                <small class="text-muted" style="font-size: 10px">{{ chatRoomTime(data.timestamp) }}</small>
                              </div>
                            </div>
                          </a>
                        </li>
                      </template>
                    </template>

                    <!-- Normal Chat List (when not in search mode) -->
                    <template v-else>
                      <li ref="listUser" v-for="data of contactListpaginate" :key="data.id" 
                          :class="[{ active: this.username == data.name }]" :id="`row-${data.id}`"
                          class="contact-list-item position-relative">
                        <a href="#" @click.prevent="chatUsername(data.name, data.image, data.telp, data.id)" 
                          class="contact-link">
                          <div class="d-flex align-items-center w-100">
                            <!-- Avatar dengan foto profil -->
                            <div class="flex-shrink-0 chat-user-img online align-self-center me-2 ms-0">
                              <div class="avatar-xs" v-if="data.image">
                                <img :src="data.image" 
                                    :id="`image-${data.telp}`"
                                    class="rounded-circle img-fluid userprofile" 
                                    @error="handleImageError($event, data)"
                                    alt="" />
                              </div>
                              <div class="avatar-xs" v-else>
                                <div class="avatar-title rounded-circle bg-primary userprofile">
                                  {{ getInitials(data.name) }}
                                </div>
                              </div>
                            </div>

                            <div class="flex-grow-1 overflow-hidden">
                              <p :id="`name-${data.telp}`" class="text-truncate m-0 mt-1">
                                {{ data.name }}
                              </p>
                              
                              <!-- Last message -->
                              <div v-if="data.shimmer" class="flex-grow-1">
                                <p class="col-8 m-0" style="font-size: 10px;">waiting...</p>
                              </div>
                              <div v-else>
                                <!-- Text message -->
                                <p v-if="!data.hasMedia"
                                  :class="['text-truncate', 'text-weight', { 'fw-bold': data.unread_count }]"
                                  style="font-size: 10px; margin: 0">
                                  <template v-if="data.type === 'revoked' || data.isRevoked">
                                    <span class="deleted-svg" style="display:inline-flex;align-items:center;vertical-align:middle;margin-right:4px;">
                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14" fill="#a6a6a6" style="opacity:1;vertical-align:middle"><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16M8.523 7.109l8.368 8.368a6 6 0 0 1-1.414 1.414L7.109 8.523A6 6 0 0 1 8.523 7.11"/></svg>
                                    </span>
                                    <i :class="['revoked-preview-text', (data.fromMe || data.align === 'right') ? '' : 'text-muted']">
                                      {{ (data.fromMe || data.align === 'right') ? 'Anda menghapus pesan ini' : 'Pesan ini dihapus' }}
                                    </i>
                                  </template>
                                  <template v-else>
                                    <i v-show="data.fromMe && !(data.type === 'revoked' || data.isRevoked)" :class="getAckIconClass(data.ack, data.fromMe)"></i>
                                    <span v-if="data.fromMe">&nbsp;</span>
                                    <span v-html="data.message"></span>
                                  </template>
                                </p>
                                
                                <!-- Media message -->
                                <p v-else
                                  :class="['text-truncate', 'text-weight', { 'fw-bold': data.unread_count }]"
                                  style="font-size: 10px; margin: 0">
                                  <i v-show="data.fromMe && !(data.type === 'revoked' || data.isRevoked)" :class="getAckIconClass(data.ack, data.fromMe)"></i>
                                  <i :class="getMediaIcon(data.type)"></i>&nbsp;
                                  <!-- Jika bertipe dokumen, tampilkan unsupported content message sebagai preview di sidebar -->
                                  <span v-if="data.hasMedia && data.type !== 'revoked'">{{ data.type === 'image' ? 'Image' : data.type === 'video' ? 'Video' : data.type === 'document' ? 'unsupported content message' : data.type === 'audio' ? 'Audio' : data.type === 'sticker' ? 'Sticker' : 'Media' }}</span>
                                  <span v-show="data.type === 'revoked'"><i :class="['revoked-preview-text', (data.fromMe || data.align === 'right') ? '' : 'text-muted']">pesan ini dihapus</i></span>
                                </p>
                              </div>
                              
                              <!-- Tags -->
                              <p v-if="data.Tags" 
                                class="text-truncate text-weight" 
                                style="font-size: 10px; width: 100px">
                                <i class="ri-price-tag-3-line"></i>
                                {{ data.Tags }}
                              </p>
                              <p v-else 
                                class="text-truncate text-weight" 
                                style="font-size: 10px; width: 100px">
                                <i class="ri-price-tag-3-line"></i>
                                No Tags
                              </p>
                            </div>

                            <!-- Timestamp dan status -->
                            <div class="flex-grow-1 float-end ms-2" style="margin-top: -15px">
                              <div v-if="data.shimmer">
                                <small class="col-8 m-0 time float-end text-end"
                                      style="height:15px;margin-top: 8px; font-size: 10px;">00:00</small>
                              </div>
                              <small v-else class="time float-end" style="font-size: 10px">
                                {{ chatRoomTime(data.timestamp) }}
                              </small>
                              <br />
                              <span v-show="data.unread_count" 
                                    class="badge rounded-pill badge-soft-danger float-end"
                                    style="font-size: 10px">{{ data.unread_count }}</span>
                              <br />
                              <span class="badge rounded-pill float-end contact-status-badge" 
                                    :class="getStatusBadgeClass(data.status)" 
                                    style="font-size: 10px">{{ data.status }}</span>
                            </div>
                          </div>
                        </a>
                        
                        <!-- Dropdown menu -->
                        <div class="contact-dropdown-toggle" @click.stop>
                          <button class="btn btn-sm btn-ghost-secondary btn-icon shadow-none dropdown-toggle-icon" 
                                  type="button" 
                                  data-bs-toggle="dropdown" 
                                  aria-expanded="false">
                            <i class="ri-arrow-down-s-line"></i>
                          </button>
                          <ul class="dropdown-menu dropdown-menu-end">
                            <li>
                              <a class="dropdown-item text-danger" href="#" @click.prevent="deleteChat(data)">
                                <i class="ri-delete-bin-line me-2 align-bottom"></i>
                                Delete chat
                              </a>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </template>
                  </SimpleBar>
                </div>
              </div>
            </div>
          </div>
          <!-- End chat-message-list -->
        </div>
      </div>
      <!-- end chat leftsidebar -->
      <!-- Start User chat -->
      <div v-if="phoneNumber && username" id="conv-1" class="user-chat w-100 overflow-hidden">
        <div class="chat-content d-lg-flex">
          <div class="w-100 overflow-hidden position-relative">
            <div class="position-relative">
              <div class="p-3 user-chat-topbar">
                <div class="row align-items-center">
                  <div class="col-sm-4 col-8">
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0 d-block d-lg-none me-3">
                        <a @click.prevent="closeConvertation" href="#" class="user-chat-remove fs-18 p-1">
                          <i class="ri-arrow-left-s-line align-bottom"></i>
                        </a>
                      </div>
                      <div class="flex-grow-1 overflow-hidden">
                        <div class="d-flex align-items-center">
                          <div class="flex-shrink-0 chat-user-img online user-own-img align-self-center me-3 ms-0">
                            <img :src="profile ? profile : require('@/assets/images/users/user-dummy-img.jpg')" 
                                 class="rounded-circle avatar-xs" alt="" />
                          </div>
                          <div class="flex-grow-1 overflow-hidden">
                            <h5 class="text-truncate mb-0 fs-16">
                              <a class="text-reset username" data-bs-toggle="offcanvas" 
                                 href="#userProfileCanvasExample" aria-controls="userProfileCanvasExample">
                                {{ username }}
                              </a>
                            </h5>
                            <p class="text-truncate text-muted fs-14 mb-0 userStatus">
                              <small>{{ phoneNumber }}</small>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-8 col-4">
                    <ul class="list-inline user-chat-nav text-end mb-0">
                      <!-- Assign Button -->
                      <li class="list-inline-item m-0 border-end pe-3" 
                          v-if="user.Role.Code === 'principal' && userStatus !== 'resolved'">
                        <div class="dropdown d-inline-block align-middle">
                          Assigned to:
                          <button class="btn btn-outline-success shadow-none btn-sm" type="button" 
                                  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Assign +
                          </button>
                          <div class="dropdown-menu p-0 dropdown-menu-end dropdown-menu-lg">
                            <div class="p-2">
                              <div class="search-box">
                                <input type="text" class="form-control bg-light border-light" 
                                       placeholder="Search here..." id="searchAgent" v-model="searchAgentInput" />
                                <i class="ri-search-2-line search-icon"></i>
                              </div>
                            </div>
                            <div style="max-height: 250px; overflow: scroll; overflow-x: hidden;">
                              <div v-for="(data, index) of searchAgent" class="p-2" :key="index">
                                <div class="card mb-1 ribbon-box ribbon-fill ribbon-sm">
                                  <div class="card-body">
                                    <a class="d-flex align-items-center" @click.prevent="assignedAgent = data; assignAgent(data.ID, userid)">
                                      <div class="flex-shrink-0">
                                        <img :src="avatarUrl(data)" alt="" class="avatar-xs rounded-circle shadow" />
                                      </div>
                                      <div class="flex-grow-1 ms-3">
                                        <h6 class="fs-14 mb-1">
                                          {{ data.Name || 'Unknown Agent' }}
                                          <span v-if="assignedAgent && assignedAgent.ID === data.ID" class="badge bg-success text-white ms-2" style="font-size:10px; vertical-align:middle">Currently</span>
                                        </h6>
                                        <p class="text-muted mb-0">{{ data.Role ? data.Role.Title : 'No Role' }}</p>
                                      </div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>

                      <!-- Resolve Button -->
                      <li class="list-inline-item m-0 ms-1" v-if="userStatus == 'assigned'">
                        <button type="button" 
                                class="btn btn-info btn-label btn-sm waves-effect waves-light rounded-pill" 
                                @click="resolveCustomer(3)">
                          <i class="ri-check-double-line label-icon align-middle rounded-pill fs-16 me-2"></i>
                          Resolve
                        </button>
                      </li>

                      <!-- Search Button -->
                      <li class="list-inline-item m-0 ms-1" 
                          onclick="document.querySelector('#searchMessage').focus()">
                        <div class="dropdown">
                          <button class="btn btn-ghost-secondary btn-icon shadow-none" type="button" 
                                  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <SearchIcon class="icon-sm"></SearchIcon>
                          </button>
                          <div class="dropdown-menu p-0 dropdown-menu-end dropdown-menu-lg">
                            <div class="p-2">
                              <div class="search-box">
                                <input v-model="searchChatInput" type="text" 
                                       class="form-control bg-light border-light" 
                                       placeholder="Search here..." id="searchMessage" />
                                <i class="ri-search-2-line search-icon"></i>
                              </div>
                              <div v-if="resultSearchMessage.length" 
                                   style="max-height: 250px; overflow: scroll; overflow-x: hidden;">
                                <div class="p-2">
                                  <div class="card mb-2" v-for="data in resultSearchMessage" :key="data.chatID">
                                    <div class="card-body" @click="goToMessageSearch(data)">
                                      <a class="d-flex align-items-center">
                                        <div class="flex-grow-1">
                                          <h6 class="fs-14 mb-1">
                                            {{ this.chatConvertationTime(parseInt(data.time)) }}
                                          </h6>
                                          <p class="text-muted mb-0">
                                            <i class="ri-check-double-fill" style="margin-top: 10px;" 
                                               v-if="data.align == 'right'"></i>
                                            {{ data.message }}
                                          </p>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>

                      <!-- Info Button -->
                      <li class="list-inline-item d-none d-lg-inline-block m-0">
                        <button type="button" class="btn btn-ghost-secondary btn-icon shadow-none" 
                                data-bs-toggle="offcanvas" data-bs-target="#userProfileCanvasExample" 
                                aria-controls="userProfileCanvasExample" @click="getUserDetil">
                          <i class="ri-information-line" style="font-size: 20px"></i>
                        </button>
                      </li>

                      <!-- Close Button -->
                      <li class="list-inline-item d-none d-lg-inline-block m-0">
                        <button type="button" class="btn btn-ghost-secondary btn-icon shadow-none" 
                                @click="closeConvertation">
                          <i class="ri-close-line" style="font-size: 20px"></i>
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- end chat user head -->

              <!-- ========================================
                   CHAT MESSAGES AREA
                   ======================================== -->
              <div class="position-relative" id="users-chat">
                
                <!-- Upload Form (overlay) -->
                <div v-if="this.showFormUpload" class="attachment-modal-overlay" @click="closeFormUpload">
                  <div class="attachment-modal-container" @click.stop>
                    <div class="attachment-modal-header d-flex justify-content-between align-items-center">
                      <h5 class="mb-0">Upload File</h5>
                      <div>
                        <button type="button" class="btn btn-sm btn-light me-2" @click.stop="deleteRecord" title="Remove selected">
                          <i class="ri-delete-bin-line"></i>
                        </button>
                        <button type="button" class="btn-close" @click="closeFormUpload" aria-label="Close"></button>
                      </div>
                    </div>

                    <div class="attachment-modal-body">
                      <DropZone @drop.prevent="drop" @change="selectedFile" />
                      <ul class="list-unstyled mb-0" id="dropzone-preview">
                        <div class="border rounded p-2 mb-2" v-for="(file, index) of files" :key="index">
                          <div class="d-flex align-items-center">
                            <div class="flex-shrink-0 me-3">
                              <div class="avatar-sm bg-light rounded">
                                <img data-dz-thumbnail="" class="img-fluid rounded d-block" :src="imagesPreview" alt="preview" style="max-width:64px;" />
                              </div>
                            </div>
                            <div class="flex-grow-1">
                              <div class="pt-1">
                                <h5 class="fs-14 mb-1" data-dz-name="">{{ file.name }}</h5>
                                <p class="fs-13 text-muted mb-0" data-dz-size=""><strong>{{ Math.round((file.size || 0) / 1024) }}</strong> KB</p>
                                <strong class="error text-danger" data-dz-errormessage=""></strong>
                              </div>
                            </div>
                            <div class="flex-shrink-0 ms-3">
                              <button data-dz-remove="" class="btn btn-sm btn-danger" @click="deleteRecord">Delete</button>
                            </div>
                          </div>
                        </div>
                      </ul>
                    </div>

                    <div class="attachment-modal-footer text-end">
                      <button class="btn btn-sm btn-secondary me-2" @click="closeFormUpload">Cancel</button>
                      <button class="btn btn-sm btn-primary" @click="formSubmit" :disabled="isSending">
                        <span v-if="isSending" class="d-flex align-items-center gap-2">
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          Sending...
                        </span>
                        <span v-else>Send</span>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Chat Conversation -->
                <div class="chat-conversation p-3 p-lg-4" id="chat-conversation" 
                     v-if="!this.showFormUpload" data-simplebar ref="current">
                  
                  <!-- ✅ LOADING STATE - NEW! -->
                  <div v-if="loadingConversation" class="text-center" style="padding: 100px 20px;">
                    <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="text-muted mt-3 mb-0">Loading conversation...</p>
                  </div>
                  
                  <!-- ✅ EMPTY STATE - Only show if NOT loading and NO messages -->
                  <div v-else-if="!loadingConversation && chatMessagesData.length === 0" 
                      class="text-center" style="padding: 40px 20px;">
                    <div class="avatar-xl mx-auto mb-4">
                      <div class="avatar-title bg-soft-primary text-primary rounded-circle">
                        <i class="ri-message-3-line display-4"></i>
                      </div>
                    </div>
                    <h5 class="mb-2">No messages yet</h5>
                    <p class="text-muted mb-4">
                      Start the conversation with <strong>{{ username }}</strong>
                    </p>
                    <div class="text-muted">
                      <i class="ri-arrow-down-line me-1"></i>
                      Type a message below to begin
                    </div>
                  </div>

                  <!-- ✅ MESSAGES LIST - Original code preserved -->
                  <ul v-else class="list-unstyled chat-conversation-list h-auto">
                    <li v-for="(data, index) of chatMessagesData" :key="data.chatID || index" 
                        :class="{
                          right: `${data.align}` === 'right',
                          left: `${data.align}` !== 'right',
                          'bg-soft-warning': data.showHightlight
                        }" 
                        class="chat-list" :id="'buble-' + index">
                      <div class="conversation-list">
                        <div class="chat-avatar" v-if="data.align !== 'right'">
                          <img :src="profile ? profile : require('@/assets/images/users/user-dummy-img.jpg')" alt="" />
                        </div>
                        <div class="user-chat-content">
                          
                          <!-- Message with Media -->
                          <div class="ctext-wrap" v-show="data.hasMedia && data.type !== 'revoked' && !data.isRevoked">
                            <!-- Right side actions (your messages) -->
                            <div class="message-img-link ml-4" v-if="data.align === 'right'">
                              <ul class="list-inline mb-0">
                                <li class="list-inline-item dropdown" v-if="data.type !== 'revoked' && !data.isRevoked">
                                  <a class="dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" 
                                     aria-haspopup="true" aria-expanded="false">
                                    <i class="ri-more-fill"></i>
                                  </a>
                                  <div class="dropdown-menu">
                                    <a class="dropdown-item reply-message" href="#" @click.prevent="
                                      replyMessages(
                                        data.message,
                                        data.align === 'right' ? 'You' : username,
                                        data.id || data.message_id || data.chatID,
                                        data.hasMedia,
                                        data
                                      )
                                    ">
                                      <i class="ri-reply-line me-2 text-muted align-bottom"></i>Reply
                                    </a>
                                    <a class="dropdown-item" href="#">
                                      <i class="ri-share-line me-2 text-muted align-bottom"></i>Forward
                                    </a>
                                    <a class="dropdown-item" href="#" @click.prevent="showDeleteModal(data)">
                                      <i class="ri-delete-bin-5-line me-2 text-muted align-bottom"></i>Delete
                                    </a>
                                    <a v-if="data.ack === 4" class="dropdown-item" href="#" @click="resendMessage(data)">
                                      <i class="ri-send-plane-fill me-2 text-muted align-bottom"></i>Resend
                                    </a>
                                    <a class="dropdown-item" href="#" v-if="data.downloadImage" 
                                       @click.prevent="downloadMedia(index)">
                                      <i class="ri-download-cloud-2-line me-2 text-muted align-bottom"></i>Download
                                    </a>
                                  </div>
                                </li>
                              </ul>
                              <div class="conversation-name">
                                <small class="text-muted time">{{ chatConvertationTime(data.time) }}</small>
                                <small class="text-muted time" v-if="'agent' in data && data.agent && data.agent.Name">
                                  by. {{ data.agent.Name }} • {{ data.agent.Role ? data.agent.Role.Title : '' }}
                                </small>
                                <span class="check-message-icon">
                                  <i class="align-bottom" :class="[
                                    { 'ri-check-double-line text-info': data.ack === 4 && data.fromMe },
                                    { 'ri-time-line text-muted': data.ack === 0 && data.fromMe },
                                    { 'ri-check-double-line text-info': data.ack === 3 && data.fromMe },
                                    { 'ri-check-line': data.ack === 1 && data.fromMe },
                                    { 'ri-check-double-line': data.ack === 2 && data.fromMe },
                                  ]"></i>
                                </span>
                              </div>
                            </div>
                            
                            <!-- Media Display -->
                            <div class="message-img mb-0">
                              <div class="message-img-list">
                                <div>
                                  <!-- Image card: image + caption in one WA-style bubble -->
                                  <div v-if="data.type === 'image'"
                                       class="media-card"
                                       @click.prevent="setDataModal(data, index)">
                                    <img :id="`chat-images-${index}`" :src="data.media" alt=""
                                         :style="data.style"
                                         :class="['media-card-img', data.message ? 'media-card-img-has-caption' : '']" />
                                    <div v-if="data.message" class="media-card-caption">
                                      <span v-html="data.message" class="text-break"></span>
                                    </div>
                                  </div>

                                  <!-- Video card: thumbnail + play button + caption -->
                                  <div v-if="data.type === 'video'"
                                       class="media-card"
                                       @click.prevent="setDataModal(data, index)">
                                    <div style="position:relative;">
                                      <!-- Show thumbnail if available, otherwise a dark placeholder -->
                                      <img v-if="data.media" :src="data.media" alt="video thumbnail"
                                           :style="data.style"
                                           :class="['media-card-img', data.message ? 'media-card-img-has-caption' : '']" />
                                      <div v-else
                                           :class="['media-card-img', data.message ? 'media-card-img-has-caption' : '']"
                                           style="background:#1a1a2e; display:flex; align-items:center; justify-content:center; min-height:160px;"></div>
                                      <div class="media-card-play-btn">
                                        <i class="ri-play-circle-fill" style="font-size:56px; color:rgba(255,255,255,0.92); text-shadow:0 2px 10px rgba(0,0,0,0.6);"></i>
                                      </div>
                                    </div>
                                    <div v-if="data.message" class="media-card-caption">
                                      <span v-html="data.message" class="text-break"></span>
                                    </div>
                                  </div>

                                  <!-- Sticker (transparent, no card) -->
                                  <div v-if="data.type === 'sticker'"
                                       @click.prevent="setDataModal(data, index)"
                                       style="cursor:pointer; display:inline-block;">
                                    <img :src="data.media" alt="" style="width:120px; display:block;" />
                                  </div>

                                  <!-- Document card: icon + filename + caption -->
                                  <!-- Jika bertipe dokumen, tampilkan tulisan unsupported content message tanpa data berkas -->
                                  <div v-if="data.type === 'document'"
                                       class="media-card p-3"
                                       style="min-width:220px; max-width:300px; cursor: default;">
                                    <div class="text-break" style="font-size: 13px; text-align: left; font-style: italic;">
                                      unsupported content message
                                    </div>
                                  </div>
                                  <div v-if="false"
                                       class="media-card"
                                       @click.prevent="setDataModal(data, index)">
                                    <div class="d-flex align-items-center p-3" style="min-width:220px; max-width:300px;">
                                      <i :class="[
                                        data.documentMimeType && data.documentMimeType.includes('pdf') ? 'ri-file-pdf-line' :
                                        data.documentMimeType && data.documentMimeType.includes('word') ? 'ri-file-word-line' :
                                        (data.documentMimeType && data.documentMimeType.includes('excel')) || (data.documentMimeType && data.documentMimeType.includes('spreadsheet')) ? 'ri-file-excel-line' :
                                        'ri-file-line'
                                      ]" style="font-size:36px; color:#e74c3c; flex-shrink:0;"></i>
                                      <div class="ms-2" style="overflow:hidden; flex:1;">
                                        <div class="fw-semibold text-truncate" style="max-width:190px; font-size:13px;">{{ data.fileName || 'Document' }}</div>
                                        <small class="text-muted">{{ data.documentMimeType ? data.documentMimeType.split('/')[1] || data.documentMimeType : 'file' }}</small>
                                      </div>
                                      <i v-if="data.downloadImage" class="ri-download-cloud-2-line ms-2 text-muted" style="font-size:20px; flex-shrink:0;"></i>
                                      <i v-else class="ri-download-line ms-2 text-success" style="font-size:20px; flex-shrink:0;"></i>
                                    </div>
                                    <div v-if="data.message" class="media-card-caption" style="border-top:1px solid rgba(0,0,0,0.08);">
                                      <span v-html="data.message" class="text-break"></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- Left side actions (their messages) -->
                            <div class="message-img-link" v-if="data.align !== 'right'">
                              <ul class="list-inline mb-0">
                                <li class="list-inline-item dropdown" v-if="data.type !== 'revoked' && !data.isRevoked">
                                  <a class="dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" 
                                     aria-haspopup="true" aria-expanded="false">
                                    <i class="ri-more-fill"></i>
                                  </a>
                                  <div class="dropdown-menu">
                                    <a class="dropdown-item reply-message" href="#" @click.prevent="
                                      replyMessages(
                                        data.message,
                                        data.align === 'right' ? 'You' : username,
                                        data.id || data.message_id || data.chatID,
                                        data.hasMedia,
                                        data
                                      )
                                    ">
                                      <i class="ri-reply-line me-2 text-muted align-bottom"></i>Reply
                                    </a>
                                    <a class="dropdown-item" href="#">
                                      <i class="ri-share-line me-2 text-muted align-bottom"></i>Forward
                                    </a>
                                    <a class="dropdown-item" href="#" @click.prevent="showDeleteModal(data)">
                                      <i class="ri-delete-bin-5-line me-2 text-muted align-bottom"></i>Delete
                                    </a>
                                    <a class="dropdown-item" href="#" v-if="data.downloadImage" 
                                       @click.prevent="downloadMedia(index)">
                                      <i class="ri-download-cloud-2-line me-2 text-muted align-bottom"></i>Download
                                    </a>
                                  </div>
                                </li>
                              </ul>
                              <div class="conversation-name">
                                <small class="text-muted time">{{ chatConvertationTime(data.time) }}</small>
                                <small class="text-muted time" v-if="data.agent && data.agent.Name">
                                  by. {{ data.agent.Name }}•{{ data.agent.Role.Title }}
                                </small>
                              </div>
                            </div>
                          </div>

                          <!-- Message without Media -->
                          <div :class="['ctext-wrap', (data.type === 'revoked' || data.isRevoked) ? 'revoked-row' : '']" v-if="(data.message && !data.hasMedia) || data.type === 'revoked' || data.isRevoked">
                            <div class="ctext-wrap-content">
                              <!-- Deleted Message -->
                              <div v-if="data.type === 'revoked' || data.isRevoked" :class="['fst-italic d-flex align-items-center', (data.fromMe || data.align === 'right') ? 'revoked-text' : 'text-muted']">
                                <i class="ri-forbid-line me-2"></i>
                                <span v-if="data.fromMe || data.align === 'right'">Anda menghapus pesan ini</span>
                                <span v-else>Pesan ini dihapus</span>
                              </div>

                              <!-- Normal Message with Quote -->
                              <template v-else>
                                <div v-if="data.quotedMsg" class="replymessage-block mb-0 d-flex align-items-start">
                                  <div class="flex-grow-1">
                                    <h5 class="" :class="{ 'text-primary': data.align === 'right' }">
                                      {{ data.quotedParticipant ? data.quotedParticipant.name : 'Unknown' }}
                                    </h5>
                                    <div v-if="data.quotedMsg.type === 'image' || ('deprecatedMms3Url' in data.quotedMsg && data.quotedMsg.type !== 'sticker')">
                                       <i class="ri-camera-fill me-1"></i> Foto <span v-if="data.quotedMsg.body && !data.quotedMsg.body.startsWith('data:')" class="text-muted">- {{ data.quotedMsg.body }}</span>
                                     </div>
                                     <!-- Jika bertipe stiker -->
                                     <div v-else-if="data.quotedMsg.type === 'sticker'">Sticker</div>
                                     <!-- Jika bertipe video -->
                                     <div v-else-if="data.quotedMsg.type === 'video'">
                                       <i class="ri-video-fill me-1"></i> Video <span v-if="data.quotedMsg.body" class="text-muted">- {{ data.quotedMsg.body }}</span>
                                     </div>
                                     <!-- Jika bertipe dokumen -->
                                     <div v-else-if="data.quotedMsg.type === 'document'">
                                        <i class="ri-file-text-fill me-1"></i> unsupported content message
                                      </div>
                                      <div v-else-if="false">
                                       <i class="ri-file-text-fill me-1"></i> Dokumen <span v-if="data.quotedMsg.body" class="text-muted">- {{ data.quotedMsg.body }}</span>
                                     </div>
                                     <!-- Jika bertipe audio/ptt -->
                                     <div v-else-if="data.quotedMsg.type === 'audio' || data.quotedMsg.type === 'ptt'">
                                       <i class="ri-volume-up-fill me-1"></i> Audio
                                     </div>
                                     <!-- Jika bertipe teks standar -->
                                     <div v-else-if="data.quotedMsg.type === 'chat' && !('deprecatedMms3Url' in data.quotedMsg)">
                                       <p class="mb-0">{{ data.quotedMsg.body }}</p>
                                     </div>
                                  </div>
                                  <img v-if="'deprecatedMms3Url' in data.quotedMsg" :src="data.quotedMsg.body" alt="" 
                                       style="height: 50px; width: auto; margin-left: 20px;" />
                                </div>
                                <div v-html="data.message" :class="{ 'mt-2': data.quotedMsg }" 
                                     class="text-break" style="max-width: 300px; text-align: left"></div>
                              </template>
                            </div>

                            <!-- Dropdown menu -->
                            <div class="dropdown align-self-start message-box-drop" v-if="data.type !== 'revoked' && !data.isRevoked">
                              <a class="dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" 
                                 aria-haspopup="true" aria-expanded="false">
                                <i class="ri-more-2-fill"></i>
                              </a>
                              <div class="dropdown-menu">
                                <a class="dropdown-item reply-message" href="#" @click.prevent="
                                  replyMessages(
                                    data.message,
                                    data.align === 'right' ? 'You' : username,
                                    data.id || data.message_id || data.chatID,
                                    data.hasMedia,
                                    data
                                  )
                                ">
                                  <i class="ri-reply-line me-2 text-muted align-bottom"></i>Reply
                                </a>
                                <a class="dropdown-item" href="#" @click.prevent="showDeleteModal(data)">
                                  <i class="ri-delete-bin-5-line me-2 text-muted align-bottom"></i>Delete
                                </a>
                                <a v-if="data.ack === 4" class="dropdown-item" href="#" @click="resendMessage(data)">
                                  <i class="ri-send-plane-fill me-2 text-muted align-bottom"></i>Resend
                                </a>
                              </div>
                            </div>

                            <div class="conversation-name">
                              <small class="text-muted time">{{ chatConvertationTime(data.time) }}</small>
                              <small class="text-muted time" v-if="data.agent && data.agent.Name">
                                by. {{ data.agent.Name }}•{{ data.agent.Role ? data.agent.Role.Title : '' }}
                              </small>
                              <span class="check-message-icon">
                                <i class="align-bottom" :class="[
                                  { 'ri-check-double-line text-info': data.ack === 4 && data.fromMe },
                                  { 'ri-time-line text-muted': data.ack === 0 && data.fromMe },
                                  { 'ri-check-double-line text-info': data.ack === 3 && data.fromMe },
                                  { 'ri-check-line': data.ack === 1 && data.fromMe },
                                  { 'ri-check-double-line': data.ack === 2 && data.fromMe },
                                ]"></i>
                              </span>
                            </div>
                          </div>

                        </div>
                      </div>
                    </li>
                  </ul>
                </div>

                <div class="alert alert-warning alert-dismissible copyclipboard-alert px-4 fade show" 
                     id="copyClipBoard" role="alert">
                  Message copied
                </div>
              </div>
              <!-- end chat-conversation -->

              <!-- ========================================
                   CHAT INPUT SECTION
                   ======================================== -->
              <div class="chat-input-section p-3 p-lg-4">
                <form @submit.prevent="formSubmit">
                  <div class="row g-0 align-items-center">
                    <div class="col-auto">
                      <div class="chat-input-links me-2">
                        <div class="d-flex align-items-center">
                          <!-- Emoji picker -->
                          <div class="dropup">
                            <button type="button" class="btn btn-link text-decoration-none emoji-btn" 
                                    id="emoji-btn" data-bs-toggle="dropdown" 
                                    aria-haspopup="true" aria-expanded="false">
                              <i class="bx bx-smile align-middle"></i>
                            </button>
                            <div class="dropdown-menu" style="background: none; height: auto">
                              <EmojiPicker :native="true" :display-recent="false" @select="selectEmoji" />
                            </div>
                          </div>

                          <!-- Attachment picker -->
                          <div class="dropup">
                            <button type="button" class="btn btn-link text-decoration-none emoji-btn" 
                                    data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              <i class="bx bx-paperclip align-middle"></i>
                            </button>
                            <div class="dropdown-menu">
                              <button type="button" class="dropdown-item" @click="imageSend">
                                <i class="ri-image-line me-2"></i>Images or Video
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col">
                      <div class="chat-input-feedback">
                        Please Enter a Message
                      </div>
                      <input type="text" 
                             v-model="form.message" 
                             class="form-control chat-input bg-light border-light" 
                             :placeholder="chatMessagesData.length === 0 ? 'Start the conversation...' : 'Enter Message...'" 
                             id="chatInput" />
                    </div>
                    <div class="col-auto">
                      <div class="chat-input-links ms-2">
                        <div class="links-list-item">
                          <button id="btnSendMessage" 
                                  type="submit" 
                                  class="btn btn-xmarks2 chat-send waves-effect waves-light shadow">
                            <i class="ri-send-plane-2-fill align-bottom"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <!-- Reply Card -->
              <div class="replyCard" :class="{ show: this.messagesReply }">
                <div class="card mb-0">
                  <div class="card-body py-3">
                    <div class="replymessage-block mb-0 d-flex align-items-start">
                      <div class="flex-grow-1">
                        <h5 class="conversation-name">{{ nameReply }}</h5>
                        <p class="mb-0" v-if="!isMediaReply">{{ pesanReply }}</p>
                        <p class="text-truncate text-weight" style="font-size: 10px; margin: 0">
                          <img v-if="isSticker" :src="previewImages" alt="" 
                               style="height: 40px; width: auto; margin-right: 10px;" />
                        </p>
                        <p class="text-truncate text-weight" style="font-size: 10px; margin: 0" 
                           v-if="isMediaReply && !isSticker">
                          <i class="ri-image-line"></i> Photo
                        </p>
                      </div>
                      <div class="flex-shrink-0">
                        <img v-if="isMediaReply && !isSticker" :src="previewImages" alt="" 
                             style="height: 40px; width: auto; margin-right: 10px" />
                        <button type="button" id="close_toggle" @click="closeReply" 
                                class="btn btn-sm mt-n2 me-n3">
                          <i class="bx bx-x align-middle"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- DEFAULT VIEW - When no conversation is opened -->
      <div v-if="!phoneNumber || !username" id="conv-0" class="user-chat w-100 overflow-hidden">
        <div class="chat-content d-lg-flex">
          <div class="w-100 overflow-hidden position-relative d-flex align-items-center justify-content-center" 
               style="min-height: calc(100vh - 150px);">
            <div class="text-center p-4">
              <img src="../../assets/images/widget-img.png" 
                   style="max-width: 500px; width: 80%;" 
                   class="img-fluid" 
                   alt="Select a conversation" />
              <h5 class="mt-4 text-muted">Select a conversation to start messaging</h5>
              <p class="text-muted">Choose a contact from the list to view messages</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end chat-wrapper -->

    <!-- Modal for open images -->
    <div class="modal fade zoomIn" tabindex="-1" aria-labelledby="zoomInModalLabel" style="display: none"
      aria-hidden="true" id="zoomInModal">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content text-center" style="width: auto">
          <div class="modal-header">
            <h5 class="modal-title" id="zoomInModalLabel">
              {{ captionModal }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <img class="img-fluid align-item-center" :src="this.imageModal" style="min-width: 250px; margin: auto" />
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <!-- end modals -->

      <!-- Modal for video playback -->
      <div v-if="showVideoModal" class="video-modal-overlay" @click="closeVideoModal">
        <div class="video-modal-container" @click.stop>
          <div style="position:absolute; right:8px; top:8px; z-index:3; display:flex; gap:8px; align-items:center;">
            <button type="button" class="btn btn-sm btn-light" @click.stop="downloadVideo" title="Download video">
              <i class="ri-download-line"></i> Download
            </button>
            <button type="button" class="btn-close" @click="closeVideoModal" aria-label="Close"></button>
          </div>
          <video ref="videoPlayer" :key="videoModalUrl" :src="videoModalUrl" controls playsinline style="max-width:900px; width:90vw; max-height:80vh; background:#000; display:block;" :poster="previewImages || ''"></video>
        </div>
      </div>

    <!-- Lightbox images -->
    <FsLightbox 
      :toggler="toggler"
      type="image"
      :sources="[sourcesImages]"
    />
    <!-- End Lightbox -->

    <!-- canvas -->
    <div class="offcanvas offcanvas-end border-0" tabindex="-1" id="userProfileCanvasExample">
      <!--end offcanvas-header-->
      <div class="offcanvas-body profile-offcanvas p-0">
        <div class="team-cover">
          <img src="@/assets/images/small/img-9.jpg" alt="" class="img-fluid" />
        </div>
        <div class="p-1 pb-4 pt-0">
          <div class="team-settings">
            <div class="row g-0">
              <div class="col">
                <div class="btn nav-btn">
                  <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"
                    id="btnCanvasClose"></button>
                </div>
              </div>
            </div>
          </div>
          <!--end col-->
        </div>
        <div class="p-3 text-center">
          <img :src="profile
              ? profile
              : require('@/assets/images/users/user-dummy-img.jpg')
            " alt="" class="avatar-lg img-thumbnail rounded-circle mx-auto profile-img" />
          <div class="mt-3">
            <h5 class="fs-16 mb-1">
              <a href="javascript:void(0);" class="link-primary username">{{
                username
              }}</a>
            </h5>
            <p class="text-muted">
              <i class="ri-checkbox-blank-circle-fill me-1 align-bottom" :class="[
                    { 'text-info': this.userStatus === 'assigned' },
                    { 'text-danger': this.userStatus === 'unassigned' },
                    { 'text-success': this.userStatus === 'resolved' },
                  ]"></i>{{ this.userStatus }}
            </p>
          </div>
        </div>

        <div class="border-top border-top-dashed p-3">
          <h5 class="fs-15 mb-3">Personal Details</h5>
          <div class="mb-3">
            <p class="text-muted text-uppercase fw-medium fs-12 mb-1">Number</p>
            <h6>{{ phoneNumber }}</h6>
          </div>
          <div class="row">
            <div class="mb-3 col-6">
              <p class="text-muted text-uppercase fw-medium fs-12 mb-1">
                Create
              </p>
              <h6>{{ create }}</h6>
            </div>
            <div class="col-6">
              <p class="text-muted text-uppercase fw-medium fs-12 mb-1">
                LastEdit
              </p>
              <h6 class="mb-0">{{ lastEdit }}</h6>
            </div>
          </div>
        </div>

        <div class="border-top border-top-dashed p-3">
          <h5 class="fs-15 mb-3">Utils</h5>
          <label>note</label>
          <textarea v-model="note" class="form-control mb-3" id="notes" rows="3" placeholder="note"
            style="height: 111px"></textarea>
          <label>tag</label>
          <Multiselect v-model="this.tagValue" mode="tags" :close-on-select="false" :searchable="true"
            :create-option="true" :options="tagoption" />
        </div>

        <div class="border-top border-top-dashed p-3">
          <h5 class="fs-15 mb-3">Agent Assigned</h5>
          <div class="vstack gap-2">
            <div class="border rounded border-dashed p-2" v-for="(agent, index) in agentHandle" :key="index">
              <div class="d-flex align-items-center">
                <div class="flex-shrink-0 me-3">
                  <div class="avatar-xs">
                    <div class="avatar-title bg-light text-secondary rounded fs-20 shadow">
                      <img :src="agent.avatar" alt="" class="avatar-sm rounded-circle" />
                    </div>
                  </div>
                </div>
                <div class="flex-grow-1 overflow-hidden">
                  <h5 class="fs-13 mb-1">
                    <a href="#" class="text-body text-truncate d-block">{{
                      agent.Name
                    }}</a>
                  </h5>
                  <div class="text-muted">Agent</div>
                </div>
                <div class="flex-shrink-0 ms-2" v-if="user.Role.Code === 'principal'">
                  <div class="d-flex gap-1">
                    <button type="button" class="btn btn-icon text-danger btn-sm fs-18 shadow-none"
                      @click="unassign(2, agent.ID)">
                      <i class="ri-delete-bin-6-line"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-center mt-2">
              <div class="row">
                <div :class="[
                  { 'col-6': userStatus === 'resolved' },
                  { 'col-12': userStatus !== 'resolved' }
                ]">
                  <button @click="saveEdit" type="button" class="btn btn-info col-12">
                    Saved <i class="ri-save-3-fill align-bottom"></i>
                  </button>
                </div>
                <div class="col-6" v-if="userStatus === 'resolved'">
                  <button type="button" class="btn btn-warning col-12" @click="resolveCustomer(1)">
                    Unresolved <i class="ri-close-line align-bottom"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end offcanvas-body-->
    </div>
    <!-- end canvas -->
  </Layout>
</template>
